import React from 'react';
import PropTypes from 'prop-types';
import Moment from 'moment';
import L from 'leaflet';
import 'leaflet-draw';
import Calls from '../../components/util/calls';

import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import FormLabel from '@material-ui/core/FormLabel';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from '@material-ui/core/Checkbox';
import ListItemText from '@material-ui/core/ListItemText';
import CircularProgress from '@material-ui/core/CircularProgress';
import Modal from '@material-ui/core/Modal';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';

import AddIcon from '@material-ui/icons/Add';
import CloseIcon from '@material-ui/icons/Close';
import SaveIcon from '@material-ui/icons/Save';
import DescriptionIcon from '@material-ui/icons/Description';
import EditIcon from '@material-ui/icons/Edit';
import SearchIcon from '@material-ui/icons/Search';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import ArrowLeftIcon from '@material-ui/icons/ArrowLeft';
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import EmailIcon from '@material-ui/icons/Email';
import VisibilityIcon from '@material-ui/icons/Visibility';
import CancelIcon from '@material-ui/icons/Cancel';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import RefreshIcon from '@material-ui/icons/Refresh';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';

import img7 from './../../assets/images/marker/waypoint/flag-green.png';
import img8 from './../../assets/images/marker/waypoint/flag-red.png';

import Config from '../../constants/appConfig';
import MaterialIcon from './../../components/MaterialIcon';
import tools from '../../components/util/tools';
import geo from '../../components/util/geo';
import { notification } from 'antd';
import { useParams } from "react-router";

import SignaturePad from 'react-signature-pad';
import EditProperty from '../client/property/Edit';

import Units from '../../components/util/units';
const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(),
    marginRight: theme.spacing(),
  }
});

const maxCaracteres = 120;

const fieldLimits = {
  property: 120,
  city: 120,
  address: 45,
  culture: 45,
  area: 18,
  volume: 18,
  temperature: 20,
  humidity: 20,
  wind_speed: 20,
  flight_height: 16,
  applicationRange: 16,
  plane: 255,
  pilot: 255,
  canac: 120,
  uf: 45,
  polygonName: 120,
  executor: 45,
  executor_crea_cpf: 30,
  agricultural_engineer: 45,
  engineer_crea_cpf: 30,
  responsibleTechnician: 45,
  responsibleTechnician_crea_cfta: 30
};

class Edit extends React.Component {
  state = {
    id: this.props.id,
    id_equipment: '',
    editData: true,
    isReportReady: false,
    openModal: false,
    jobReportId: null,
    job: {},
    validJob: '',
    preJob: '',
    jobReport: {},
    jobProperty: [],
    list_properties: [],
    planes: [],
    pilots: [],
    selectedPlaneIds: [],
    selectedPilotIds: [],
    showCustomPlane: false,
    showCustomPilot: false,
    selectedPropertyId: '',
    selectedPropertyIds: [],
    showCustomProperty: false,
    showPropertyForm: false,
    propertyModalKey: 0,
    contractor: '',
    cpf_cnpj: '',
    property: '',
    city: '',
    address: '',
    uf: '',
    areaLocation: null,
    culture: '',
    area: '',
    volume: '',
    startDate: '',
    endDate: '',
    time_voo: '',
    application_period: '',
    type_service: {
      insecticide: false,
      herbicide: false,
      fungicide: false,
      seeding: false,
      fertilizing: false,
      maturator: false,
    },
    temperature: '',
    humidity: '',
    wind_speed: '',
    flight_height: '',
    selectedService: '',
    applicationRange: '',
    plane: '',
    pilot: '',
    canac: '',
    equipment: {
      type: '',
      name: '',
      details: {
        core: '',
        disco: '',
        angulo: '',
        ponta: '',
        anguloPa: '',
        malha: '',
        vru: '',
        orificio: '',
      }
    },
    product: [],
    technicians: [],
    executor: '',
    executor_crea_cpf: '',
    agronomists: [],
    agricultural_engineer: '',
    engineer_crea_cpf: '',
    responsibleTechnician: '',
    responsibleTechnician_crea_cfta: '',
    responsibleTechnicianEmail: '',
    responsibleTechnicianSignature: '',
    longitude: '',
    latitude: '',
    flight_direction: [],
    wind_direction: '',
    runway_latitude: '',
    runway_longitude: '',
    runwayDistance: '',
    polygonName: '',
    id_client: '',
    id_pilot: '',
    id_property: '',
    id_technician: '',
    id_agronomist: '',
    jobReportIdjob: '',
    cultureData: [],
    list_all_prod: [],
    filteredProducts: [],
    currentPage: 1,
    itemsPerPage: 21,
    applicationConditions: {
      data: '',
      dataFim: '',
      temperaturaMatutino: false,
      temperaturaVespertino: false,
      temperaturaInicialMatutino: '',
      temperaturaFinalMatutino: '',
      temperaturaInicialVespertino: '',
      temperaturaFinalVespertino: '',
      umidadeMatutino: false,
      umidadeVespertino: false,
      umidadeInicialMatutino: '',
      umidadeFinalMatutino: '',
      umidadeInicialVespertino: '',
      umidadeFinalVespertino: '',
      velocidadeMatutino: false,
      velocidadeVespertino: false,
      velocidadeInicialMatutino: '',
      velocidadeFinalMatutino: '',
      velocidadeInicialVespertino: '',
      velocidadeFinalVespertino: '',
      horarioMatutino: false,
      horarioVespertino: false,
      horarioInicialMatutino: '',
      horarioFinalMatutino: '',
      horarioInicialVespertino: '',
      horarioFinalVespertino: '',
    },
    prescriptionDate: new Date().toISOString().split('T')[0],
    prescriptionNumber: '',
    registrationNumber: '',
    polygon: '',
    // polygon: {},
    title: '',
    observations: '',
    areaData: '',
    contractorEmail: '',
    pilotEmail: '',
    engineerEmail: '',
    executorEmail: '',
    fileSigned: '',
    documentGuid: '',
    documentId: '',
    documentTitle: '',
    documentData: {},
    reportGenerated: false,
    createDocument: '',
    arrFuel: [],
    percSize: 100,
    applicationGuide: false,
    logo: false,
    path: true,
    map: true,
    application: true,
    autoMapaConfig: null,
    openReportConfigDialog: false,
    openPreReportConfigDialog: false,
    clients: [],
    propertyPreOrcamento: '',
    showCustomContractor: false,
    contractorSelect: '',
    isSigning: false,
    imageURL: '',
    hasSignature: false,
    isOnlyServiceOrder: false,
    filter: '',
    newProductModalOpen: false,
    newProductName: '',
    newProductSaving: false,
    initialLoading: true,

  };

  signaturePadRef = React.createRef();

  componentDidMount() {
    this.getProd()
      .then(() => this.getProdCustom())
      .then(() => {
        const selectedProductIds = Array.isArray(this.state.product)
          ? this.state.product.map(p => p.id)
          : [];

        const sortedProducts = Array.isArray(this.state.list_all_prod)
          ? this.state.list_all_prod.sort((a, b) => {
            const aSelected = selectedProductIds.includes(a.id);
            const bSelected = selectedProductIds.includes(b.id);
            return aSelected === bSelected ? 0 : aSelected ? -1 : 1;
          })
          : [];

        this.setState({ filteredProducts: sortedProducts });
        this.readJob();
        this.readAllReportsMapa();
      })
      .catch((error) => {
        console.error(error);
        this.readJob();
        this.readAllReportsMapa();
      });

    this.readTechnician();
    this.readAgronomist();
    this.loadCultures();
    this.initialize();
    this.readCustomers();
    this.readPlanes();
    this.readPilots();
    this.readProfileAutoMapa();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.jobReportId && !prevState.jobReportId) {
      this.setState({ editData: false, isReportReady: true });
    }
  }

  componentWillUnmount() {
    // fix Warning: Can't perform a React state update on an unmounted component
    this.setState = (state, callback) => {
      return;
    };
  };

  getContractorForSubmit = () => {
    const contractorSelect = (this.state && this.state.contractorSelect) || '';
    const contractor = (this.state && this.state.contractor) || '';

    return contractorSelect === 'noRegister' ? contractor : contractorSelect;
  };

  normalizeDocumentValue = (value) => {
    if (value === null || value === undefined) return '';
    const normalized = String(value).trim();
    if (!normalized || normalized.toLowerCase() === 'null' || normalized.toLowerCase() === 'undefined') return '';
    return normalized;
  };

  isValidEmail = (email) => {
    const normalized = this.normalizeDocumentValue(email);
    if (!normalized) return false;

    const emails = normalized.split(',').map(item => item.trim()).filter(Boolean);
    if (!emails.length) return false;

    return emails.every(item => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(item));
  };

  isInvalidEmail = (email) => {
    const normalized = this.normalizeDocumentValue(email);
    return !!normalized && !this.isValidEmail(normalized);
  };

  getInvalidEmailMessage = () => {
    return this.props.res.ERRO_EMAIL;
  };

  getInvalidEmailNotification = () => {
    return this.props.res.EMAIL_INVALIDO_MSG;
  };

  getInvalidFormEmails = () => {
    const emails = [
      { field: 'contractorEmail', value: this.state.contractorEmail },
      { field: 'pilotEmail', value: this.state.pilotEmail },
      { field: 'engineerEmail', value: this.state.engineerEmail },
      { field: 'executorEmail', value: this.state.executorEmail },
      { field: 'responsibleTechnicianEmail', value: this.state.responsibleTechnicianEmail }
    ];

    return emails.filter(item => this.isInvalidEmail(item.value));
  };

  getInvalidSignatureEmails = () => {
    const jobReport = this.state.jobReport || {};
    const emails = [
      { field: 'contractorEmail', value: jobReport.contractorEmail || this.state.contractorEmail },
      { field: 'pilotEmail', value: jobReport.pilotEmail || this.state.pilotEmail },
      { field: 'engineerEmail', value: jobReport.engineerEmail || this.state.engineerEmail },
      { field: 'executorEmail', value: jobReport.executorEmail || this.state.executorEmail },
      { field: 'responsibleTechnicianEmail', value: jobReport.responsibleTechnicianEmail || this.state.responsibleTechnicianEmail }
    ];

    return emails.filter(item => this.isInvalidEmail(item.value) || !this.normalizeDocumentValue(item.value));
  };

  readJob = () => {
    const parseJSON = (raw, fallback) => {
      try { return JSON.parse(raw); } catch (_) { return fallback; }
    };

    const safeJson = (raw, fallback) => {
      try {
        if (raw == null) return fallback;
        if (typeof raw === 'object') return raw;
        const s = String(raw).trim();
        if (!s) return fallback;
        return JSON.parse(s);
      } catch { return fallback; }
    };

    const toAgroFlags = (raw) => {
      const obj = safeJson(raw, raw);
      const base = (obj && typeof obj === 'object') ? obj : {};
      return {
        insecticide: !!base.insecticide,
        herbicide: !!base.herbicide,
        fungicide: !!base.fungicide,
        seeding: !!base.seeding,
        fertilizing: !!base.fertilizing,
        maturator: !!base.maturator
      };
    };

    const normalizeServiceType = (v) => {
      const allowed = new Set(['AplicacaoAgrotoxico', 'AplicacaoBioinsumo', 'AplicacaoFertilizante', 'Semeadura', 'Maturador', 'AplicacaoAdjuvante']);
      const s = (v == null) ? '' : String(v).trim();
      return allowed.has(s) ? s : '';
    };

    const apiUrl = `${Config.server}/job_detail/${this.state.id}`;
    const options = { method: 'GET', headers: { 'Authorization': localStorage.getItem('access-token-jwt') } };

    return fetch(apiUrl, options)
      .then((res) => { if (res.status !== 200) throw res; else return res.json(); })
      .then((jobDetail) => {
        if (jobDetail && jobDetail.id_task) this.checkTask(jobDetail.id_task);

        const serviceOrderList = (jobDetail && Array.isArray(jobDetail.service_order)) ? jobDetail.service_order : [];
        const serviceOrderSafe = serviceOrderList.length ? serviceOrderList[0] : null;

        const getServiceOrderValues = (field) => {
          const values = [];

          serviceOrderList.forEach((item) => {
            if (!item || item[field] === null || item[field] === undefined) return;

            let rawValues = item[field];

            if (typeof rawValues === 'string') {
              const text = rawValues.trim();
              if (!text) return;

              try {
                const parsed = JSON.parse(text);
                rawValues = Array.isArray(parsed) ? parsed : [text];
              } catch (_) {
                rawValues = text.split(',');
              }
            }

            if (!Array.isArray(rawValues)) rawValues = [rawValues];

            rawValues.forEach((value) => {
              const normalized = value === null || value === undefined ? '' : String(value).trim();
              if (normalized && !values.includes(normalized)) values.push(normalized);
            });
          });

          return values.join(', ');
        };

        const serviceOrderPlanes = getServiceOrderValues('plane');
        const serviceOrderPilots = getServiceOrderValues('pilot');
        const serviceOrderPilotCanacs = getServiceOrderValues('pilot_canac');
        const serviceOrderPilotEmails = getServiceOrderValues('pilot_email');

        const soAreas = (serviceOrderSafe && Array.isArray(serviceOrderSafe.areas)) ? serviceOrderSafe.areas : [];
        const runwayPoints = soAreas.filter(a => a && a.type === 'point');
        const runwayLatPre = (runwayPoints.length > 0 && runwayPoints[0] && runwayPoints[0].lat != null) ? Number(runwayPoints[0].lat) : null;
        const runwayLngPre = (runwayPoints.length > 0 && runwayPoints[0] && runwayPoints[0].lng != null) ? Number(runwayPoints[0].lng) : null;

        const areaPoints = soAreas.filter(a => a && a.type === 'area');
        const areaLatPre = (areaPoints.length > 0 && areaPoints[0] && areaPoints[0].lat != null) ? Number(areaPoints[0].lat) : null;
        const areaLngPre = (areaPoints.length > 0 && areaPoints[0] && areaPoints[0].lng != null) ? Number(areaPoints[0].lng) : null;

        const latRefuel = (jobDetail && jobDetail.execucao && jobDetail.execucao.lat_refuel != null) ? jobDetail.execucao.lat_refuel
          : (jobDetail && jobDetail.planejamento && jobDetail.planejamento.lat_refuel != null) ? jobDetail.planejamento.lat_refuel
            : areaLatPre;

        const lngRefuel = (jobDetail && jobDetail.execucao && jobDetail.execucao.lng_refuel != null) ? jobDetail.execucao.lng_refuel
          : (jobDetail && jobDetail.planejamento && jobDetail.planejamento.lng_refuel != null) ? jobDetail.planejamento.lng_refuel
            : areaLngPre;

        const applicationLatitude = (jobDetail && jobDetail.execucao && jobDetail.execucao.latitude != null) ? jobDetail.execucao.latitude
          : (jobDetail && jobDetail.planejamento && jobDetail.planejamento.latitude != null) ? jobDetail.planejamento.latitude
            : runwayLatPre;

        const applicationLongitude = (jobDetail && jobDetail.execucao && jobDetail.execucao.longitude != null) ? jobDetail.execucao.longitude
          : (jobDetail && jobDetail.planejamento && jobDetail.planejamento.longitude != null) ? jobDetail.planejamento.longitude
            : runwayLngPre;

        const calculateDistance = (lat1, lng1, lat2, lng2) => {
          if (!Number.isFinite(lat1) || !Number.isFinite(lng1) || !Number.isFinite(lat2) || !Number.isFinite(lng2)) return null;
          const toRadians = (degree) => degree * (Math.PI / 180);
          const earthRadius = 6371000;
          const dLat = toRadians(lat2 - lat1);
          const dLng = toRadians(lng2 - lng1);
          const a = Math.sin(dLat / 2) ** 2 + Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) * Math.sin(dLng / 2) ** 2;
          const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
          return earthRadius * c;
        };

        const runwayDistance = calculateDistance(latRefuel, lngRefuel, applicationLatitude, applicationLongitude);

        const equipmentPlanArr = (jobDetail && jobDetail.planejamento && jobDetail.planejamento.planningEquipment) ? parseJSON(jobDetail.planejamento.planningEquipment, []) : [];
        const tempPlanArr = (jobDetail && jobDetail.planejamento && jobDetail.planejamento.planningTempMin) ? parseJSON(jobDetail.planejamento.planningTempMin, []) : [];
        const humidityPlanArr = (jobDetail && jobDetail.planejamento && jobDetail.planejamento.planningHumidityMax) ? parseJSON(jobDetail.planejamento.planningHumidityMax, []) : [];
        const culturePlanArr = (jobDetail && jobDetail.planejamento && jobDetail.planejamento.planningAgricultureCulture) ? parseJSON(jobDetail.planejamento.planningAgricultureCulture, []) : [];
        const windSpeedPlanArr = (jobDetail && jobDetail.planejamento && jobDetail.planejamento.planningWindSpeed) ? parseJSON(jobDetail.planejamento.planningWindSpeed, []) : [];
        const applicationPeriodArr = (jobDetail && jobDetail.planejamento && jobDetail.planejamento.planningApplication_period) ? parseJSON(jobDetail.planejamento.planningApplication_period, []) : [];
        const selectedServicePlanArr = (jobDetail && jobDetail.planejamento && jobDetail.planejamento.planningSelectedService) ? parseJSON(jobDetail.planejamento.planningSelectedService, []) : [];

        const serviceMappingPlanning = { Inseticida: 'insecticide', Herbicida: 'herbicide', Fungicida: 'fungicide', Semeadura: 'seeding', Adubação: 'fertilizing', Maturador: 'maturator' };
        const serviceMappingPreorcamento = { insecticide: 'insecticide', herbicide: 'herbicide', fungicide: 'fungicide', seeding: 'seeding', fertilizing: 'fertilizing', maturator: 'maturator' };

        const agroFlags = serviceOrderSafe ? toAgroFlags(serviceOrderSafe.agro_class) : { insecticide: false, herbicide: false, fungicide: false, seeding: false, fertilizing: false, maturator: false };
        const selectedServiceNorm = serviceOrderSafe ? normalizeServiceType(serviceOrderSafe.service_type) : '';
        const selectedServiceFinal = selectedServiceNorm || (Array.isArray(selectedServicePlanArr) && selectedServicePlanArr.length ? normalizeServiceType(selectedServicePlanArr[0]) : '');

        const applicationFlowAll = Number(
          (jobDetail && jobDetail.execucao && jobDetail.execucao.application_flow) ??
          (jobDetail && jobDetail.planejamento && jobDetail.planejamento.application_flow) ??
          (serviceOrderSafe && serviceOrderSafe.application_flow)
        );

        const parsePositiveNumber = (value) => {
          if (value === null || value === undefined || value === '') return null;
          const normalized = typeof value === 'string' ? value.trim().replace(',', '.') : value;
          const number = Number(normalized);
          return Number.isFinite(number) && number > 0 ? number : null;
        };

        const buildAreaVolumePair = () => {
          const execArea = parsePositiveNumber(jobDetail && jobDetail.execucao && jobDetail.execucao.spray);
          const execVolume = parsePositiveNumber(jobDetail && jobDetail.execucao && jobDetail.execucao.liters);

          if (execArea !== null) {
            if (execVolume !== null) {
              return { area: execArea, volume: execVolume };
            }

            const execApplicationFlow = [
              jobDetail && jobDetail.execucao && jobDetail.execucao.application_flow,
              jobDetail && jobDetail.planejamento && jobDetail.planejamento.application_flow,
              serviceOrderSafe && serviceOrderSafe.application_flow
            ]
              .map(parsePositiveNumber)
              .find(value => value !== null);

            if (execApplicationFlow !== undefined) {
              const calculatedVolume = Math.round(execArea * execApplicationFlow * 1000) / 1000;
              return { area: execArea, volume: calculatedVolume };
            }
          }

          const planningArea = parsePositiveNumber(jobDetail && jobDetail.planejamento && jobDetail.planejamento.spray);
          const planningVolume = parsePositiveNumber(jobDetail && jobDetail.planejamento && jobDetail.planejamento.liters);

          if (planningArea !== null && planningVolume !== null) {
            return { area: planningArea, volume: planningVolume };
          }

          const serviceOrderArea = parsePositiveNumber(serviceOrderSafe && serviceOrderSafe.area);
          const serviceOrderVolume = parsePositiveNumber(
            serviceOrderSafe && (serviceOrderSafe.liters ?? serviceOrderSafe.volume)
          );

          if (serviceOrderArea !== null && serviceOrderVolume !== null) {
            return { area: serviceOrderArea, volume: serviceOrderVolume };
          }

          return { area: '', volume: '' };
        };

        const areaVolumePair = buildAreaVolumePair();

        this.setState((prev) => ({
          type_service: { ...agroFlags, others: false },
          validJob: (jobDetail && (jobDetail.planejamento || jobDetail.execucao)) ? (jobDetail.planejamento || jobDetail.execucao) : prev.validJob,
          preJob: serviceOrderSafe ? serviceOrderSafe : prev.preJob
        }));

        const productArrayRaw = (jobDetail && jobDetail.planejamento && jobDetail.planejamento.planningProduct) ? parseJSON(jobDetail.planejamento.planningProduct, []) : [];
        const productsDict = parseJSON(productArrayRaw[0] || '{}', {});
        let updatedProducts = [];
        if (productsDict && typeof productsDict === 'object') {
          const allProducts = Array.isArray(this.state.list_all_prod) ? this.state.list_all_prod : [];
          for (const [name, details] of Object.entries(productsDict)) {
            const productItem = allProducts.find(prod => (prod && prod.name || '').trim().toLowerCase() === String(name || '').trim().toLowerCase());
            if (productItem) {
              updatedProducts.push({
                ...productItem,
                dosage: details && details.dosage,
                unit: details && details.unit,
                applicationRate: Number.isFinite(applicationFlowAll) ? applicationFlowAll : ''
              });
            }
          }
        }

        const coordinateLatitude = (jobDetail && jobDetail.execucao && jobDetail.execucao.latitude != null) ? jobDetail.execucao.latitude
          : (jobDetail && jobDetail.planejamento && jobDetail.planejamento.latitude != null) ? jobDetail.planejamento.latitude
            : null;

        const coordinateLongitude = (jobDetail && jobDetail.execucao && jobDetail.execucao.longitude != null) ? jobDetail.execucao.longitude
          : (jobDetail && jobDetail.planejamento && jobDetail.planejamento.longitude != null) ? jobDetail.planejamento.longitude
            : null;

        const lat_refuel = (jobDetail && jobDetail.execucao && jobDetail.execucao.lat_refuel != null) ? jobDetail.execucao.lat_refuel
          : (jobDetail && jobDetail.planejamento && jobDetail.planejamento.lat_refuel != null) ? jobDetail.planejamento.lat_refuel
            : null;

        const lng_refuel = (jobDetail && jobDetail.execucao && jobDetail.execucao.lng_refuel != null) ? jobDetail.execucao.lng_refuel
          : (jobDetail && jobDetail.planejamento && jobDetail.planejamento.lng_refuel != null) ? jobDetail.planejamento.lng_refuel
            : null;

        let jobProperty = Array.isArray(this.state.jobProperty) ? this.state.jobProperty.slice() : [];
        let tempProperty = { id_property: '', property_name: '' };

        if (jobDetail && jobDetail.planejamento && Array.isArray(jobDetail.planejamento.area)) {
          for (let i = 0; i < jobDetail.planejamento.area.length; i++) {
            const item = jobDetail.planejamento.area[i];
            if (item && item.property_name) {
              tempProperty.id_property = item.id_property;
              tempProperty.property_name = item.property_name;
              break;
            }
          }
          if (!jobProperty.some(a => tempProperty.property_name === a.property_name) && tempProperty.property_name) {
            jobProperty.push({ property_id: tempProperty.id_property, property_name: tempProperty.property_name });
          }
        }
        const selectedProperty = tempProperty.id_property ? tempProperty.property_name : 'Outro';

        const validData = (arr) => {
          for (let data of (arr || [])) {
            if (data && String(data).trim() !== '') return data;
          }
          return null;
        };
        const validCulture = validData(culturePlanArr);
        const validTemperature = validData(tempPlanArr);
        const validHumidity = validData(humidityPlanArr);

        const secondsToTimeFormat = (seconds) => {
          const date = new Date(0);
          date.setSeconds(Number(seconds) || 0);
          return date.toISOString().substr(11, 8);
        };

        const startDate = (jobDetail && jobDetail.execucao && jobDetail.execucao.startDate)
          ? tools.dateTimeZoneFormat(jobDetail.execucao.startDate, 'YYYY-MM-DDTHH:mm', this.props.res.timezone)
          : (jobDetail && jobDetail.planejamento && jobDetail.planejamento.startDate)
            ? tools.dateTimeZoneFormat(jobDetail.planejamento.startDate, 'YYYY-MM-DDTHH:mm', this.props.res.timezone)
            : (jobDetail && jobDetail.preorcamento && jobDetail.preorcamento.timetable_start)
              ? tools.dateTimeZoneFormat(jobDetail.preorcamento.timetable_start, 'YYYY-MM-DDTHH:mm', this.props.res.timezone)
              : '';

        this.setState({ startDate });

        const endDate = (jobDetail && jobDetail.execucao && jobDetail.execucao.endDate)
          ? tools.dateTimeZoneFormat(jobDetail.execucao.endDate, 'YYYY-MM-DDTHH:mm', this.props.res.timezone)
          : (jobDetail && jobDetail.planejamento && jobDetail.planejamento.endDate)
            ? tools.dateTimeZoneFormat(jobDetail.planejamento.endDate, 'YYYY-MM-DDTHH:mm', this.props.res.timezone)
            : (jobDetail && jobDetail.preorcamento && jobDetail.preorcamento.timetable_end)
              ? tools.dateTimeZoneFormat(jobDetail.preorcamento.timetable_end, 'YYYY-MM-DDTHH:mm', this.props.res.timezone)
              : '';

        this.setState({ endDate });

        const uniquePolygons = (jobDetail && jobDetail.planejamento && Array.isArray(jobDetail.planejamento.area) && jobDetail.planejamento.area.length > 0)
          ? jobDetail.planejamento.area.map(item => item && item.points).filter(Boolean)
          : (jobDetail && jobDetail.execucao && Array.isArray(jobDetail.execucao.area))
            ? jobDetail.execucao.area.map(item => item && item.points).filter(Boolean)
            : [];

        const formatABs = (ABs) => {
          const s = typeof ABs === 'string' ? ABs.trim() : '';
          if (!s || (s !== '' && s !== 'null' && s !== 'undefined' && s[0] !== '[' && s[0] !== '{')) return [];
          let points;
          try { points = JSON.parse(s); } catch (_) { return []; }
          if (!Array.isArray(points) || points.length < 2) return [];
          const angle = this.getAngleFromCoordinates(points[0][1], points[0][0], points[1][1], points[1][0]);
          const direction = this.getCardinalDirection(angle);
          return { startPoint: { lat: points[0][1], lng: points[0][0] }, endPoint: { lat: points[1][1], lng: points[1][0] }, direction };
        };

        const formattedABs = (jobDetail && jobDetail.planejamento && Array.isArray(jobDetail.planejamento.area) && jobDetail.planejamento.area.length > 0)
          ? jobDetail.planejamento.area.map(item => formatABs(item && item.ABs))
          : (jobDetail && jobDetail.execucao && Array.isArray(jobDetail.execucao.area))
            ? jobDetail.execucao.area.map(item => formatABs(item && item.ABs))
            : [];

        const flightDirections = formattedABs.map(ab => ab && ab.direction).filter(Boolean);

        let applicationRange = '';
        if (jobDetail && jobDetail.execucao && Array.isArray(jobDetail.execucao.area) && jobDetail.execucao.area.length > 0) {
          const temp = jobDetail.execucao.area.slice().sort((a, b) => Number(b && b.spray) - Number(a && a.spray))[0];
          applicationRange = temp && temp.applicationRange ? temp.applicationRange : '';
        } else if (jobDetail && jobDetail.planejamento && Array.isArray(jobDetail.planejamento.area) && jobDetail.planejamento.area.length > 0) {
          const temp = jobDetail.planejamento.area.slice().sort((a, b) => Number(b && b.spray) - Number(a && a.spray))[0];
          applicationRange = temp && temp.applicationRange ? temp.applicationRange : '';
        } else if (serviceOrderSafe && serviceOrderSafe.strip_width) {
          applicationRange = serviceOrderSafe.strip_width;
        }

        let flightHeight = '';
        if (jobDetail && jobDetail.execucao && Array.isArray(jobDetail.execucao.area) && jobDetail.execucao.area.length > 0) {
          const temp = jobDetail.execucao.area.slice().sort((a, b) => Number(b && b.spray) - Number(a && a.spray))[0];
          flightHeight = temp && temp.flightHeight ? temp.flightHeight : '';
        } else if (jobDetail && jobDetail.planejamento && Array.isArray(jobDetail.planejamento.area) && jobDetail.planejamento.area.length > 0) {
          const temp = jobDetail.planejamento.area.slice().sort((a, b) => Number(b && b.spray) - Number(a && a.spray))[0];
          flightHeight = temp && temp.flightHeight ? temp.flightHeight : '';
        }

        let id_property = '';
        if (jobDetail && jobDetail.planejamento && Array.isArray(jobDetail.planejamento.area) && jobDetail.planejamento.area.length > 0) {
          const tempPlanejamento = jobDetail.planejamento.area.filter(a => a && a.id_property);
          if (tempPlanejamento.length > 0) id_property = tempPlanejamento.slice().sort((a, b) => Number(b && b.spray) - Number(a && a.spray))[0].id_property;
        }
        if (!id_property && jobDetail && jobDetail.execucao && Array.isArray(jobDetail.execucao.area) && jobDetail.execucao.area.length > 0) {
          const tempExecucao = jobDetail.execucao.area.filter(a => a && a.id_property);
          if (tempExecucao.length > 0) id_property = tempExecucao.slice().sort((a, b) => Number(b && b.spray) - Number(a && a.spray))[0].id_property;
        }

        const windDirectionArr = (jobDetail && jobDetail.planejamento && jobDetail.planejamento.planningWindDirection) ? parseJSON(jobDetail.planejamento.planningWindDirection, []) : [];

        const coordLatForWx = (jobDetail && jobDetail.execucao && jobDetail.execucao.latitude != null) ? jobDetail.execucao.latitude
          : (jobDetail && jobDetail.planejamento && jobDetail.planejamento.latitude != null) ? jobDetail.planejamento.latitude
            : null;

        const coordLngForWx = (jobDetail && jobDetail.execucao && jobDetail.execucao.longitude != null) ? jobDetail.execucao.longitude
          : (jobDetail && jobDetail.planejamento && jobDetail.planejamento.longitude != null) ? jobDetail.planejamento.longitude
            : null;

        const startDateRaw = (jobDetail && jobDetail.execucao && jobDetail.execucao.startDate) ? jobDetail.execucao.startDate
          : (jobDetail && jobDetail.planejamento && jobDetail.planejamento.startDate) ? jobDetail.planejamento.startDate
            : '';

        const endDateRaw = (jobDetail && jobDetail.execucao && jobDetail.execucao.endDate) ? jobDetail.execucao.endDate
          : (jobDetail && jobDetail.planejamento && jobDetail.planejamento.endDate) ? jobDetail.planejamento.endDate
            : '';

        if (Number.isFinite(coordLatForWx) && Number.isFinite(coordLngForWx) && startDateRaw && endDateRaw) {
          this.listPolygonData().then((polygonResult) => {
            if (!polygonResult || polygonResult.length === 0) {
              this.listWeatherDataByLocation([{ lat: coordLatForWx, lng: coordLngForWx, time_ini: startDateRaw, time_fim: endDateRaw }], this.state.id).then((weatherData) => {
                this.setState({ weatherData });
              });
            } else {
              this.setState({ weatherData: polygonResult });
            }
          });
        }

        const execNames = (jobDetail && jobDetail.execucao && Array.isArray(jobDetail.execucao.area)) ? jobDetail.execucao.area.map(a => a && a.name).filter(Boolean) : [];
        const planNames = (jobDetail && jobDetail.planejamento && Array.isArray(jobDetail.planejamento.area)) ? jobDetail.planejamento.area.map(a => a && a.name).filter(Boolean) : [];
        const soNames = Array.from(new Set([].concat.apply([], serviceOrderList.map(so => (Array.isArray(so.areas) ? so.areas : []).filter(a => a && a.type === 'area' && a.name).map(a => a.name)))));

        const polygonNames = execNames.length ? execNames : (planNames.length ? planNames : soNames);

        let equipmentSource = '';
        if (jobDetail && jobDetail.planejamento && jobDetail.planejamento.equipment) {
          this.setState({ equipment: { name: jobDetail.planejamento.equipment.name || '' } });
          equipmentSource = 'planejamento';
        } else if (serviceOrderSafe && serviceOrderSafe.equipment) {
          this.setState({ equipment: parseJSON(serviceOrderSafe.equipment, {}) });
          equipmentSource = 'preorcamento';
        }

        const isOnlyServiceOrder = !jobDetail.planejamento && !jobDetail.execucao && serviceOrderList.length > 0;

        const rawContractor =
          (jobDetail && jobDetail.execucao && jobDetail.execucao.client_name) ||
          (jobDetail && jobDetail.planejamento && jobDetail.planejamento.client_name) ||
          (serviceOrderSafe && serviceOrderSafe.so_client) || '';

        let soProductsRaw = [];
        if (serviceOrderSafe && Array.isArray(serviceOrderSafe.products)) {
          soProductsRaw = serviceOrderSafe.products.slice(0, 6);
        } else if (serviceOrderSafe && serviceOrderSafe.products) {
          const parsed = parseJSON(serviceOrderSafe.products, []);
          soProductsRaw = Array.isArray(parsed) ? parsed.slice(0, 6) : [];
        }
        const soProductsWithRate = soProductsRaw
          .filter(p => p && typeof p === 'object')
          .map(p => ({
            ...p,
            id: p.id || p.id_product || p.id_product_custom,
            applicationRate: Number.isFinite(applicationFlowAll) ? applicationFlowAll : ''
          }));

        const sourceProducts = (updatedProducts && updatedProducts.length) ? updatedProducts : soProductsWithRate;
        const finalProducts = this.getProductsWithClass(sourceProducts);

        const validateExist = (prevValue, incomingValue) => {
          if (incomingValue === undefined || incomingValue === null) return prevValue;
          const text = String(incomingValue).trim();
          if (!text) return prevValue;
          return incomingValue;
        };

        const areaCoordinates = this.getAreaCoordinates(jobDetail, serviceOrderList);
        const formattedAreaLatitude = this.formatAreaCoordinateValues(areaCoordinates, 'latitude');
        const formattedAreaLongitude = this.formatAreaCoordinateValues(areaCoordinates, 'longitude');

        this.setState((prevState) => ({
          job: jobDetail,
          isOnlyServiceOrder,
          id_client: (jobDetail && jobDetail.execucao && jobDetail.execucao.id_client) || (jobDetail && jobDetail.planejamento && jobDetail.planejamento.id_client) || '',
          id_pilot: (jobDetail && jobDetail.execucao && jobDetail.execucao.id_pilot) || (jobDetail && jobDetail.planejamento && jobDetail.planejamento.id_pilot) || '',
          id_property: id_property,
          id_equipment: (jobDetail && jobDetail.execucao && jobDetail.execucao.id_equipment) || (jobDetail && jobDetail.planejamento && jobDetail.planejamento.id_equipment) || '',
          contractor: rawContractor || '',
          contractorSelect: rawContractor ? rawContractor : 'noRegister',
          showCustomContractor: false,
          cpf_cnpj: (jobDetail && jobDetail.execucao && jobDetail.execucao.client_cpf_cnpj) || (jobDetail && jobDetail.planejamento && jobDetail.planejamento.client_cpf_cnpj) || '',
          contractorEmail: (jobDetail && jobDetail.planejamento && jobDetail.planejamento.client_email) || '',
          area: this.limitFieldValue('area', areaVolumePair.area),
          volume: this.limitFieldValue('volume', areaVolumePair.volume),
          startDate: startDate || '',
          endDate: endDate || '',
          time_voo: (jobDetail && jobDetail.execucao && jobDetail.execucao.time_total) ? secondsToTimeFormat(jobDetail.execucao.time_total)
            : (jobDetail && jobDetail.planejamento && jobDetail.planejamento.time_total) ? secondsToTimeFormat(jobDetail.planejamento.time_total) : '',
          plane: this.limitFieldValue('plane', serviceOrderPlanes || (jobDetail && jobDetail.execucao && jobDetail.execucao.plane) || (jobDetail && jobDetail.planejamento && jobDetail.planejamento.plane) || ''),
          pilot: this.limitFieldValue('pilot', serviceOrderPilots || (jobDetail && jobDetail.planejamento && jobDetail.planejamento.pilot_name) || ''),
          canac: this.limitFieldValue('canac', serviceOrderPilotCanacs || (jobDetail && jobDetail.planejamento && jobDetail.planejamento.pilot_canac) || ''),
          pilotEmail: serviceOrderPilotEmails || (jobDetail && jobDetail.planejamento && jobDetail.planejamento.pilot_email) || '',
          temperature: this.limitFieldValue('temperature', validTemperature || ''),
          humidity: this.limitFieldValue('humidity', validHumidity || ''),
          culture: this.limitFieldValue('culture', validCulture || (serviceOrderSafe && serviceOrderSafe.crop) || ''),
          flight_height: this.limitFieldValue('flight_height', flightHeight || ''),
          applicationRange: this.limitFieldValue('applicationRange', applicationRange || ''),
          filteredProducts: Array.isArray(this.state.list_all_prod) ? this.state.list_all_prod : [],
          title: (jobDetail && jobDetail.execucao && jobDetail.execucao.title) || (jobDetail && jobDetail.planejamento && jobDetail.planejamento.title) || (serviceOrderSafe && serviceOrderSafe.so_title) || '',
          observations: (serviceOrderSafe && (serviceOrderSafe.so_observation || serviceOrderSafe.observations || serviceOrderSafe.observation)) || '',
          latitude: formattedAreaLatitude || (Number.isFinite(coordinateLatitude) ? geo.toDMS(coordinateLatitude, 'latitude', null, this.props.res) : Number.isFinite(areaLatPre) ? geo.toDMS(areaLatPre, 'latitude', null, this.props.res) : ''),
          longitude: formattedAreaLongitude || (Number.isFinite(coordinateLongitude) ? geo.toDMS(coordinateLongitude, 'longitude', null, this.props.res) : Number.isFinite(areaLngPre) ? geo.toDMS(areaLngPre, 'longitude', null, this.props.res) : ''),
          runway_latitude: Number.isFinite(lat_refuel) ? geo.toDMS(lat_refuel, 'latitude', null, this.props.res) : Number.isFinite(runwayLatPre) ? geo.toDMS(runwayLatPre, 'latitude', null, this.props.res) : '',
          runway_longitude: Number.isFinite(lng_refuel) ? geo.toDMS(lng_refuel, 'longitude', null, this.props.res) : Number.isFinite(runwayLngPre) ? geo.toDMS(runwayLngPre, 'longitude', null, this.props.res) : '',
          polygon: uniquePolygons || [],
          property: this.limitFieldValue('property', (serviceOrderSafe && serviceOrderSafe.so_property) || selectedProperty || ''),
          jobProperty: jobProperty || [],
          areaData: formattedABs || [],
          applicationConditions: {
            ...this.state.applicationConditions,
            data: startDate ? Moment(startDate).format("YYYY-MM-DD") : '',
            dataFim: endDate ? Moment(endDate).format("YYYY-MM-DD") : '',
          },
          wind_speed: this.limitFieldValue('wind_speed', windSpeedPlanArr || ''),
          wind_direction: windDirectionArr.length > 0 ? windDirectionArr[0] : '',
          application_period: Array.isArray(applicationPeriodArr) && applicationPeriodArr.length ? applicationPeriodArr[0] : '',
          selectedService: selectedServiceFinal || '',
          registrationNumber:
            ((jobDetail && jobDetail.execucao && jobDetail.execucao.registrationNumber === "null") ? "" : (jobDetail && jobDetail.execucao && jobDetail.execucao.registrationNumber)) ||
            ((jobDetail && jobDetail.planejamento && jobDetail.planejamento.registrationNumber === "null") ? "" : (jobDetail && jobDetail.planejamento && jobDetail.planejamento.registrationNumber)) || '',
          runwayDistance: Number.isFinite(runwayDistance) ? runwayDistance.toFixed(1) : '',
          polygonName: (Array.isArray(polygonNames) ? polygonNames : [])
            .filter(Boolean)
            .join(' / ')
            .slice(0, maxCaracteres),
          responsibleTechnician: validateExist(prevState.responsibleTechnician, serviceOrderSafe && serviceOrderSafe.so_rt_name),
          responsibleTechnician_crea_cfta: validateExist(prevState.responsibleTechnician_crea_cfta, serviceOrderSafe && serviceOrderSafe.so_rt_crea_cfta),
          responsibleTechnicianEmail: validateExist(prevState.responsibleTechnicianEmail, serviceOrderSafe && serviceOrderSafe.so_rt_email),
          product: finalProducts,
          agroClass: agroFlags
        }), async () => {
          const areaLocationPromise = this.readAreaLocations(areaCoordinates);

          const hasExecAreas = (this.state && this.state.job && this.state.job.execucao && Array.isArray(this.state.job.execucao.area) && this.state.job.execucao.area.length > 0);
          const hasPlanAreas = (this.state && this.state.job && this.state.job.planejamento && Array.isArray(this.state.job.planejamento.area) && this.state.job.planejamento.area.length > 0);

          if (!hasExecAreas && !hasPlanAreas) {
            const job = (this.state && this.state.job) ? this.state.job : null;

            const soFromState = (job && Array.isArray(job.service_order) && job.service_order.length > 0) ? job.service_order[0] : null;
            const soAreasB = (soFromState && Array.isArray(soFromState.areas)) ? soFromState.areas : [];
            const soAreasAll = soAreasB.filter(a => a && a.type === 'area' && a.points_place);

            if (soAreasAll.length > 0) {
              this.drawPreOperacaoPolygon(soAreasAll.map(a => a.points_place));
            } else {
              const pointsPlace = (job && job.preorcamento && job.preorcamento.points_place) || null;
              if (pointsPlace) this.drawPreOperacaoPolygon(pointsPlace);
            }

            const latRef =
              (job && job.execucao && job.execucao.lat_refuel) != null ? job.execucao.lat_refuel :
                (job && job.planejamento && job.planejamento.lat_refuel) != null ? job.planejamento.lat_refuel :
                  (job && job.preorcamento && job.preorcamento.lat_refuel) != null ? job.preorcamento.lat_refuel :
                    null;

            const lngRef =
              (job && job.execucao && job.execucao.lng_refuel) != null ? job.execucao.lng_refuel :
                (job && job.planejamento && job.planejamento.lng_refuel) != null ? job.planejamento.lng_refuel :
                  (job && job.preorcamento && job.preorcamento.lng_refuel) != null ? job.preorcamento.lng_refuel :
                    null;

            if (Number.isFinite(latRef) && Number.isFinite(lngRef)) {
              this.featureGroupP.clearLayers();
              L.circleMarker([latRef, lngRef], { radius: 5 }).addTo(this.featureGroupP);
              this.featureGroupP.addTo(this.mymap);
              this.featureGroupP.bringToFront();
            }
          }

          if (equipmentSource === 'planejamento' && this.state && this.state.equipment && this.state.equipment.name && this.state.equipment.name.length > 0) {
            this.readEquipments();
          }

          if (Array.isArray(this.state.planes) && this.state.planes.length > 0) {
            this.applyPlaneSelectionFromText(this.state.planes);
          }

          if (Array.isArray(this.state.pilots) && this.state.pilots.length > 0) {
            this.applyPilotSelectionFromText(this.state.pilots);
          }

          let propertyPromise = Promise.resolve();
          if (this.state.id_client) {
            propertyPromise = this.readProperties(this.state.id_client, {
              selectId: this.state.id_property,
              selectName: this.state.property
            });
          }

          const contractorName = this.state.contractor;
          if (contractorName && Array.isArray(this.state.clients) && this.state.clients.length) {
            const selectedClient = this.state.clients.find(client => client && String(client.name) === String(contractorName));

            this.setState({
              contractorSelect: selectedClient ? contractorName : 'noRegister',
              showCustomContractor: !selectedClient
            });
          }

          await Promise.all([areaLocationPromise, propertyPromise]);
          this.setState({ initialLoading: false });
        });
      })
      .catch((error) => {
        this.setState({ initialLoading: false });
        if (error && error.status === 405) {
          notification.open({
            message: this.props.res.PERMISSAO,
            description: this.props.res.PERMISSAO_MSG,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
        } else if (error && (error.status === 401 || error.status === 403)) {
          this.props.link('/login');
        }
      });
  };

  drawPreOperacaoPolygon = (pointsPlace) => {
    const list = Array.isArray(pointsPlace) ? pointsPlace : [pointsPlace];

    this.featureGroupPoly.clearLayers();
    const bounds = L.latLngBounds();

    list.forEach((pp) => {
      if (!pp || typeof pp !== 'string') return;
      let arr;
      try { arr = JSON.parse(pp); } catch { return; }
      if (!Array.isArray(arr) || arr.length < 3) return;

      const pts = arr
        .map(p => (Array.isArray(p) && p.length >= 2) ? [Number(p[0]), Number(p[1])] : null)
        .filter(Boolean);

      if (pts.length >= 3) {
        const poly = L.polygon(pts, { weight: 2 });
        poly.addTo(this.featureGroupPoly);
        pts.forEach(ll => bounds.extend(ll));
      }
    });

    if (bounds.isValid()) {
      this.featureGroupPoly.addTo(this.mymap);
      this.featureGroupPoly.bringToFront();
      this.featureGroupP.bringToFront();
      this.mymap.fitBounds(bounds, { padding: [20, 20] });
    }
  };

  listWeatherDataByLocation = async (polyData, id_job) => {
    const newWeatherData = [];

    for (const { lat, lng, time_ini, time_fim } of polyData) {
      if (!lat || !lng || !time_ini || !time_fim) {
        continue;
      }

      const options = {
        method: 'GET',
        headers: {
          'Authorization': localStorage.getItem('access-token-jwt'),
        },
      };

      try {
        const apiUrlIni = `${Config.server}/weather_data/location/${lat}/${lng}/${time_ini}`;
        const responseIni = await fetch(apiUrlIni, options);
        const resultIni = responseIni.status === 200 ? await responseIni.json() : [];

        const apiUrlFim = `${Config.server}/weather_data/location/${lat}/${lng}/${time_fim}`;
        const responseFim = await fetch(apiUrlFim, options);
        const resultFim = responseFim.status === 200 ? await responseFim.json() : [];

        const startData = resultIni.length > 0 ? resultIni[0] : null;
        const endData = resultFim.length > 0 ? resultFim[0] : null;

        if (startData || endData) {
          const startHour = new Date(time_ini).getHours();
          const endHour = new Date(time_fim).getHours();

          const isStartMorning = startHour < 12;
          const isEndMorning = endHour < 12;


          const updatedConditions = {
            ...this.state.applicationConditions,
            data: new Date(time_ini).toISOString().split('T')[0],

            temperaturaMatutino: isStartMorning || isEndMorning,
            temperaturaInicialMatutino: isStartMorning ? startData?.air_temperature || '' : '',
            temperaturaFinalMatutino: isEndMorning ? endData?.air_temperature || '' : '',
            umidadeMatutino: isStartMorning || isEndMorning,
            umidadeInicialMatutino: isStartMorning ? startData?.air_humidity || '' : '',
            umidadeFinalMatutino: isEndMorning ? endData?.air_humidity || '' : '',
            velocidadeMatutino: isStartMorning || isEndMorning,
            velocidadeInicialMatutino: isStartMorning ? (startData?.wind_speed ? (startData.wind_speed * 3.6).toFixed(2) : '') : '',
            velocidadeFinalMatutino: isEndMorning ? (endData?.wind_speed ? (endData.wind_speed * 3.6).toFixed(2) : '') : '',
            horarioMatutino: isStartMorning || isEndMorning,
            horarioInicialMatutino: isStartMorning ? Moment(time_ini).format("HH:mm") : '',
            horarioFinalMatutino: isEndMorning ? Moment(time_fim).format("HH:mm") : '',

            temperaturaVespertino: !isStartMorning || !isEndMorning,
            temperaturaInicialVespertino: !isStartMorning ? startData?.air_temperature || '' : '',
            temperaturaFinalVespertino: !isEndMorning ? endData?.air_temperature || '' : '',
            umidadeVespertino: !isStartMorning || !isEndMorning,
            umidadeInicialVespertino: !isStartMorning ? startData?.air_humidity || '' : '',
            umidadeFinalVespertino: !isEndMorning ? endData?.air_humidity || '' : '',
            velocidadeVespertino: !isStartMorning || !isEndMorning,
            velocidadeInicialVespertino: !isStartMorning ? (startData?.wind_speed ? (startData.wind_speed * 3.6).toFixed(2) : '') : '',
            velocidadeFinalVespertino: !isEndMorning ? (endData?.wind_speed ? (endData.wind_speed * 3.6).toFixed(2) : '') : '',
            horarioVespertino: !isStartMorning || !isEndMorning,
            horarioInicialVespertino: !isStartMorning ? Moment(time_ini).format("HH:mm") : '',
            horarioFinalVespertino: !isEndMorning ? Moment(time_fim).format("HH:mm") : '',
          };

          this.setState({ applicationConditions: updatedConditions });
        }

        newWeatherData.push({ id_job, lat, lng, startData, endData });
      } catch (error) {
        if (error.status === 405) {
          notification.open({
            message: this.props.res.PERMISSAO,
            description: this.props.res.PERMISSAO_MSG,
            icon: <MaterialIcon icon="error" className="text-danger" />,
          });
        } else if (error.status === 401 || error.status === 403) {
          this.props.link('/login');
        }
      }
    }

    return newWeatherData;
  };

  getAngleFromCoordinates = (lat1, lng1, lat2, lng2) => {
    const rad = Math.PI / 180;
    const dLon = (lng2 - lng1) * rad;
    const y = Math.sin(dLon) * Math.cos(lat2 * rad);
    const x = Math.cos(lat1 * rad) * Math.sin(lat2 * rad) - Math.sin(lat1 * rad) * Math.cos(lat2 * rad) * Math.cos(dLon);
    let brng = Math.atan2(y, x);
    brng = brng / rad;
    brng = (brng + 360) % 360;
    return brng;
  }

  getCardinalDirection = (angle) => {
    if (angle >= 348.75 || angle < 11.25) {
      return 'N';
    } else if (angle >= 11.25 && angle < 33.75) {
      return 'NNE';
    } else if (angle >= 33.75 && angle < 56.25) {
      return 'NE';
    } else if (angle >= 56.25 && angle < 78.75) {
      return 'ENE';
    } else if (angle >= 78.75 && angle < 101.25) {
      return 'L';
    } else if (angle >= 101.25 && angle < 123.75) {
      return 'ESE';
    } else if (angle >= 123.75 && angle < 146.25) {
      return 'SE';
    } else if (angle >= 146.25 && angle < 168.75) {
      return 'SSE';
    } else if (angle >= 168.75 && angle < 191.25) {
      return 'S';
    } else if (angle >= 191.25 && angle < 213.75) {
      return 'SSO';
    } else if (angle >= 213.75 && angle < 236.25) {
      return 'SO';
    } else if (angle >= 236.25 && angle < 258.75) {
      return 'OSO';
    } else if (angle >= 258.75 && angle < 281.25) {
      return 'O';
    } else if (angle >= 281.25 && angle < 303.75) {
      return 'ONO';
    } else if (angle >= 303.75 && angle < 326.25) {
      return 'NO';
    } else if (angle >= 326.25 && angle < 348.75) {
      return 'NNO';
    }
  }

  readEquipments = () => {
    const apiUrl = `${Config.server}/plane_equipment/${this.state.id_equipment}`;

    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    };

    const equipmentTypeMap = {
      'Bico Hidráulico Core e Disco': 'bicoHidraulicoCoreDisco',
      'Bico Hidráulico Cerâmica': 'bicoHidraulicoCeramica',
      'Bico Hidráulico Jato Sólido': 'bicoHidraulicoSolido',
      'Bico Hidráulico Jato Plano': 'bicoHidraulicoPlano',
      'Atomizador Rotativo Tela': 'atomizadorTela',
      'Atomizador Rotativo Disco': 'atomizadorDisco',
      'CP03/TT03': 'cp03tt03',
      'CP09/TT09': 'cp09tt09',
      'CP11/TT11': 'cp11tt11'
    };

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.json();
      })
      .then((result) => {
        const equipment = result[0] || {};
        const equipType = equipmentTypeMap[equipment.equipmentTypeName];

        this.setState({
          equipment: {
            type: equipType,
            name: equipment.equipment || '',
            details: {
              angulo: equipment.deflectionAngle || '',
              ponta: equipment.jetType || '',
              anguloPa: equipment.angleBlades || '',
              malha: equipment.screen || '',
              vru: equipment.flowRegulator || '',
              orificio: equipment.jetType || '',
              core: equipment.core || '',
              disco: equipment.disco || '',
            }
          }
        });
      })
      .catch((error) => {
        if (error.status === 405) {
          notification.open({
            message: this.props.res.PERMISSAO,
            description: this.props.res.PERMISSAO_MSG,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
        } else if (error.status === 401 || error.status === 403) {
          this.props.link('/login');
        }
      });
  };

  readTechnician = () => {
    const apiUrl = `${Config.server}/technician`;

    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    };

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.json();
      })
      .then((result) => {
        if (result.length > 0) {
          const firstTechnician = result[0];
          this.setState({
            technicians: result,
            id_technician: firstTechnician.id,
            executor: firstTechnician.name,
            executor_crea_cpf: firstTechnician.cfta,
            executorEmail: firstTechnician.email.toLowerCase(),
            responsibleTechnician: firstTechnician.name,
            responsibleTechnician_crea_cfta: firstTechnician.cfta,
            responsibleTechnicianEmail: firstTechnician.email.toLowerCase()
          });
        }
      })
      .catch((error) => {
        if (error.status === 405) {
          notification.open({
            message: this.props.res.PERMISSAO,
            description: this.props.res.PERMISSAO_MSG,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
        } else if (error.status === 401 || error.status === 403) {
          this.props.link('/login');
        }
      });
  };

  handleTechnicianChange = (event) => {
    const selectedTechnician = this.state.technicians.find(technician => technician.name === event.target.value);
    this.setState({
      executor: selectedTechnician.name,
      executor_crea_cpf: selectedTechnician.cfta,
      executorEmail: selectedTechnician.email ? selectedTechnician.email.toLowerCase() : '',
    });
  };

  readAgronomist = () => {
    const apiUrl = `${Config.server}/agronomist`;

    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    };

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.json();
      })
      .then((result) => {
        if (result.length > 0) {
          const firstAgronomist = result[0];

          this.setState({
            agronomists: result,
            id_agronomist: firstAgronomist.id,
            agricultural_engineer: firstAgronomist.name,
            engineer_crea_cpf: firstAgronomist.crea,
            engineerEmail: firstAgronomist.email.toLowerCase(),
          });
        }
      })
      .catch((error) => {
        if (error.status === 405) {
          notification.open({
            message: this.props.res.PERMISSAO,
            description: this.props.res.PERMISSAO_MSG,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
        } else if (error.status === 401 || error.status === 403) {
          this.props.link('/login');
        }
      });
  };

  handleAgronomistChange = (event) => {
    const selectedAgronomist = this.state.agronomists.find(agronomist => agronomist.name === event.target.value);
    this.setState({
      agricultural_engineer: selectedAgronomist.name,
      engineer_crea_cpf: selectedAgronomist.crea,
      engineerEmail: selectedAgronomist.email ? selectedAgronomist.email.toLowerCase() : ''
    });
  };

  handleResponsibleTechnicianChange = (event) => {
    const selectedTechnicians = this.state.technicians.find(technician => technician.name === event.target.value);
    this.setState({
      responsibleTechnician: selectedTechnicians.name,
      responsibleTechnician_crea_cfta: selectedTechnicians.cfta,
      responsibleTechnicianEmail: selectedTechnicians.email ? selectedTechnicians.email.toLowerCase() : ''
    });
  };

  isFormValid = () => {
    return !!this.normalizeDocumentValue(this.state.contractorEmail) &&
      !!this.normalizeDocumentValue(this.state.pilotEmail) &&
      !!this.normalizeDocumentValue(this.state.executorEmail) &&
      !!this.normalizeDocumentValue(this.state.engineerEmail) &&
      !!this.normalizeDocumentValue(this.state.responsibleTechnicianEmail);
  };

  getProductsWithClass = (products) => {
    const allProducts = Array.isArray(this.state.list_all_prod) ? this.state.list_all_prod : [];
    const inputProducts = Array.isArray(products) ? products : [];


    const enrichedProducts = inputProducts.map(product => {
      if (!product || product.is_custom === true || product.source === 'custom') {
        const customProduct = { ...product, class: (product && product.class) || '' };


        return customProduct;
      }

      const productId = product.id_product || product.id;
      const masterProduct = allProducts.find(item =>
        item &&
        item.is_custom !== true &&
        item.source !== 'custom' &&
        (
          Number(item.id) === Number(productId) ||
          String(item.name || '').trim().toLowerCase() === String(product.name || '').trim().toLowerCase()
        )
      );

      const resolvedClass = product.class || product.toxicClass || (masterProduct && masterProduct.class) || '';

      return {
        ...product,
        id: product.id || productId,
        class: resolvedClass,
        toxicClass: resolvedClass
      };
    });


    return enrichedProducts;
  };

  handleSubmit = (event, opts = {}) => {
    event.preventDefault();

    const preservePreDoc = !!(opts && opts.preservePreDoc);

    if (!this.isFormValid()) {
      notification.open({
        message: this.props.res.ATENCAO,
        description: this.props.res.PREENCHA_EMAILS,
        icon: <MaterialIcon icon="error" className="text-danger" />
      });
      return;
    }

    if (this.getInvalidFormEmails().length > 0) {
      notification.open({
        message: this.props.res.ATENCAO,
        description: this.getInvalidEmailNotification(),
        icon: <MaterialIcon icon="error" className="text-danger" />
      });
      return;
    }

    let apiUrl = '';
    let method = '';
    apiUrl = Config.server + '/reports_mapa';

    const formData = new URLSearchParams();
    if (this.state.jobReportId) {
      apiUrl += `/${this.state.jobReportId}`;
      formData.append('id', this.state.jobReportId);
      method = 'PUT';
    } else {
      method = 'POST';
    }

    const isBlank = (v) => v === '' || v === null || v === undefined;
    const appendFormData = (key, value) => {
      if (isBlank(value)) return;
      formData.append(key, this.limitFieldValue(key, value));
    };

    const appendNumber = (key, value) => {
      if (isBlank(value)) return;
      const n = Number(value);
      if (!Number.isFinite(n)) return;
      formData.append(key, String(n));
    };

    const appendDateTime = (key, value) => {
      if (isBlank(value)) return;
      formData.append(key, value);
    };

    appendFormData('id_client', this.state.id_client);
    appendFormData('id_job', this.state.id);
    appendFormData('id_pilot', this.state.id_pilot);
    appendFormData('id_property', this.state.id_property);
    appendFormData('contractor', this.getContractorForSubmit());
    appendFormData('cpf_cnpj', this.state.cpf_cnpj);
    appendFormData('contractorEmail', this.state.contractorEmail);
    appendFormData('property', this.state.property);
    appendFormData('city', this.state.city);
    appendFormData('address', this.state.address);
    appendFormData('uf', this.state.uf);
    appendFormData('culture', this.state.culture);
    appendFormData('area', this.state.area);
    appendFormData('volume', this.state.volume);
    appendDateTime('initialDate', this.state.startDate);
    appendDateTime('finalDate', this.state.endDate);
    appendFormData('time_voo', this.state.time_voo);
    appendFormData('application_period', this.state.application_period);
    appendFormData('type_service', JSON.stringify(this.state.type_service));
    appendFormData('temperature', this.state.temperature);
    appendFormData('humidity', this.state.humidity);
    appendFormData('wind_speed', this.state.wind_speed);
    appendFormData('service', this.state.selectedService);
    appendFormData('flight_height', this.state.flight_height);
    appendFormData('applicationRange', this.state.applicationRange);
    appendFormData('plane', this.state.plane);
    appendFormData('pilot', this.state.pilot);
    appendFormData('canac', this.state.canac);
    appendFormData('pilotEmail', this.state.pilotEmail);

    const productsWithClass = this.getProductsWithClass(this.state.product);


    appendFormData('equipment', JSON.stringify(this.state.equipment));
    appendFormData('product', JSON.stringify(productsWithClass));
    appendFormData('executor', this.state.executor);
    appendFormData('executor_crea_cpf', this.state.executor_crea_cpf);
    appendFormData('executorEmail', this.state.executorEmail);
    appendFormData('agricultural_engineer', this.state.agricultural_engineer);
    appendFormData('engineer_crea_cpf', this.state.engineer_crea_cpf);
    appendFormData('engineerEmail', this.state.engineerEmail);
    appendFormData('responsibleTechnician', this.state.responsibleTechnician);
    appendFormData('responsibleTechnician_crea_cfta', this.state.responsibleTechnician_crea_cfta);
    appendFormData('responsibleTechnicianEmail', this.state.responsibleTechnicianEmail);
    appendFormData('longitude', this.state.longitude);
    appendFormData('latitude', this.state.latitude);
    appendFormData('flight_direction', JSON.stringify(this.state.flight_direction));
    appendFormData('areaData', JSON.stringify(this.state.areaData));
    appendFormData('wind_direction', this.state.wind_direction);
    appendFormData('runway_longitude', this.state.runway_longitude);
    appendFormData('runway_latitude', this.state.runway_latitude);
    appendFormData('applicationConditions', JSON.stringify(this.state.applicationConditions));
    appendFormData('prescriptionDate', this.state.prescriptionDate);
    appendFormData('prescriptionNumber', this.state.prescriptionNumber);
    appendFormData('registrationNumber', this.state.registrationNumber);
    appendFormData('polygon', JSON.stringify(this.state.polygon));
    appendFormData('title', this.state.title);
    appendNumber('runwayDistance', this.state.runwayDistance);
    appendFormData('polygonName', this.state.polygonName);
    appendFormData('observations', this.state.observations);
    appendFormData('signature', this.state.responsibleTechnicianSignature);
    formData.append('pre_document', preservePreDoc ? (this.state.preDocumentB64 || '') : '');

    const options = {
      method: method,
      body: formData,
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    };

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.json();
      })
      .then(
        (result) => {
          if (result && result.error) {
            notification.open({
              message: this.props.res[result.message],
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else {
            let msg = this.props.res.ITEM_INCLUIR;
            if (this.state.id) {
              msg = this.props.res.ITEM_ALTERADO;
            }
            notification.open({
              message: this.props.res.SUCESSO,
              description: msg,
              icon: <MaterialIcon icon="check_circle" className="text-success" />
            });
          }
          this.setState({
            isReportReady: true,
            editData: false,
            jobReportIdjob: result,
            preDocumentB64: preservePreDoc ? (this.state.preDocumentB64 || '') : ''
          });

          this.readReportMapa(this.state.id);
        },
        (error) => {
          if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 401 || error.status === 403) {
            this.props.link('/login');
          } else {
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG_INFORMACOES,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        }
      );
  };

  createDocument = (event) => {
    event && event.preventDefault();
    let apiUrl = '';
    let method = '';
    apiUrl = Config.server + '/document';

    const formData = new URLSearchParams();
    const convertDateToMySQLFormat = (date) => {
      const d = new Date(date);
      return d.toISOString().slice(0, 19).replace('T', ' ');
    };
    const currentDateTime = convertDateToMySQLFormat(new Date());

    if (this.state.documentId) {
      apiUrl += `/${this.state.documentId}`;
      formData.append('id', this.state.documentId);
      method = 'PUT';
      formData.append('creationDate', this.state.createDocument);
    } else {
      method = 'POST';
      formData.append('creationDate', currentDateTime);
    }

    const documentGuid = this.normalizeDocumentValue(this.state.documentGuid);
    const fileSigned = this.normalizeDocumentValue(this.state.fileSigned);
    const documentName = this.normalizeDocumentValue(this.state.property !== 'Outro' ? this.state.property : this.state.contractor);

    formData.append('id_reports_mapa', this.state.jobReportId);
    formData.append('name', documentName);
    formData.append('title', this.state.title);
    formData.append('updateDate', currentDateTime);
    formData.append('fileGuid', documentGuid);
    formData.append('fileSigned', fileSigned);

    const requestOptions = {
      method: method,
      body: formData,
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    };

    return fetch(apiUrl, requestOptions)
      .then((res) => { if (res.status !== 200) throw res; return res.json(); })
      .then(() => {
        notification.open({
          message: this.props.res.SUCESSO,
          description: this.props.res.DOCUMENTO_GERADO,
          icon: <MaterialIcon icon="check_circle" className="text-success" />
        });
        return true;
      })
      .catch((error) => {
        notification.open({
          message: this.props.res.ERRO,
          description: this.props.res.ERRO_MSG,
          icon: <MaterialIcon icon="error" className="text-danger" />
        });
        throw error;
      });
  };

  readDocument = () => {
    const apiUrl = `${Config.server}/document/${this.state.jobReportId}`;

    const requestOptions = {
      method: 'GET',
      headers: { 'Authorization': localStorage.getItem('access-token-jwt') }
    };

    return fetch(apiUrl, requestOptions)
      .then((res) => { if (res.status !== 200) throw res; return res.json(); })
      .then((result) => {
        const convertDateToMySQLFormat = (date) => {
          const d = new Date(date);
          const year = d.getFullYear();
          const month = ('0' + (d.getMonth() + 1)).slice(-2);
          const day = ('0' + d.getDate()).slice(-2);
          const hours = ('0' + d.getHours()).slice(-2);
          const minutes = ('0' + d.getMinutes()).slice(-2);
          const seconds = ('0' + d.getSeconds()).slice(-2);
          return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        };
        const creationDate = result && result.creationDate
          ? convertDateToMySQLFormat(result.creationDate)
          : null;

        let signedUrl = null;
        if (result && result.autentiqueData && result.autentiqueData.arquivo && result.autentiqueData.arquivo.assinado) {
          signedUrl = result.autentiqueData.arquivo.assinado;
        } else if (result && result.fileSigned) {
          signedUrl = result.fileSigned;
        }

        return new Promise((resolve) => {
          this.setState({
            documentData: result.autentiqueData || {},
            documentGuid: this.normalizeDocumentValue(result.fileGuid),
            documentId: result.id,
            fileSigned: this.normalizeDocumentValue(signedUrl),
            fileBase64: this.normalizeDocumentValue(result.fileBase64) || null,
            createDocument: creationDate
          }, () => {
            this.createSignatures && this.createSignatures();
            resolve(true);
          });
        });
      })
      .catch((error) => {
        if (error.status === 405) {
          notification.open({
            message: this.props.res.PERMISSAO,
            description: this.props.res.PERMISSAO_MSG,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
        } else if (error.status === 401 || error.status === 403) {
          this.props.link('/login');
        }
        throw error;
      });
  };

  createSignatures = () => {
    const partes = (this.state.documentData && Array.isArray(this.state.documentData.partes)) ? this.state.documentData.partes : [];

    this.readSignatures()
      .then(existingSignatures => {
        partes.forEach(parte => {
          const formData = new URLSearchParams();
          formData.append('id_document', this.state.documentId);
          formData.append('name', parte.nome);
          formData.append('email', parte.email);

          const statusDetails = this.getStatusDetails(parte);
          formData.append('updateDate', statusDetails.date);
          formData.append('status', statusDetails.etapa);

          formData.append('id_agronomist', parte.email === this.state.engineerEmail ? (this.state.id_agronomist || '') : '');
          formData.append('id_pilot', parte.email === this.state.pilotEmail ? (this.state.id_pilot || '') : '');
          formData.append('id_technician', parte.email === this.state.executorEmail ? (this.state.id_technician || '') : '');
          formData.append('id_client', parte.email === this.state.contractorEmail ? (this.state.id_client || '') : '');

          let existingSignature = existingSignatures.find(sig => sig.email === parte.email);

          let apiUrl = `${Config.server}/signature`;
          let method = 'POST';

          if (existingSignature) {
            apiUrl += `/${existingSignature.id}`;
            method = 'PUT';
          }

          const options = {
            method: method,
            headers: {
              'Authorization': localStorage.getItem('access-token-jwt'),
              'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: formData.toString()
          };

          fetch(apiUrl, options)
            .then((res) => {
              if (res.status !== 201 && res.status !== 200) {
                return res.json().then(data => {
                  throw new Error(data.message || 'Unexpected error');
                });
              }
              return res.json();
            })
            .then(result => {
            })
            .catch(error => {
            });
        });

        this.readSignatures();
      })
      .catch(error => {
        console.error(error);
      });
  };

  readSignatures = () => {
    const documentId = this.state.documentId;

    if (!documentId) {
      return Promise.resolve([]);
    }

    const apiUrl = `${Config.server}/signature/${documentId}`;

    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    };

    return fetch(apiUrl, options)
      .then(res => {
        if (res.status === 200) {
          return res.json();
        } else if (res.status === 404) {
          return [];
        } else {
          return res.json().then(data => {
            throw new Error(data.message || 'Unexpected error');
          });
        }
      })
      .catch(error => {
        throw error;
      });
  };

  readAllReportsMapa = () => {
    const apiUrl = `${Config.server}/reports_mapa`;

    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    };

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.json();
      })
      .then((result) => {
        const filterJobReport = result.filter(res => res.id_job == this.state.id);
        if (filterJobReport.length > 0) {
          this.setState({ jobReportId: filterJobReport[0].id, jobReportIdjob: filterJobReport[0].id_job });
          this.readReportMapa(filterJobReport[0].id_job);
        }
      })
      .catch((error) => {
        if (error.status === 405) {
          notification.open({
            message: this.props.res.PERMISSAO,
            description: this.props.res.PERMISSAO_MSG,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
        } else if (error.status === 401 || error.status === 403) {
          this.props.link('/login');
        }
      });
  };

  readReportMapa = (id) => {
    const apiUrl = `${Config.server}/reports_mapa/${id}`;

    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    };

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.json();
      })
      .then((result) => {
        if (!Array.isArray(result) || result.length === 0) {
          return;
        }

        const row = result[0];

        const safeParse = (str, fallback) => {
          try {
            if (str === null || str === undefined || str === '') return fallback;
            return JSON.parse(str);
          } catch (e) {
            return fallback;
          }
        };

        const formatDateForInput = (dateString) => {
          if (!dateString) return '';
          const date = new Date(dateString);
          if (isNaN(date.getTime())) return '';
          return tools.dateTimeZoneFormat(date, 'YYYY-MM-DDTHH:mm', this.props.res.timezone);
        };

        const formattedInitialDate = row.initialDate ? formatDateForInput(row.initialDate) : '';
        const formattedFinalDate = row.finalDate ? formatDateForInput(row.finalDate) : '';
        const savedReportProducts = safeParse(row.product, []);


        const reportProducts = this.getProductsWithClass(savedReportProducts);


        const normalizeStr = (v) => {
          if (v == null) return '';
          const s = String(v).trim();
          const l = s.toLowerCase();
          if (l === 'null' || l === 'undefined') return '';
          return s;
        };
        const contractorNameFromRow = normalizeStr(row.contractor);

        let contractorSelectVal = 'noRegister';
        let contractorFreeText = contractorNameFromRow;
        let showCustomContractor = !!contractorNameFromRow;

        if (contractorNameFromRow && Array.isArray(this.state.clients)) {
          const match = this.state.clients.find(c => {
            const label = normalizeStr(c && c.name);
            return label && label.toLowerCase() === contractorNameFromRow.toLowerCase();
          });

          if (match) {
            contractorSelectVal = match.name;
            contractorFreeText = match.name;
            showCustomContractor = false;
          }
        }

        const propertyNameForSelect = (row && row.property) ? String(row.property).trim() : '';

        this.setState({
          jobReportId: row.id,
          jobReport: row,
          id_client: row.id_client,
          id_pilot: row.id_pilot,
          id_property: row.id_property,

          contractor: contractorFreeText,
          contractorSelect: contractorSelectVal,
          showCustomContractor: showCustomContractor,

          cpf_cnpj: row.cpf_cnpj,
          contractorEmail: row.contractorEmail,
          property: row.property,
          propertyPreOrcamento: propertyNameForSelect,
          selectedPropertyIds: [],

          city: this.limitFieldValue('city', row.city),
          address: this.limitFieldValue('address', row.address),
          uf: row.uf,
          culture: this.limitFieldValue('culture', row.culture),
          area: this.limitFieldValue('area', row.area),
          volume: this.limitFieldValue('volume', row.volume),
          time_voo: row.time_voo,
          startDate: formattedInitialDate,
          endDate: formattedFinalDate,
          application_period: row.application_period,
          type_service: row.type_service
            ? safeParse(row.type_service, {
              insecticide: false,
              herbicide: false,
              fungicide: false,
              seeding: false,
              fertilizing: false,
              maturator: false
            })
            : {
              insecticide: false,
              herbicide: false,
              fungicide: false,
              seeding: false,
              fertilizing: false,
              maturator: false
            },
          temperature: this.limitFieldValue('temperature', row.temperature),
          humidity: this.limitFieldValue('humidity', row.humidity),
          wind_speed: this.limitFieldValue('wind_speed', row.wind_speed),
          selectedService: row.service,
          flight_height: this.limitFieldValue('flight_height', row.flight_height),
          applicationRange: this.limitFieldValue('applicationRange', row.applicationRange),
          plane: this.limitFieldValue('plane', row.plane),
          selectedPlaneIds: [],
          showCustomPlane: row.plane ? true : false,
          pilot: this.limitFieldValue('pilot', row.pilot),
          selectedPilotIds: [],
          showCustomPilot: row.pilot ? true : false,
          canac: this.limitFieldValue('canac', row.canac),
          pilotEmail: row.pilotEmail,
          equipment: safeParse(row.equipment, []),
          product: reportProducts,
          executor: this.limitFieldValue('executor', row.executor),
          executor_crea_cpf: this.limitFieldValue('executor_crea_cpf', row.executor_crea_cpf),
          executorEmail: row.executorEmail,
          agricultural_engineer: this.limitFieldValue('agricultural_engineer', row.agricultural_engineer),
          engineer_crea_cpf: this.limitFieldValue('engineer_crea_cpf', row.engineer_crea_cpf),
          engineerEmail: row.engineerEmail,
          responsibleTechnician: this.limitFieldValue('responsibleTechnician', row.responsibleTechnician),
          responsibleTechnician_crea_cfta: this.limitFieldValue('responsibleTechnician_crea_cfta', row.responsibleTechnician_crea_cfta),
          responsibleTechnicianEmail: row.responsibleTechnicianEmail,
          longitude: row.longitude,
          latitude: row.latitude,
          flight_direction: safeParse(row.flight_direction, []),
          wind_direction: row.wind_direction,
          runway_longitude: row.runway_longitude,
          runway_latitude: row.runway_latitude,
          applicationConditions: safeParse(row.applicationConditions, {}),
          prescriptionDate: row.prescriptionDate,
          prescriptionNumber: row.prescriptionNumber,
          registrationNumber: row.registrationNumber,
          runwayDistance: row.runwayDistance,
          polygon: safeParse(row.polygon, []),
          observations: row.observations,
          responsibleTechnicianSignature: row.signature,
          preDocumentB64: row.pre_document || null,
        }, () => {
          if (this.state.id_client) {
            this.readProperties(this.state.id_client, {
              selectId: this.state.id_property,
              selectName: this.state.property || this.state.propertyPreOrcamento
            });
          }

          this.readDocument();
        });
      })
      .catch((error) => {
        if (error.status === 405) {
          notification.open({
            message: this.props.res.PERMISSAO,
            description: this.props.res.PERMISSAO_MSG,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
        } else if (error.status === 401 || error.status === 403) {
          this.props.link('/login');
        } else {
          notification.open({
            message: this.props.res.ERRO,
            description: this.props.res.ERRO_MSG,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
        }
      });
  };

  limitValue = (value, max) => {
    if (value === null || value === undefined) return '';
    return String(value).slice(0, max);
  };

  limitFieldValue = (field, value) => {
    const max = fieldLimits[field];
    if (!max) return value;
    return this.limitValue(value, max);
  };

  handleLimitedChange = (name) => (event) => {
    const value = event && event.target ? event.target.value : '';
    this.setState({ [name]: this.limitFieldValue(name, value) });
  };

  parseTimeToSeconds = (value) => {
    if (!value) return 0;

    const parts = String(value).split(':');
    const hours = Number(parts[0]) || 0;
    const minutes = Number(parts[1]) || 0;
    const seconds = Number(parts[2]) || 0;

    return (hours * 3600) + (minutes * 60) + seconds;
  };

  formatSecondsToTime = (value) => {
    const totalSeconds = Math.max(0, Number(value) || 0);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return String(hours).padStart(2, '0') + ':' +
      String(minutes).padStart(2, '0') + ':' +
      String(seconds).padStart(2, '0');
  };

  updateOperationTimeByDates = () => {
    const startDate = this.state.startDate;
    const endDate = this.state.endDate;
    const currentOperationSeconds = this.parseTimeToSeconds(this.state.time_voo);

    if (!startDate || !endDate || !currentOperationSeconds) return;

    const start = Moment(startDate);
    const end = Moment(endDate);

    if (!start.isValid() || !end.isValid()) return;
    if (!start.isSame(end, 'day')) return;

    const operationSecondsByDates = end.diff(start, 'seconds');

    if (operationSecondsByDates <= 0) return;
    if (operationSecondsByDates >= currentOperationSeconds) return;

    this.setState({
      time_voo: this.formatSecondsToTime(operationSecondsByDates)
    });
  };

  handleChange = (name) => (event) => {
    const { value } = event.target;
    if (name === 'equipment') {
      this.setState(prevState => ({
        equipment: {
          ...prevState.equipment,
          type: value,
        }
      }));
    } else if (name === 'name') {
      this.setState(prevState => ({
        equipment: {
          ...prevState.equipment,
          name: value,
        }
      }));
    } else if (name === 'startDate' || name === 'endDate') {
      this.setState({ [name]: this.limitFieldValue(name, value) }, () => {
        this.updateOperationTimeByDates();
      });
    } else {
      this.setState({ [name]: this.limitFieldValue(name, value) });
    }
  };

  handleDirectionChange = (event) => {
    this.setState({ flight_direction: event.target.value });
  };

  handleChangeCoordinates = (name) => (event) => {
    let value = event.target.value;
    this.setState({
      [name]: value,
    });
  };

  handleBlurCoordinates = (name) => (event) => {
    let value = this.state[name];
    let { formattedInput, isValid } = this.maskCoordinateInput(value, name.includes('latitude') ? 'latitude' : 'longitude');

    this.setState({
      [name]: formattedInput,
      [name + '_error']: !isValid,
    });
  };

  maskCoordinateInput = (input, type) => {
    let cleanInput = input.replace(/[^0-9NSWE.,'°"\s]/gi, '').trim();
    let parts = cleanInput.split(/[\s°'"]/).filter(Boolean);

    let formattedInput = '';

    if (parts[0]) {
      formattedInput += parts[0].padStart(type === 'latitude' ? 2 : 3, '0') + '°';
    }
    if (parts[1]) {
      formattedInput += parts[1].padStart(2, '0') + '\'';
    }
    if (parts[2]) {
      formattedInput += parts[2].padStart(2, '0');
      if (parts[2].includes('.')) {
        let decimals = parts[2].split('.')[1];
        formattedInput += '.' + decimals;
      }
      formattedInput += '"';
    }

    let direction = parts.length === 4 ? parts[3].toUpperCase() : '';
    if (!direction && type === 'latitude') {
      direction = 'S';
    } else if (!direction && type === 'longitude') {
      direction = 'W';
    }
    if (direction && /[NSWE]/.test(direction)) {
      formattedInput += ' ' + direction;
    }

    let latitudeRegex = /^([0-8]?[0-9]|90)°([0-5]?[0-9])'([0-5]?[0-9](\.\d{1,})?)"(\s?[NS])$/;
    let longitudeRegex = /^([0-9]?[0-9]|1[0-7][0-9]|180)°([0-5]?[0-9])'([0-5]?[0-9](\.\d{1,})?)"(\s?[EW])$/;

    let isValid = type === 'latitude' ? latitudeRegex.test(formattedInput) : longitudeRegex.test(formattedInput);

    return { formattedInput, isValid };
  };

  getDefaultReportConfig = () => {
    const autoMapaConfig = this.state.autoMapaConfig || {};

    return {
      applicationGuide: autoMapaConfig.checkGuiaAplicacaoMapa !== undefined ? autoMapaConfig.checkGuiaAplicacaoMapa : false,
      logo: autoMapaConfig.checkRemoverLogoMapa !== undefined ? autoMapaConfig.checkRemoverLogoMapa : false,
      path: autoMapaConfig.checkTrajetoriaMapa !== undefined ? autoMapaConfig.checkTrajetoriaMapa : true,
      map: autoMapaConfig.checkMapaFundoMapa !== undefined ? autoMapaConfig.checkMapaFundoMapa : true,
      application: autoMapaConfig.checkAplicacaoMapa !== undefined ? autoMapaConfig.checkAplicacaoMapa : true
    };
  };

  readProfileAutoMapa = () => {
    const apiUrl = Config.server + '/profile_auto_mapa';

    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    };

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.json();
      })
      .then((result) => {
        let resumoConfig = null;

        if (result && result.length > 0 && result[0].mapa && result[0].mapa.length > 0) {
          resumoConfig = result[0].mapa[0].resumo_config;
        }

        if (resumoConfig && typeof resumoConfig === 'string') {
          try {
            resumoConfig = JSON.parse(resumoConfig);
          } catch (e) {
            resumoConfig = null;
          }
        }

        if (resumoConfig && typeof resumoConfig === 'object') {
          this.setState({ autoMapaConfig: resumoConfig });
        }
      })
      .catch((error) => {
        if (error && (error.status === 401 || error.status === 403)) {
          this.props.link('/login');
        }
      });
  };

  downloadRelMAPA = () => {
    this.setState({
      openReportConfigDialog: true,
      ...this.getDefaultReportConfig()
    });
  };

  downloadPreRelMAPA = () => {
    this.openPreReportConfigDialog();
  };

  confirmDownloadPreRelMAPA = () => {
    if (this.state.preDocumentB64 && this.state.preDocumentB64.length > 0) {
      try {
        const blob = this.base64ToBlob(this.state.preDocumentB64);
        const pdfUrl = URL.createObjectURL(blob);
        const downloadLink = document.createElement('a');
        downloadLink.href = pdfUrl;
        downloadLink.download = `${this.state.title}-Pre-Relatorio-MAPA.pdf`;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        URL.revokeObjectURL(pdfUrl);

        this.setState({ openPreReportConfigDialog: false });
        return;
      } catch (e) {
        console.warn(e);
      }
    }

    const apiUrl = Config.server + '/prerelmapa';
    const formData = new URLSearchParams();

    const pre = this.state.job?.preorcamento || {};
    const so0 = this.state.job?.service_order?.[0] || null;

    const pickPointsPlace = () => {
      const soAreas = Array.isArray(so0?.areas) ? so0.areas : [];

      const polys = soAreas
        .filter(a => a && a.type === 'area' && a.points_place)
        .map(a => {
          const raw = a.points_place;
          if (typeof raw === 'string') {
            const t = raw.trim();
            try { return (t && t[0] === '[') ? JSON.parse(t) : []; } catch { return []; }
          }
          if (Array.isArray(raw)) return raw;
          return [];
        })
        .filter(p => Array.isArray(p) && p.length > 0);

      if (polys.length > 0) {
        return JSON.stringify(polys);
      }

      const raw = pre.points_place;
      if (typeof raw === 'string') {
        const t = raw.trim();
        return (t && t[0] === '[') ? t : '[]';
      }
      if (Array.isArray(raw)) return JSON.stringify(raw);
      return '[]';
    };
    const points_place_payload = pickPointsPlace();

    const teste = {
      ...pre,

      points_place: points_place_payload,
      id_client: this.state.id_client || '',
      id_job: this.state.id || '',
      id_pilot: this.state.id_pilot || '',
      id_property: this.state.id_property || '',

      contractor: this.getContractorForSubmit(),
      cpf_cnpj: this.state.cpf_cnpj || '',
      contractorEmail: this.state.contractorEmail || '',
      property: this.state.property || 'Outro',
      city: this.state.city || '',
      address: this.state.address || '',
      uf: this.state.uf || '',

      culture: this.state.culture || '',
      area: this.state.area || '',
      volume: this.state.volume || '',
      initialDate: this.state.startDate || '',
      finalDate: this.state.endDate || '',
      time_voo: this.state.time_voo || '',
      application_period: this.state.application_period || '',

      type_service:
        this.state.type_service != null
          ? JSON.stringify(this.state.type_service)
          : (pre.type_service ?? ''),
      temperature: this.state.temperature || '',
      humidity: this.state.humidity || '',
      wind_speed: this.state.wind_speed || '',

      service: this.state.selectedService || '',
      flight_height: this.state.flight_height || '',
      applicationRange: this.state.applicationRange || '',

      plane: this.state.plane || '',
      pilot: this.state.pilot || '',
      canac: this.state.canac || '',
      pilotEmail: this.state.pilotEmail || '',

      equipment:
        this.state.equipment != null
          ? JSON.stringify(this.state.equipment)
          : (pre.equipment ?? ''),
      product:
        this.state.product != null
          ? JSON.stringify(this.state.product)
          : (pre.product ?? ''),

      executor: this.state.executor || '',
      executor_crea_cpf: this.state.executor_crea_cpf || '',
      executorEmail: this.state.executorEmail || '',
      agricultural_engineer: this.state.agricultural_engineer || '',
      engineer_crea_cpf: this.state.engineer_crea_cpf || '',
      engineerEmail: this.state.engineerEmail || '',
      responsibleTechnician: this.state.responsibleTechnician || '',
      responsibleTechnician_crea_cfta: this.state.responsibleTechnician_crea_cfta || '',
      responsibleTechnicianEmail: this.state.responsibleTechnicianEmail || '',

      longitude: this.state.longitude || '',
      latitude: this.state.latitude || '',
      flight_direction:
        this.state.flight_direction != null
          ? JSON.stringify(this.state.flight_direction)
          : (pre.flight_direction ?? ''),
      areaData:
        this.state.areaData != null
          ? JSON.stringify(this.state.areaData)
          : (pre.areaData ?? ''),
      wind_direction: this.state.wind_direction || '',
      runway_longitude: this.state.runway_longitude || '',
      runway_latitude: this.state.runway_latitude || '',

      applicationConditions:
        this.state.applicationConditions != null
          ? JSON.stringify(this.state.applicationConditions)
          : (pre.applicationConditions ?? ''),

      prescriptionDate: this.state.prescriptionDate || '',
      prescriptionNumber: this.state.prescriptionNumber || '',
      registrationNumber: this.state.registrationNumber || '',

      polygon:
        this.state.polygon != null
          ? JSON.stringify(this.state.polygon)
          : (pre.polygon ?? ''),
      title: this.state.title || '',
      runwayDistance: this.state.runwayDistance || '',
      polygonName: this.state.polygonName || '',
      observations: this.state.observations || '',

      signature: this.state.responsibleTechnicianSignature || '',
      map: this.state.map
    };

    formData.append('data', JSON.stringify(teste));
    formData.append('products', JSON.stringify(this.state.product || []));
    formData.append('type', 'preorcamento');
    formData.append('map', this.state.map);

    const options = {
      method: 'POST',
      body: formData,
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt'),
      }
    };

    fetch(apiUrl, options)
      .then((res) => {
        if (!res.ok) throw new Error('Erro ao gerar o PDF');
        return res.blob();
      })
      .then(async (blob) => {
        const pdfUrl = URL.createObjectURL(blob);
        const downloadLink = document.createElement('a');
        downloadLink.href = pdfUrl;
        downloadLink.download = `${this.state.title}-Pre-Relatorio-MAPA.pdf`;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        URL.revokeObjectURL(pdfUrl);

        try {
          const preB64 = await this.blobToBase64(blob);
          if (preB64 && preB64.length > 0) {
            this.setState({
              preDocumentB64: preB64,
              openPreReportConfigDialog: false
            }, () => {
              this.handleSubmit({ preventDefault: () => { } }, { preservePreDoc: true });
            });
          } else {
            this.setState({ openPreReportConfigDialog: false });
          }
        } catch (e) {
          console.warn(e);
          this.setState({ openPreReportConfigDialog: false });
        }
      })
      .catch((error) => {
        console.error(error);
        notification.open({
          message: this.props.res.ERRO,
          description: this.props.res.ERRO_MSG,
          icon: <MaterialIcon icon="error" className="text-danger" />
        });
      });
  };

  loadCultures = () => {
    const apiUrl = Config.server + '/domain/CULTURA';

    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt'),
      }
    }

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.json();
      })
      .then(
        (result) => {
          this.setState({
            cultureData: result
          });
        },
        (error) => {
          if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 401 || error.status === 403) {
            this.props.link('/login');
          }
          else {
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        }
      );
  }

  getProd = () => {
    return new Promise((resolve, reject) => {
      const apiUrl = `${Config.server}/product`;
      const options = {
        method: 'GET',
        headers: { 'Authorization': localStorage.getItem('access-token-jwt') }
      };

      fetch(apiUrl, options)
        .then((res) => { if (res.status !== 200) throw res; return res.json(); })
        .then((result) => {
          if (Array.isArray(result)) {

            const selectedProductIds = this.state.product.map(p => p.id);
            const sortedProducts = result
              .map((item, key) => ({ ...item, index: key, source: 'master', is_custom: false, uid: `master:${item.id}` }))
              .sort((a, b) => {
                const aSelected = selectedProductIds.includes(a.id);
                const bSelected = selectedProductIds.includes(b.id);
                return aSelected === bSelected ? 0 : aSelected ? -1 : 1;
              });

            this.setState({
              list_all_prod: sortedProducts,
              filteredProducts: sortedProducts
            }, resolve);
          }
        })
        .catch((error) => {
          if (error.status === 401) {
            this.props.link('/login');
          } else {
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
            reject(error);
          }
        });
    });
  };

  openNewProductModal = () => {
    if (this.state.editData === false) return;
    this.setState({ newProductModalOpen: true, newProductName: '' });
  };

  closeNewProductModal = () => {
    this.setState({ newProductModalOpen: false, newProductName: '', newProductSaving: false });
  };

  onNewProductNameChange = (e) => {
    const v = (e && e.target && e.target.value) ? String(e.target.value) : '';
    this.setState({ newProductName: v.slice(0, 120) });
  };

  saveNewProductCustom = () => {
    const name = (this.state.newProductName || '').trim();
    if (!name) return;
    if (this.state.newProductSaving) return;

    this.setState({ newProductSaving: true });

    const apiUrl = (Config.server + '/product_custom');
    const options = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('access-token-jwt') },
      body: JSON.stringify({ name })
    };

    fetch(apiUrl, options)
      .then((res) => { if (res.status !== 200) throw res; return res.json(); })
      .then((result) => {
        const serverId = Number(result && result.id);
        if (Number.isFinite(serverId) && serverId > 0) {
          const newProd = {
            id: serverId,
            uid: 'custom:' + serverId,
            source: 'custom',
            is_custom: true,
            name: name,
            class: '',
            dosage: '',
            unit: '',
            applicationRate: '',
            toxicClass: ''
          };

          const currentList = Array.isArray(this.state.list_all_prod) ? this.state.list_all_prod.slice() : [];
          const keyMap = new Map();
          for (let p of currentList) keyMap.set(String(p.uid || p.id || p.code || p.name).toLowerCase(), p);
          keyMap.set(String(newProd.uid).toLowerCase(), newProd);
          const mergedList = Array.from(keyMap.values());

          const selected = Array.isArray(this.state.product) ? this.state.product.slice() : [];
          if (!selected.some(p => Number(p.id) === serverId)) selected.push(newProd);

          const filtered = this.applyFilter(this.state.filter, mergedList);

          this.setState({
            list_all_prod: mergedList,
            filteredProducts: filtered,
            product: selected,
            newProductSaving: false,
            newProductModalOpen: false,
            newProductName: ''
          }, () => { this.getProdCustom(); });
        } else {
          this.setState({ newProductSaving: false });
        }
      })
      .catch((error) => {
        if (error && (error.status === 401 || error.status === 403)) {
          this.props.link('/login');
        } else if (error && error.status === 400) {
          error.json().then((errCode) => {
            notification.open({
              message: this.props.res[errCode.code],
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          });
        } else {
          notification.open({
            message: this.props.res.ERRO,
            description: this.props.res.ERRO_MSG,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
        }
        this.setState({ newProductSaving: false });
      });
  };

  getProdCustom = () => {
    const apiUrl = `${Config.server}/product_custom`;
    const options = { method: 'GET', headers: { 'Authorization': localStorage.getItem('access-token-jwt') } };

    return fetch(apiUrl, options)
      .then((res) => { if (res.status !== 200) throw res; return res.json(); })
      .then((result) => {
        if (!Array.isArray(result)) return;

        const customProducts = result.map((item, key) => ({
          ...item,
          id: Number(item.id),
          index: key,
          source: 'custom',
          is_custom: true,
          uid: `custom:${item.id}`
        }));

        const currentList = Array.isArray(this.state.list_all_prod) ? this.state.list_all_prod.slice() : [];
        const map = new Map();
        currentList.forEach(p => map.set(String(p.uid || p.id || p.code || p.name).toLowerCase(), p));
        customProducts.forEach(p => map.set(String(p.uid || p.id || p.code || p.name).toLowerCase(), p));

        const mergedList = Array.from(map.values());
        const filtered = this.applyFilter(this.state.filter, mergedList);

        this.setState({ list_all_prod: mergedList, filteredProducts: filtered });
      })
      .catch((error) => {
        if (error && error.status === 401) this.props.link('/login');
        else {
          notification.open({
            message: this.props.res.ERRO,
            description: this.props.res.ERRO_MSG,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
        }
      });
  };

  applyFilter = (term, list) => {
    const s = String(term || '').toLowerCase().trim();
    if (!s) return list.slice();
    return list.filter(p => String((p && p.name) || '').toLowerCase().indexOf(s) !== -1);
  };

  handleFilterChange = (e) => {
    const term = (e && e.target && e.target.value) ? String(e.target.value) : '';
    const base = Array.isArray(this.state.list_all_prod) ? this.state.list_all_prod : [];
    const filtered = this.applyFilter(term, base);
    this.setState({ filter: term, filteredProducts: filtered, currentPage: 1 });
  };

  getCurrentItems = () => {
    const list = Array.isArray(this.state.filteredProducts) ? this.state.filteredProducts : [];
    const page = Number(this.state.currentPage) || 1;
    const pageSize = Number(this.state.itemsPerPage) || 21;
    const start = (page - 1) * pageSize;
    return list.slice(start, start + pageSize);
  };

  handleProductChange = (product) => {
    if (this.state.editData === false) return;

    const selected = Array.isArray(this.state.product) ? this.state.product.slice() : [];
    const idx = selected.findIndex(p => Number(p.id) === Number(product.id));

    if (idx >= 0) {
      selected.splice(idx, 1);
    } else {
      const base = {
        id: product.id,
        uid: product.uid || ('custom:' + product.id),
        name: product.name,
        class: product.class || '',
        source: product.source || 'master',
        is_custom: product.is_custom === true,
        dosage: product.dosage || '',
        unit: product.unit || '',
        applicationRate: product.applicationRate || '',
        toxicClass: product.class || product.toxicClass || ''
      };
      selected.push(base);
    }

    this.setState({ product: selected });
  };

  renderPaginationControls() {
    const pageCount = Math.ceil(this.state.filteredProducts.length / this.state.itemsPerPage);

    return (
      <div style={{ textAlign: 'center' }}>
        <Button
          onClick={this.prevPage}
          disabled={this.state.currentPage === 1 || this.state.editData === false}
        >
          <ArrowLeftIcon style={{ fontSize: '2rem' }} />
        </Button>
        <Button
          onClick={this.nextPage}
          disabled={this.state.currentPage === pageCount || this.state.editData === false}
        >
          <ArrowRightIcon style={{ fontSize: '2rem' }} />
        </Button>
      </div>
    );
  }

  nextPage = () => {
    this.setState(prevState => ({
      currentPage: prevState.currentPage + 1
    }));
  }

  prevPage = () => {
    this.setState(prevState => ({
      currentPage: prevState.currentPage - 1
    }));
  }

  handleFilterChange = (e) => {
    const filter = e.target.value;
    let filteredProducts;

    if (filter) {
      filteredProducts = this.state.list_all_prod.filter(product =>
        product.name.toLowerCase().includes(filter.toLowerCase())
      );
    } else {
      filteredProducts = this.state.list_all_prod;
    }

    this.setState({ filter, filteredProducts });
  }

  handleProductChange = (product) => {

    this.setState(prevState => {
      const maxProducts = 6;
      const productIndex = prevState.product.findIndex(p => p.id === product.id);
      let newProducts = prevState.product;

      if (productIndex > -1) {
        newProducts = [
          ...prevState.product.slice(0, productIndex),
          ...prevState.product.slice(productIndex + 1)
        ];
      } else {
        if (prevState.product.length < maxProducts) {
          newProducts = [
            ...prevState.product,
            { ...product, class: product.class || '' }
          ];
        } else {
          notification.open({
            message: this.props.res.ATENCAO,
            description: this.props.res.ERRO_MAX_PRODUTO,
            icon: <MaterialIcon icon="error_outline" className="text-danger" />
          });
        }
      }


      return { product: newProducts };
    });
  };

  handleFieldChange = (productId, fieldName, value) => {
    this.setState(prev => ({
      product: (prev.product || []).map(p =>
        Number(p.id) === Number(productId) ? { ...p, [fieldName]: value } : p
      )
    }));
  };

  normalizeUnit = (v) => {
    const s = String(v || '').trim().toLowerCase();
    return s === 'kg' ? 'kg' : (s === 'l' ? 'l' : '');
  };

  handleChangeDetails = (name) => (event) => {
    const { value } = event.target;
    this.setState(prevState => ({
      equipment: {
        ...prevState.equipment,
        details: {
          ...prevState.equipment.details,
          [name]: value
        }
      }
    }));
  };

  renderEquipmentDetailsInput = () => {
    switch (this.state.equipment.type) {
      case 'bicoHidraulicoCoreDisco':
        return (
          <div style={{ display: 'flex' }}>
            <TextField
              id="equipment"
              label="Equipamento"
              style={{ marginTop: '1rem', width: '50%', paddingRight: '1rem' }}
              value={this.state.equipment.name}
              onChange={this.handleChange('name')}
              disabled={!this.state.editData}
            />
            <TextField
              id="core"
              label="Core"
              style={{ marginTop: '1rem', width: '50%', paddingRight: '1rem' }}
              value={this.state.equipment.details ? this.state.equipment.details.core : ''}
              onChange={this.handleChangeDetails('core')}
              disabled={!this.state.editData}
            />
            <TextField
              id="disco"
              label="Disco"
              style={{ marginTop: '1rem', width: '50%', paddingRight: '1rem' }}
              value={this.state.equipment.details ? this.state.equipment.details.disco : ''}
              onChange={this.handleChangeDetails('disco')}
              disabled={!this.state.editData}
            />
            <TextField
              id="angulo"
              label="Ângulo"
              style={{ marginTop: '1rem', width: '50%' }}
              value={this.state.equipment.details ? this.state.equipment.details.angulo : ''}
              onChange={this.handleChangeDetails('angulo')}
              disabled={!this.state.editData}
            />
          </div>
        );
      case 'bicoHidraulicoCeramica':
        return (
          <div style={{ display: 'flex' }}>
            <TextField
              id="equipment"
              label="Equipamento"
              style={{ marginTop: '1rem', width: '50%', paddingRight: '1rem' }}
              value={this.state.equipment.name}
              onChange={this.handleChange('name')}
              disabled={!this.state.editData}
            />
            <TextField
              id="ponta"
              label="Ponta"
              style={{ marginTop: '1rem', width: '50%', paddingRight: '1rem' }}
              value={this.state.equipment.details ? this.state.equipment.details.ponta : ''}
              onChange={this.handleChangeDetails('ponta')}
              disabled={!this.state.editData}
            />
            <TextField
              id="angulo"
              label="Ângulo"
              style={{ marginTop: '1rem', width: '50%' }}
              value={this.state.equipment.details ? this.state.equipment.details.angulo : ''}
              onChange={this.handleChangeDetails('angulo')}
              disabled={!this.state.editData}
            />
          </div>
        );
      case 'atomizadorTela':
        return (
          <div style={{ display: 'flex' }}>
            <TextField
              id="equipment"
              label="Equipamento"
              style={{ marginTop: '1rem', width: '50%', paddingRight: '1rem' }}
              value={this.state.equipment.name}
              onChange={this.handleChange('name')}
              disabled={!this.state.editData}
            />
            <TextField
              id="anguloPa"
              label="Ângulo Pá"
              style={{ marginTop: '1rem', width: '50%', paddingRight: '1rem' }}
              value={this.state.equipment.details ? this.state.equipment.details.anguloPa : ''}
              onChange={this.handleChangeDetails('anguloPa')}
              disabled={!this.state.editData}
            />
            <TextField
              id="malha"
              label="Malha"
              style={{ marginTop: '1rem', width: '50%', paddingRight: '1rem' }}
              value={this.state.equipment.details ? this.state.equipment.details.malha : ''}
              onChange={this.handleChangeDetails('malha')}
              disabled={!this.state.editData}
            />
            <TextField
              id="vru"
              label="VRU"
              style={{ marginTop: '1rem', width: '50%' }}
              value={this.state.equipment.details ? this.state.equipment.details.vru : ''}
              onChange={this.handleChangeDetails('vru')}
              disabled={!this.state.editData}
            />
          </div>
        );
      case 'atomizadorDisco':
        return (
          <div style={{ display: 'flex' }}>
            <TextField
              id="equipment"
              label="Equipamento"
              style={{ marginTop: '1rem', width: '50%', paddingRight: '1rem' }}
              value={this.state.equipment.name}
              onChange={this.handleChange('name')}
              disabled={!this.state.editData}
            />
            <TextField
              id="anguloPa"
              label="Ângulo Pá"
              style={{ marginTop: '1rem', width: '50%', paddingRight: '1rem' }}
              value={this.state.equipment.details ? this.state.equipment.details.anguloPa : ''}
              onChange={this.handleChangeDetails('anguloPa')}
              disabled={!this.state.editData}
            />
            <TextField
              id="vru"
              label="VRU"
              style={{ marginTop: '1rem', width: '50%' }}
              value={this.state.equipment.details ? this.state.equipment.details.vru : ''}
              onChange={this.handleChangeDetails('vru')}
              disabled={!this.state.editData}
            />
          </div>
        );
      case 'bicoHidraulicoSolido':
        return (
          <div style={{ display: 'flex' }}>
            <TextField
              id="equipment"
              label="Equipamento"
              style={{ marginTop: '1rem', width: '50%', paddingRight: '1rem' }}
              value={this.state.equipment.name}
              onChange={this.handleChange('name')}
              disabled={!this.state.editData}
            />
            <TextField
              id="ponta"
              label="Ponta"
              style={{ marginTop: '1rem', width: '50%', paddingRight: '1rem' }}
              value={this.state.equipment.details ? this.state.equipment.details.ponta : ''}
              onChange={this.handleChangeDetails('ponta')}
              disabled={!this.state.editData}
            />
            <TextField
              id="angulo"
              label="Ângulo"
              style={{ marginTop: '1rem', width: '50%' }}
              value={this.state.equipment.details ? this.state.equipment.details.angulo : ''}
              onChange={this.handleChangeDetails('angulo')}
              disabled={!this.state.editData}
            />
          </div>
        );
      case 'bicoHidraulicoPlano':
        return (
          <div style={{ display: 'flex' }}>
            <TextField
              id="equipment"
              label="Equipamento"
              style={{ marginTop: '1rem', width: '50%', paddingRight: '1rem' }}
              value={this.state.equipment.name}
              onChange={this.handleChange('name')}
              disabled={!this.state.editData}
            />
            <TextField
              id="ponta"
              label="Ponta"
              style={{ marginTop: '1rem', width: '50%', paddingRight: '1rem' }}
              value={this.state.equipment.details ? this.state.equipment.details.ponta : ''}
              onChange={this.handleChangeDetails('ponta')}
              disabled={!this.state.editData}
            />
            <TextField
              id="angulo"
              label="Ângulo"
              style={{ marginTop: '1rem', width: '50%' }}
              value={this.state.equipment.details ? this.state.equipment.details.angulo : ''}
              onChange={this.handleChangeDetails('angulo')}
              disabled={!this.state.editData}
            />
          </div>
        );
      case 'cp03tt03':
        return (
          <div style={{ display: 'flex' }}>
            <TextField
              id="equipment"
              label="Equipamento"
              style={{ marginTop: '1rem', width: '50%', paddingRight: '1rem' }}
              value={this.state.equipment.name}
              onChange={this.handleChange('name')}
              disabled={!this.state.editData}
            />
            <TextField
              id="orificio"
              label="Orifício"
              style={{ marginTop: '1rem', width: '50%', paddingRight: '1rem' }}
              value={this.state.equipment.details ? this.state.equipment.details.orificio : ''}
              onChange={this.handleChangeDetails('orificio')}
              disabled={!this.state.editData}
            />
            <TextField
              id="angulo"
              label="Ângulo"
              style={{ marginTop: '1rem', width: '50%' }}
              value={this.state.equipment.details ? this.state.equipment.details.angulo : ''}
              onChange={this.handleChangeDetails('angulo')}
              disabled={!this.state.editData}
            />
          </div>
        );
      case 'cp11tt11':
        return (
          <div style={{ display: 'flex' }}>
            <TextField
              id="equipment"
              label="Equipamento"
              style={{ marginTop: '1rem', width: '50%', paddingRight: '1rem' }}
              value={this.state.equipment.name}
              onChange={this.handleChange('name')}
              disabled={!this.state.editData}
            />
            <TextField
              id="ponta"
              label="Ponta"
              style={{ marginTop: '1rem', width: '50%', paddingRight: '1rem' }}
              value={this.state.equipment.details ? this.state.equipment.details.ponta : ''}
              onChange={this.handleChangeDetails('ponta')}
              disabled={!this.state.editData}
            />
            <TextField
              id="angulo"
              label="Ângulo"
              style={{ marginTop: '1rem', width: '50%' }}
              value={this.state.equipment.details ? this.state.equipment.details.angulo : ''}
              onChange={this.handleChangeDetails('angulo')}
              disabled={!this.state.editData}
            />
          </div>
        );
      case 'cp09tt09':
        return (
          <div style={{ display: 'flex' }}>
            <TextField
              id="equipment"
              label="Equipamento"
              style={{ marginTop: '1rem', width: '50%', paddingRight: '1rem' }}
              value={this.state.equipment.name}
              onChange={this.handleChange('name')}
              disabled={!this.state.editData}
            />
            <TextField
              id="orificio"
              label="Orifício"
              style={{ marginTop: '1rem', width: '50%', paddingRight: '1rem' }}
              value={this.state.equipment.details ? this.state.equipment.details.orificio : ''}
              onChange={this.handleChangeDetails('orificio')}
              disabled={!this.state.editData}
            />
            <TextField
              id="angulo"
              label="Ângulo"
              style={{ marginTop: '1rem', width: '50%' }}
              value={this.state.equipment.details ? this.state.equipment.details.angulo : ''}
              onChange={this.handleChangeDetails('angulo')}
              disabled={!this.state.editData}
            />
          </div>
        );
      case 'outro':
        return (
          <div style={{ display: 'flex' }}>
            <TextField
              id="equipment"
              label="Equipamento"
              style={{ marginTop: '1rem', width: '50%', paddingRight: '1rem' }}
              value={this.state.equipment.name}
              onChange={this.handleChange('name')}
              disabled={!this.state.editData}
            />
            <TextField
              id="ponta"
              label="Ponta"
              style={{ marginTop: '1rem', width: '50%', paddingRight: '1rem' }}
              value={this.state.equipment.details ? this.state.equipment.details.ponta : ''}
              onChange={this.handleChangeDetails('ponta')}
              disabled={!this.state.editData}
            />
            <TextField
              id="angulo"
              label="Ângulo"
              style={{ marginTop: '1rem', width: '50%' }}
              value={this.state.equipment.details ? this.state.equipment.details.angulo : ''}
              onChange={this.handleChangeDetails('angulo')}
              disabled={!this.state.editData}
            />
          </div>
        );
      default:
        return null;
    }
  };

  handleCheckboxChange = (name) => {
    this.setState((prevState) => ({
      applicationConditions: {
        ...prevState.applicationConditions,
        [name]: !prevState.applicationConditions[name]
      }
    }));
  };

  handleInputChange = (name, value) => {
    this.setState((prevState) => ({
      applicationConditions: {
        ...prevState.applicationConditions,
        [name]: value
      }
    }));
  };

  handleDateChange = (date, field) => {
    this.setState(prevState => ({
      applicationConditions: {
        ...prevState.applicationConditions,
        [field]: date
      }
    }));
  };

  handleTypeServiceChange = (name) => {
    this.setState((prevState) => ({
      type_service: {
        ...prevState.type_service,
        [name]: !prevState.type_service[name]
      }
    }));
  };

  handleOpenModal = () => {
    this.setState({ openModal: true });
  };

  handleCloseModal = () => {
    this.setState({ openModal: false });
  };

  getStatusDetails = (part) => {
    if (part.assinado && part.assinado.created) {
      return { icon: <CheckCircleIcon style={{ color: 'limegreen' }} />, etapa: 'Assinado', date: part.assinado.created };
    } else if (part.rejeitado && Object.keys(part.rejeitado).length > 0) {
      return { icon: <CancelIcon style={{ color: 'red' }} />, etapa: 'Rejeitado', date: part.rejeitado.created };
    } else if (part.visualizado && Object.keys(part.visualizado).length > 0) {
      return { icon: <VisibilityIcon style={{ color: 'gold' }} />, etapa: 'Visualizado', date: part.visualizado.created };
    } else if (part.mail && part.mail.sent) {
      return { icon: <EmailIcon />, etapa: 'Enviado', date: part.mail.sent };
    } else {
      return { icon: null, etapa: 'Indefinido', date: null };
    }
  };

  getNameFromEmail = (email) => {
    if (email === this.state.contractorEmail) return this.state.contractor;
    if (email === this.state.pilotEmail) return this.state.pilot;
    if (email === this.state.engineerEmail) return this.state.agricultural_engineer;
    if (email === this.state.executorEmail) return this.state.executor;
    if (email === this.state.responsibleTechnicianEmail) return this.state.responsibleTechnician;

    return 'Nome não disponível';
  };

  getFunctionFromEmail = (email) => {
    if (email === this.state.contractorEmail) return 'Contratante';
    if (email === this.state.pilotEmail) return 'Piloto';
    if (email === this.state.engineerEmail) return 'Eng. Agrônomo';
    if (email === this.state.executorEmail) return 'Executor';
    if (email === this.state.responsibleTechnicianEmail) return 'Responsável Técnico';

    return 'Função não disponível';
  };

  handleDeleteSignature = () => {
    const apiUrl = Config.server + `/signature/${this.state.documentId}`;
    const formData = new URLSearchParams();
    let descr = '';

    formData.append('id_document', this.state.documentId);
    descr = this.props.res.ITEM_EXCLUIDO;

    const options = {
      method: 'DELETE',
      body: formData,
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    };

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.json();
      })
      .then(
        (result) => {
          this.setState({ documentId: '', })
          this.handleDelete();
        },
        (error) => {
          console.log(error);
        }
      );
  };

  handleDelete = () => {
    const documentGuid = this.normalizeDocumentValue(this.state.documentGuid);

    if (!documentGuid) {
      notification.open({
        message: this.props.res.ERRO,
        description: this.props.res.ERRO_MSG,
        icon: <MaterialIcon icon="error" className="text-danger" />
      });
      return;
    }

    const apiUrl = Config.server + `/document/${documentGuid}`;
    const formData = new URLSearchParams();
    let descr = '';

    formData.append('fileGuid', documentGuid);
    descr = this.props.res.ITEM_EXCLUIDO;

    const options = {
      method: 'DELETE',
      body: formData,
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    };

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.json();
      })
      .then(
        (result) => {
          notification.open({
            message: this.props.res.SUCESSO,
            description: descr,
            icon: <MaterialIcon icon="check_circle" className="text-success" />
          });
          this.setState({ documentData: {}, documentGuid: '', documentId: '', fileSigned: '' })
          this.handleClose();
          this.handleCloseModal();
        },
        (error) => {
          if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 401 || error.status === 403) {
            this.props.link('/login');
          } else {
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
          this.handleClose();
        }
      );
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  downloadReportSigned = () => {
    const fileSigned = this.normalizeDocumentValue(this.state.fileSigned);

    if (fileSigned) {
      const anchor = document.createElement('a');
      anchor.href = fileSigned;
      anchor.target = '_blank';
      document.body.appendChild(anchor);
      anchor.click();
      anchor.remove();
      return;
    }

    notification.open({
      message: this.props.res.ERRO,
      description: this.props.res.ERRO_MSG,
      icon: <MaterialIcon icon="error" className="text-danger" />
    });
  };

  downloadReportMapaOnly = async () => {
    const culture = this.props.res.LINGUA;
    const apiUrlGen = Config.server + '/relmapa';

    const formData = new URLSearchParams();
    formData.append('data', JSON.stringify(this.state.jobReport));
    formData.append('signature', this.state.responsibleTechnicianSignature);
    formData.append('type', 'relmapa');
    formData.append('culture', culture);
    formData.append('id', this.state.id);
    formData.append('arrFuel', JSON.stringify(this.state.arrFuel));
    formData.append('percSize', this.state.percSize);
    formData.append('applicationGuide', this.state.applicationGuide);
    formData.append('logo', this.state.logo);
    formData.append('path', this.state.path);
    formData.append('map', this.state.map);
    formData.append('application', this.state.application);

    try {
      const response = await fetch(apiUrlGen, {
        method: 'POST',
        body: formData,
        headers: { 'Authorization': localStorage.getItem('access-token-jwt') }
      });

      if (response.status !== 200) throw response;

      const contentType = response.headers.get('content-type') || '';
      let blob = null;

      if (contentType.indexOf('application/json') !== -1) {
        const result = await response.json();
        const pdfData = result && result.pdfData ? result.pdfData : null;

        if (pdfData) {
          blob = this.base64ToBlob(pdfData);
        }
      } else {
        blob = await response.blob();
      }

      if (!(blob && blob.type === 'application/pdf' && blob.size > 0)) {
        throw new Error('PDF inválido');
      }

      const fileName = (this.state.title || 'Relatorio-MAPA').replace(/[\/\:\.\!]/g, '-');
      const blobUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = `${fileName}-Relatorio-MAPA.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      notification.open({
        message: this.props.res.ERRO,
        description: this.props.res.ERRO_MSG,
        icon: <MaterialIcon icon="error" className="text-danger" />
      });
    }
  };

  downloadReportDocument = () => {
    const partes = (this.state.documentData && Array.isArray(this.state.documentData.partes)) ? this.state.documentData.partes : [];
    const allSigned = partes.length > 0 && partes.every(part => part.assinado && part.assinado.created);

    if (allSigned) {
      this.downloadReportSigned();
      return;
    }

    this.downloadReportMapaOnly();
  };

  initialize = () => {
    this.mymap = L.map('mapid', {
      zoomControl: false,
      attributionControl: false,
    }).setView(Config.place, 14);

    this.mymap.dragging.disable();
    this.mymap.scrollWheelZoom.disable();
    this.mymap.doubleClickZoom.disable();
    this.mymap.boxZoom.disable();
    this.mymap.keyboard.disable();
    this.mymap.touchZoom.disable();
    if (this.mymap.tap) this.mymap.tap.disable();

    L.tileLayer(Config.tile_google, Config.tile_google_config).addTo(this.mymap);
    L.control.scale({ imperial: false }).addTo(this.mymap);

    this.featureGroupL = L.featureGroup().addTo(this.mymap);
    this.featureGroupP = L.featureGroup().addTo(this.mymap);
    this.featureGroupPoly = L.featureGroup().addTo(this.mymap);
    this.featureGroupPM = L.featureGroup().addTo(this.mymap);

    const resizeObserver = new ResizeObserver(() => {
      this.mymap.invalidateSize();
    });
    resizeObserver.observe(document.getElementById('mapid'));

    new L.Control.Draw({
      draw: {
        polyline: false,
        polygon: false,
        circle: false,
        rectangle: false,
        marker: false,
        circlemarker: false
      },
      edit: false
    }).addTo(this.mymap);

    this.mymap.on('click', () => {
      this.handleClickAplMap();
    });

    const customControl = L.control({ position: 'topright' });
    customControl.onAdd = () => {
      const button = L.DomUtil.create('div', 'leaflet-bar leaflet-control leaflet-control-custom');
      button.style.width = '34px';
      button.style.height = '34px';
      button.style.cursor = 'pointer';
      button.style.display = 'flex';
      button.style.justifyContent = 'center';
      button.style.alignItems = 'center';
      button.style.border = '1px solid #ccc';
      button.style.backgroundColor = 'palegreen';
      button.title = 'Trajeto Voo Exibido';

      const svgIcon = document.createElement('div');
      svgIcon.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800" fill="#343a40" style="width: 24px; height: 24px;">
        <path d="M 0 156.81 L 0 0 L 65.28 0 L 125.41 103.72 L 243.59 87.54 C 260.71 67.18 282.02 49.29 307.72 33.88 C 333.41 18.46 354.72 10.66 371.85 10.66  L 381.93 10.66 C 395.25 10.28 409.14 19.04 423.8 36.54 C 438.26 54.24 448.73 67.56 455.58 76.51 L 734.36 95.92 L 734.36 21.32 L 753.2 21.32 L 753.2  116.66 C 757.39 116.66 762.34 117.61 768.62 119.7 C 774.71 121.8 777.75 123.89 777.75 126.17 C 777.75 128.65 774.71 132.07 768.62 136.45 C 762.34  140.64 757.58 142.73 753.77 142.73 L 753.77 242.06 L 734.74 242.06 L 734.74 168.99 L 569.18 208 L 569.18 251.01 C 583.46 256.15 590.5 266.23 590.5  281.08 C 590.5 302.58 579.84 313.43 558.72 313.43 C 537.02 313.43 526.37 302.58 526.37 281.08 C 526.37 265.47 533.98 255.19 549.2 250.44 L 549.2 210.29  L 501.82 225.89 L 384.78 225.89 L 0 156.81 Z M 23.98 430.46 C 23.98 416.38 30.83 409.34 44.53 409.34 C 58.81 409.34 65.85 416.38 65.85 430.46 C 65.85  444.16 58.81 451.2 44.53 451.2 C 30.83 451.2 23.98 444.16 23.98 430.46 Z M 26.83 579.27 C 26.83 565.19 33.88 558.15 47.96 558.15 C 61.66 558.15 68.51  565.19 68.51 579.27 C 68.51 593.16 61.66 600.01 47.96 600.01 C 33.88 600.01 26.83 593.16 26.83 579.27 Z M 65.85 652.92 C 65.85 639.22 72.89 632.37  86.97 632.37 C 100.67 632.37 107.71 639.22 107.71 652.92 C 107.71 667 100.67 674.04 86.97 674.04 C 72.89 674.04 65.85 667 65.85 652.92 Z M 66.42 504.11  C 66.42 490.02 73.46 482.98 87.54 482.98 C 101.24 482.98 108.09 490.02 108.09 504.11 C 108.09 517.81 101.24 524.66 87.54 524.66 C 73.46 524.66 66.42  517.81 66.42 504.11 Z M 106.57 430.46 C 106.57 416.38 113.61 409.34 127.69 409.34 C 141.39 409.34 148.24 416.38 148.24 430.46 C 148.24 444.16 141.39  451.2 127.69 451.2 C 113.61 451.2 106.57 444.16 106.57 430.46 Z M 109.23 579.27 C 109.23 565.19 116.28 558.15 130.55 558.15 C 144.25 558.15 151.1  565.19 151.1 579.27 C 151.1 593.16 144.25 600.01 130.55 600.01 C 116.28 600.01 109.23 593.16 109.23 579.27 Z M 148.24 652.92 C 148.24 639.22 155.29  632.37 169.56 632.37 C 183.26 632.37 190.11 639.22 190.11 652.92 C 190.11 667 183.26 674.04 169.56 674.04 C 155.29 674.04 148.24 667 148.24 652.92  Z M 149.39 504.11 C 149.39 490.02 156.24 482.98 170.13 482.98 C 183.83 482.98 190.68 490.02 190.68 504.11 C 190.68 517.81 183.83 524.66 170.13 524.66  C 156.24 524.66 149.39 517.81 149.39 504.11 Z M 151.1 355.86 C 151.1 341.97 157.95 335.12 171.65 335.12 C 185.92 335.12 192.97 341.97 192.97 355.86  C 192.97 369.95 185.92 376.99 171.65 376.99 C 157.95 376.99 151.1 369.95 151.1 355.86 Z M 188.97 430.46 C 188.97 416.38 196.01 409.34 210.28 409.34  C 223.98 409.34 230.83 416.38 230.83 430.46 C 230.83 444.16 223.98 451.2 210.28 451.2 C 196.01 451.2 188.97 444.16 188.97 430.46 Z M 192.39 579.27  C 192.39 565.19 199.25 558.15 212.95 558.15 C 226.65 558.15 233.69 565.19 233.69 579.27 C 233.69 593.16 226.65 600.01 212.95 600.01 C 199.25 600.01  192.39 593.16 192.39 579.27 Z M 231.41 652.92 C 231.41 639.22 238.26 632.37 251.96 632.37 C 266.23 632.37 273.27 639.22 273.27 652.92 C 273.27 667 266.23  674.04 251.96 674.04 C 238.26 674.04 231.41 667 231.41 652.92 Z M 231.98 504.11 C 231.98 490.02 238.83 482.98 252.53 482.98 C 266.61 482.98 273.84 490.02  273.84 504.11 C 273.84 517.81 266.61 524.66 252.53 524.66 C 238.83 524.66 231.98 517.81 231.98 504.11 Z M 233.69 355.86 C 233.69 341.97 240.54 335.12  254.24 335.12 C 268.32 335.12 275.36 341.97 275.36 355.86 C 275.36 369.95 268.32 376.99 254.24 376.99 C 240.54 376.99 233.69 369.95 233.69 355.86 Z M  272.13 430.46 C 272.13 416.38 278.98 409.34 292.68 409.34 C 306.76 409.34 313.81 416.38 313.81 430.46 C 313.81 444.16 306.76 451.2 292.68 451.2 C 278.98  451.2 272.13 444.16 272.13 430.46 Z M 274.79 579.27 C 274.79 565.19 281.83 558.15 295.54 558.15 C 309.62 558.15 316.66 565.19 316.66 579.27 C 316.66 593.16  309.62 600.01 295.54 600.01 C 281.83 600.01 274.79 593.16 274.79 579.27 Z M 277.08 284.5 C 277.08 270.23 283.93 263.19 297.82 263.19 C 311.9 263.19 318.94  270.23 318.94 284.5 C 318.94 298.2 311.9 305.05 297.82 305.05 C 283.93 305.05 277.08 298.2 277.08 284.5 Z M 313.81 652.92 C 313.81 639.22 321.04 632.37  335.12 632.37 C 348.82 632.37 355.67 639.22 355.67 652.92 C 355.67 667 348.82 674.04 335.12 674.04 C 321.04 674.04 313.81 667 313.81 652.92 Z M 314.38  504.11 C 314.38 490.02 321.61 482.98 335.69 482.98 C 349.39 482.98 356.24 490.02 356.24 504.11 C 356.24 517.81 349.39 524.66 335.69 524.66 C 321.61 524.66  314.38 517.81 314.38 504.11 Z M 316.09 355.86 C 316.09 341.97 323.13 335.12 337.4 335.12 C 351.1 335.12 357.95 341.97 357.95 355.86 C 357.95 369.95 351.1  376.99 337.4 376.99 C 323.13 376.99 316.09 369.95 316.09 355.86 Z M 345.58 76.51 L 418.66 76.51 L 382.5 39.21 L 345.58 39.21 L 345.58 76.51 Z M 354.53  430.46 C 354.53 416.38 361.38 409.34 375.27 409.34 C 389.35 409.34 396.39 416.38 396.39 430.46 C 396.39 444.16 389.35 451.2 375.27 451.2 C 361.38 451.2  354.53 444.16 354.53 430.46 Z M 357.38 579.27 C 357.38 565.19 364.42 558.15 378.51 558.15 C 392.4 558.15 399.25 565.19 399.25 579.27 C 399.25 593.16 392.4  600.01 378.51 600.01 C 364.42 600.01 357.38 593.16 357.38 579.27 Z M 359.67 284.5 C 359.67 270.23 366.71 263.19 380.79 263.19 C 394.49 263.19 401.34 270.23  401.34 284.5 C 401.34 298.2 394.49 305.05 380.79 305.05 C 366.71 305.05 359.67 298.2 359.67 284.5 Z M 369.18 143.87 C 387.26 149.58 405.53 152.82 423.99  153.96 C 442.44 155.1 461.1 155.67 480.12 155.67 C 498.58 155.29 516.85 154.34 534.74 152.82 C 552.44 151.29 570.13 147.3 587.64 140.64 C 568.99 134.93  550.73 131.31 532.65 129.79 C 514.76 128.08 496.87 126.74 479.55 126.17 C 432.36 128.65 395.44 134.55 369.18 143.87 Z M 396.96 504.11 C 396.96 490.02 404.01  482.98 418.09 482.98 C 431.98 482.98 438.83 490.02 438.83 504.11 C 438.83 517.81 431.98 524.66 418.09 524.66 C 404.01 524.66 396.96 517.81 396.96 504.11 Z  M 398.68 355.86 C 398.68 341.97 405.72 335.12 419.8 335.12 C 433.5 335.12 440.54 341.97 440.54 355.86 C 440.54 369.95 433.5 376.99 419.8 376.99 C 405.72  376.99 398.68 369.95 398.68 355.86 Z M 437.12 430.46 C 437.12 416.38 444.16 409.34 458.24 409.34 C 472.13 409.34 478.98 416.38 478.98 430.46 C 478.98 444.16  472.13 451.2 458.24 451.2 C 444.16 451.2 437.12 444.16 437.12 430.46 Z M 442.06 284.5 C 442.06 270.23 449.11 263.19 463.38 263.19 C 477.08 263.19 483.93  270.23 483.93 284.5 C 483.93 298.2 477.08 305.05 463.38 305.05 C 449.11 305.05 442.06 298.2 442.06 284.5 Z" />
      </svg>`;
      svgIcon.style.marginTop = '0.2rem';
      button.appendChild(svgIcon);

      button.onclick = () => {
        if (!this.state.editData) return;

        if (this.state.path) {
          this.mymap.removeLayer(this.featureGroupL);
          button.style.backgroundColor = 'white';
          button.title = 'Trajeto Voo Removido';
        } else {
          this.featureGroupL.addTo(this.mymap);
          this.featureGroupPoly.bringToFront();
          this.featureGroupP.bringToFront();
          button.style.backgroundColor = 'palegreen';
          button.title = 'Trajeto Voo Exibido';
        }

        this.setState({ path: !this.state.path });
      };

      if (!this.state.editData) {
        button.style.opacity = '0.5';
        button.style.pointerEvents = 'none';
        button.title = 'Edição desabilitada';
      }

      L.DomEvent.disableClickPropagation(button);
      return button;
    };
    customControl.addTo(this.mymap);
  };

  checkTask = async (idTask) => {
    const apiUrl = Config.server + '/getResult/' + idTask;
    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt'),
      },
    };

    let result;
    try {
      const response = await fetch(apiUrl, options);
      result = await Calls.toJSON(response.headers.get('content-length'), response.body,
        (loaded, length) => {
          this.setState({ progressValue: (100 * loaded / length).toFixed() });
        });
    } catch (error) {
      notification.open({
        message: this.props.res.ERRO,
        description: this.props.res.ERRO_MSG,
        icon: <MaterialIcon icon="error" className="text-danger" />
      });
      return;
    }

    try {
      const parsedResult = JSON.parse(result);
      if (parsedResult && parsedResult.code) {
        notification.open({
          message: this.props.res.ARQUIVO_INVALIDO,
          icon: <MaterialIcon icon="error" className="text-danger" />
        });
        return;
      }

      this.useData(parsedResult);
    } catch (e) {
      notification.open({
        message: this.props.res.ARQUIVO_INVALIDO,
        description: this.props.res.ERRO_MSG,
        icon: <MaterialIcon icon="error" className="text-danger" />
      });
    }
  };

  useData = (result) => {
    if (result && result.linha) {
      if (!this.featureGroupL || !this.featureGroupPoly || !this.featureGroupP) {
        return;
      }

      this.featureGroupL.eachLayer(layer => this.featureGroupL.removeLayer(layer));
      this.featureGroupPoly.eachLayer(layer => this.featureGroupPoly.removeLayer(layer));
      this.featureGroupP.eachLayer(layer => this.featureGroupP.removeLayer(layer));

      result.polygons.forEach(poly => {
        this.polyMap(poly, result.title, result.aeronavePrefix);
      });

      this.pathMap(result.linha);

      result.apl.aplicacao.forEach(element => {
        this.aplMapCorrect(element);
      });

      if (result.polygons.length > 0) {
        this.mymap.fitBounds(this.featureGroupPoly.getBounds());
      }

      this.setState({ arrFuel: result.fuel.arrFuel, percSize: result.perc ? result.perc : 100, })
    } else {
      notification.open({
        message: this.props.res.ERRO,
        description: this.props.res.ERRO_MSG,
        icon: <MaterialIcon icon="error" className="text-danger" />
      });
    }
  };

  pathMap = (lineData) => {
    if (!lineData || !lineData.geometry || !lineData.geometry.coordinates || lineData.geometry.coordinates.length < 2) {
      return;
    }

    const pathStyle = {
      color: '#d0d0d0',
      weight: 1,
      opacity: 1,
      smoothFactor: 1,
      className: 'caminho'
    };

    const geoJSONLine = {
      type: "Feature",
      geometry: {
        type: "LineString",
        coordinates: lineData.geometry.coordinates,
      }
    };

    if (!this.featureGroupL) {
      return;
    }

    let lineLayer = L.geoJSON(geoJSONLine, { style: pathStyle });
    lineLayer.addTo(this.featureGroupL);
    if (this.mymap) {
      this.mymap.fitBounds(this.featureGroupL.getBounds());
      this.mymap.invalidateSize();
    }
  };

  polyMap = (poly, jobTitle, aeronavePrefix, index = 0) => {
    if (!poly || !poly.poly) return;

    const color_x = '#ff002b';
    let myStyle = {
      color: '#47839e',
      weight: 1,
      opacity: 0.5,
      fillColor: '#FF1493',
      fillOpacity: 0.7,
      className: 'area'
    };

    if (poly.type === 'X') {
      myStyle.color = color_x;
      myStyle.fillColor = color_x;
    }

    const layer = L.geoJSON(poly.poly, { style: myStyle });
    layer.bindTooltip(jobTitle + ` - ${aeronavePrefix}`, {
      permanent: true,
      direction: "center",
      className: 'tool-tip-L tool-tip-size10-L'
    });
    layer.addTo(this.featureGroupPoly);

    let a = null, b = null;

    if (poly.abData && poly.abData.pointA && poly.abData.pointA.geometry && poly.abData.pointA.geometry.coordinates) {
      a = poly.abData.pointA.geometry.coordinates;
    }
    if (poly.abData && poly.abData.pointB && poly.abData.pointB.geometry && poly.abData.pointB.geometry.coordinates) {
      b = poly.abData.pointB.geometry.coordinates;
    }

    if ((!a || !b) && poly.ABs) {
      try {
        const abArr = (typeof poly.ABs === 'string') ? JSON.parse(poly.ABs) : poly.ABs;
        if (abArr && abArr.length >= 2) { a = abArr[0]; b = abArr[1]; }
      } catch (e) { }
    }

    if (!a || !b) return;
    if (a[0] === b[0] && a[1] === b[1]) return;

    const toRad = v => v * Math.PI / 180;
    const norm360 = deg => { let d = deg % 360; if (d < 0) d += 360; return d; };
    const bearing = (lon1, lat1, lon2, lat2) => {
      const φ1 = toRad(lat1), φ2 = toRad(lat2), Δλ = toRad(lon2 - lon1);
      const y = Math.sin(Δλ) * Math.cos(φ2);
      const x = Math.cos(φ1) * Math.sin(φ2) - Math.sin(φ1) * Math.cos(φ2) * Math.cos(Δλ);
      return norm360(Math.atan2(y, x) * 180 / Math.PI);
    };

    const angleDeg = (poly.abData && typeof poly.abData.bearing === 'number')
      ? norm360(poly.abData.bearing)
      : bearing(a[0], a[1], b[0], b[1]);

    const getDirection = deg => {
      const directions = [
        { label: 'N', min: 348.75, max: 360 }, { label: 'N', min: 0, max: 11.25 },
        { label: 'NNE', min: 11.25, max: 33.75 }, { label: 'NE', min: 33.75, max: 56.25 },
        { label: 'ENE', min: 56.25, max: 78.75 }, { label: 'L', min: 78.75, max: 101.25 },
        { label: 'ESE', min: 101.25, max: 123.75 }, { label: 'SE', min: 123.75, max: 146.25 },
        { label: 'SSE', min: 146.25, max: 168.75 }, { label: 'S', min: 168.75, max: 191.25 },
        { label: 'SSO', min: 191.25, max: 213.75 }, { label: 'SO', min: 213.75, max: 236.25 },
        { label: 'OSO', min: 236.25, max: 258.75 }, { label: 'O', min: 258.75, max: 281.25 },
        { label: 'ONO', min: 281.25, max: 303.75 }, { label: 'NO', min: 303.75, max: 326.25 },
        { label: 'NNO', min: 326.25, max: 348.75 }
      ];
      for (let i = 0; i < directions.length; i++) {
        const d = directions[i];
        if (deg >= d.min && deg < d.max) return d.label;
      }
      return 'N/A';
    };

    const direction = getDirection(angleDeg);
    this.setState(prev => {
      const current = prev.flight_direction || [];
      for (let i = 0; i < current.length; i++) { if (current[i] === direction) return null; }
      return { flight_direction: current.concat([direction]) };
    });

    const arrowSvg = `
  <div style="position:relative;z-index:9999;width:36px;height:36px;display:flex;align-items:center;justify-content:center;">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="36" height="36" style="transform: rotate(${angleDeg - 90}deg);">
      <path d="M4 11h12.17l-4.88-4.88L13.7 5.7 20 12l-6.3 6.3-1.41-1.41 4.88-4.88H4z" fill="orange" stroke="orange" stroke-width="2" stroke-linejoin="round"/>
    </svg>
  </div>
`;

    const arrowIcon = L.divIcon({ html: arrowSvg, iconSize: [36, 36], iconAnchor: [18, 18], className: '' });
    const latlng = L.latLng(a[1], a[0]);
    L.marker(latlng, { icon: arrowIcon }).addTo(this.featureGroupPoly);
  };

  addFlightPathToMap = (ABs) => {
    if (!ABs || !Array.isArray(ABs) || ABs.length < 2) {
      return;
    }

    const pathCoordinates = ABs.map(point => [point.lat, point.lng]);

    const pathStyle = {
      color: '#ffffff',
      weight: 3,
      opacity: 0.8,
    };

    const flightPath = L.polyline(pathCoordinates, pathStyle);
    flightPath.addTo(this.featureGroupP);

    flightPath.bindPopup("<b>Trajeto da Aeronave</b>");
  };

  aplMapCorrect = (poly) => {
    let myStyle = {
      color: '#32a852',
      fillOpacity: .9,
      opacity: 0,
      className: 'aplicacao'
    };

    const pop =
      '<b>' + this.props.res.TIRO + ': ' + poly.title + '</b><br> '
      + this.props.res.LARGURA_FAIXA + ': ' + Units.formatValue(Units.convertLength(poly.faixa, 'm', this.props.res), this.props.res, 1) + ' ' + Units.getLengthUnit(this.props.res) + '<br> '
      + this.props.res.COMPRIMENTO + ': ' + Units.formatValue(Units.convertLength(poly.comprimento, 'm', this.props.res), this.props.res, 1) + ' ' + Units.getLengthUnit(this.props.res) + '<br> '
      + this.props.res.AREA + ': ' + Units.formatValue(Units.convertArea(poly.area, 'ha', this.props.res), this.props.res, 1) + ' ' + Units.getAreaUnit(this.props.res) + '<br> '
      + this.props.res.VOLUME + ': ' + Units.formatValue(Units.convertVolume(poly.volume, 'L', this.props.res), this.props.res, 1) + ' ' + Units.getVolumeUnit(this.props.res, 'L') + '<br> '
      + this.props.res.FLUXO_MEDIO + ': ' + Units.formatValue(Units.convertFlow(poly.fMedio, 'L', 'ha', this.props.res), this.props.res, 1) + ' ' + Units.getFlowUnit(this.props.res);

    let myLayer = L.geoJSON(poly.poly, { style: myStyle });
    myLayer.on("click", () => { this.handleClickAplMap(myLayer); });
    myLayer.bindPopup(pop);
    myLayer.addTo(this.featureGroupP);

    if (poly.abData && poly.abData.ABs) {
      this.addFlightPathToMap(poly.abData.ABs);
    }
  };

  handleClickAplMap = (layer) => {
    this.featureGroupP.eachLayer((item) => {
      item.setStyle({ color: '#32a852' });
    });
    if (layer) {
      layer.setStyle({ color: '#25c450' });
    }
  };

  listPolygonData = async () => {
    const apiUrl = `${Config.server}/polygon_climate/${this.state.id}`;

    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    };

    try {
      const res = await fetch(apiUrl, options);
      if (res.status !== 200) throw res;

      const result = await res.json();

      if (!result || result.length === 0) {
        return [];
      }

      const startItem = result.reduce((prev, current) => {
        return new Date(prev.startDate) < new Date(current.startDate) ? prev : current;
      });

      const endItem = result.reduce((prev, current) => {
        return new Date(prev.endDate) > new Date(current.endDate) ? prev : current;
      });

      const startHour = new Date(startItem.startDate).getHours();
      const endHour = new Date(endItem.endDate).getHours();

      const isStartMorning = startHour < 12;
      const isEndMorning = endHour < 12;

      const updatedConditions = {
        ...this.state.applicationConditions,
        data: new Date(startItem.startDate).toISOString().split('T')[0],

        temperaturaMatutino: isStartMorning || isEndMorning,
        temperaturaInicialMatutino: isStartMorning ? (startItem.temperatureStart || '') : '',
        temperaturaFinalMatutino: isEndMorning ? (endItem.temperatureEnd || '') : '',
        umidadeMatutino: isStartMorning || isEndMorning,
        umidadeInicialMatutino: isStartMorning ? (startItem.humidityStart || '') : '',
        umidadeFinalMatutino: isEndMorning ? (endItem.humidityEnd || '') : '',
        velocidadeMatutino: isStartMorning || isEndMorning,
        velocidadeInicialMatutino: isStartMorning ? (startItem.windSpeedStart ? (parseFloat(startItem.windSpeedStart) * 3.6).toFixed(2) : '') : '',
        velocidadeFinalMatutino: isEndMorning ? (endItem.windSpeedEnd ? (parseFloat(endItem.windSpeedEnd) * 3.6).toFixed(2) : '') : '',
        horarioMatutino: isStartMorning || isEndMorning,
        horarioInicialMatutino: isStartMorning ? Moment(startItem.startDate).format("HH:mm") : '',
        horarioFinalMatutino: isEndMorning ? Moment(endItem.endDate).format("HH:mm") : '',

        temperaturaVespertino: !isStartMorning || !isEndMorning,
        temperaturaInicialVespertino: !isStartMorning ? (startItem.temperatureStart || '') : '',
        temperaturaFinalVespertino: !isEndMorning ? (endItem.temperatureEnd || '') : '',
        umidadeVespertino: !isStartMorning || !isEndMorning,
        umidadeInicialVespertino: !isStartMorning ? (startItem.humidityStart || '') : '',
        umidadeFinalVespertino: !isEndMorning ? (endItem.humidityEnd || '') : '',
        velocidadeVespertino: !isStartMorning || !isEndMorning,
        velocidadeInicialVespertino: !isStartMorning ? (startItem.windSpeedStart ? (parseFloat(startItem.windSpeedStart) * 3.6).toFixed(2) : '') : '',
        velocidadeFinalVespertino: !isEndMorning ? (endItem.windSpeedEnd ? (parseFloat(endItem.windSpeedEnd) * 3.6).toFixed(2) : '') : '',
        horarioVespertino: !isStartMorning || !isEndMorning,
        horarioInicialVespertino: !isStartMorning ? Moment(startItem.startDate).format("HH:mm") : '',
        horarioFinalVespertino: !isEndMorning ? Moment(endItem.endDate).format("HH:mm") : '',
      };

      this.setState({ applicationConditions: updatedConditions });

      return result;
    } catch (error) {
      if (error.status === 405) {
        notification.open({
          message: this.props.res.PERMISSAO,
          description: this.props.res.PERMISSAO_MSG,
          icon: <MaterialIcon icon="error" className="text-danger" />
        });
      } else if (error.status === 401 || error.status === 403) {
        this.props.link('/login');
      } else {
        notification.open({
          message: this.props.res.ERRO,
          description: this.props.res.ERRO_MSG,
          icon: <MaterialIcon icon="error" className="text-danger" />
        });
      }

      return [];
    }
  };

  readCustomers = () => {
    const apiUrl = Config.server + '/customer';
    const options = {
      method: 'GET',
      headers: { 'Authorization': localStorage.getItem('access-token-jwt') }
    };

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        return res.json();
      })
      .then((result) => {
        const clients = Array.isArray(result) ? result : [];

        this.setState({ clients }, () => {
          const contractor = this.state.contractor || '';

          if (!contractor) {
            this.setState({
              contractorSelect: '',
              showCustomContractor: false
            });
            return;
          }

          const selectedClient = clients.find(client => client && String(client.name) === String(contractor));

          if (!selectedClient) {
            this.setState({
              contractorSelect: 'noRegister',
              showCustomContractor: true
            });
            return;
          }

          const streetNumber = (selectedClient.logradouro ? selectedClient.logradouro : '') + (selectedClient.numero ? (selectedClient.logradouro ? ', ' : '') + String(selectedClient.numero) : '');
          let address = streetNumber;
          if (selectedClient.bairro) address = (address ? address + ' - ' : '') + selectedClient.bairro;
          if (!address && selectedClient.address) address = selectedClient.address;

          this.setState({
            contractorSelect: selectedClient.name,
            contractor: selectedClient.name,
            showCustomContractor: false,
            id_client: selectedClient.id || '',
            cpf_cnpj: selectedClient.cpf_cnpj || '',
            contractorEmail: selectedClient.email ? String(selectedClient.email).toLowerCase() : '',
            city: (this.state.areaLocation && this.state.areaLocation.city) || selectedClient.localidade || '',
            address: (this.state.areaLocation && this.state.areaLocation.address) || address || '',
            uf: (this.state.areaLocation && this.state.areaLocation.uf) || selectedClient.uf || ''
          });
        });
      })
      .catch((error) => {
        if (error.status === 405) {
          notification.open({
            message: this.props.res.PERMISSAO,
            description: this.props.res.PERMISSAO_MSG,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
        } else if (error.status === 401 || error.status === 403) {
          this.props.link('/login');
        }
      });
  };

  handleContractorSelectChange = (e) => {
    const name = e.target.value;
    const clients = Array.isArray(this.state.clients) ? this.state.clients : [];

    if (name === 'noRegister') {
      this.setState({
        contractorSelect: 'noRegister',
        showCustomContractor: true,
        contractor: '',
        id_client: '',
        id_property: '',
        selectedPropertyId: '',
        property: '',
        jobProperty: [],
        list_properties: [],
        showCustomProperty: true,
        cpf_cnpj: '',
        contractorEmail: '',
        city: (this.state.areaLocation && this.state.areaLocation.city) || '',
        address: (this.state.areaLocation && this.state.areaLocation.address) || '',
        uf: (this.state.areaLocation && this.state.areaLocation.uf) || ''
      });
      return;
    }

    const selectedClient = clients.find(client => client && String(client.name) === String(name));

    const streetNumber = (selectedClient && selectedClient.logradouro ? selectedClient.logradouro : '') + (selectedClient && selectedClient.numero ? (selectedClient.logradouro ? ', ' : '') + String(selectedClient.numero) : '');
    let address = streetNumber;
    if (selectedClient && selectedClient.bairro) address = (address ? address + ' - ' : '') + selectedClient.bairro;
    if (!address && selectedClient && selectedClient.address) address = selectedClient.address;

    this.setState({
      contractorSelect: name,
      contractor: name,
      showCustomContractor: false,
      id_client: selectedClient && selectedClient.id ? selectedClient.id : '',
      id_property: '',
      selectedPropertyId: '',
      selectedPropertyIds: [],
      property: '',
      jobProperty: [],
      list_properties: [],
      showCustomProperty: false,
      cpf_cnpj: selectedClient && selectedClient.cpf_cnpj ? selectedClient.cpf_cnpj : '',
      contractorEmail: selectedClient && selectedClient.email ? String(selectedClient.email).toLowerCase() : '',
      city: (this.state.areaLocation && this.state.areaLocation.city) || (selectedClient && selectedClient.localidade ? selectedClient.localidade : ''),
      address: (this.state.areaLocation && this.state.areaLocation.address) || address || '',
      uf: (this.state.areaLocation && this.state.areaLocation.uf) || (selectedClient && selectedClient.uf ? selectedClient.uf : '')
    });

    if (selectedClient && selectedClient.id) {
      this.readProperties(selectedClient.id);
    }
  };

  handleContractorInputChange = (e) => {
    this.setState({
      contractor: e.target.value,
      contractorSelect: 'noRegister',
      showCustomContractor: true,
      id_client: '',
      id_property: '',
      selectedPropertyId: '',
      selectedPropertyIds: [],
      property: '',
      jobProperty: [],
      list_properties: [],
      showCustomProperty: true
    });
  };

  handleSignatureEnd = () => {
    const pad = this.signaturePadRef.current;
    this.setState({ hasSignature: !!(pad && !pad.isEmpty()) });
  };

  clearSignature = () => {
    const pad = this.signaturePadRef.current;
    if (pad) pad.clear();
    this.setState({ hasSignature: false, responsibleTechnicianSignature: '', imageURL: '' });
  };

  startSigning = () => {
    this.setState({ isSigning: true, hasSignature: false });
  };

  saveSignature = () => {
    const pad = this.signaturePadRef.current;
    if (pad && !pad.isEmpty()) {
      const dataUrl = pad.toDataURL('image/png');
      this.setState({
        responsibleTechnicianSignature: dataUrl,
        imageURL: dataUrl,
        isSigning: false,
        hasSignature: true
      });
    } else {
      notification.open({
        message: this.props.res.ATENCAO,
        description: 'Por favor, desenhe a assinatura antes de salvar.',
        icon: <MaterialIcon icon="error" className="text-danger" />
      });
    }
  };

  blobToBase64 = (blob) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const res = reader.result || '';
      const b64 = typeof res === 'string' ? (res.split(',')[1] || '') : '';
      resolve(b64);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });

  base64ToBlob = (b64) => {
    try {
      const byteChars = atob(b64);
      const byteNumbers = new Array(byteChars.length);
      for (let i = 0; i < byteChars.length; i++) byteNumbers[i] = byteChars.charCodeAt(i);
      const byteArray = new Uint8Array(byteNumbers);
      return new Blob([byteArray], { type: 'application/pdf' });
    } catch (e) {
      return new Blob([], { type: 'application/pdf' });
    }
  };

  downloadFromBase64 = () => {
    if (!this.state.fileBase64) return;
    const blob = this.base64ToBlob(this.state.fileBase64);
    const objectUrl = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = objectUrl;
    anchor.download = (this.state.title || 'relatorio-assinado') + '.pdf';
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    setTimeout(() => URL.revokeObjectURL(objectUrl), 60000);
  };

  handleOpenModalSigned = () => {
    const partes = (this.state.documentData && this.state.documentData.partes) || [];
    const hasPartes = Array.isArray(partes) && partes.length > 0;

    if (hasPartes) {
      this.handleOpenModal();
      return;
    }

    const readPromise = this.readDocument && this.readDocument();
    if (readPromise && typeof readPromise.finally === 'function') {
      readPromise.finally(() => this.handleOpenModal());
    } else {
      this.readDocument();
      this.handleOpenModal();
    }
  };


  getNameParts = (value) => {
    if (!value) return [];
    return String(value).split(',').map(item => item.trim()).filter(Boolean);
  };

  getItemLabel = (item) => {
    if (!item) return '';
    return item.name ? String(item.name).trim() : '';
  };

  getItemOriginalLabel = (item) => {
    if (!item) return '';
    return item.original_name ? String(item.original_name).trim() : this.getItemLabel(item);
  };

  limitSelectLabel = (value) => {
    if (value === null || value === undefined) return '';
    const text = String(value).trim();
    return text.length > 202 ? text.slice(0, 202) + '...' : text;
  };

  getSelectedPlaneState = (selectedPlanes) => {
    const planes = Array.isArray(selectedPlanes) ? selectedPlanes : [];
    const ids = planes.map(item => item.id).filter(item => item !== null && item !== undefined);
    const names = planes.map(item => this.getItemOriginalLabel(item));

    return {
      selectedPlaneIds: ids,
      plane: this.limitFieldValue('plane', this.joinUniqueValues(names)),
      showCustomPlane: false
    };
  };

  getSelectedPilotState = (selectedPilots) => {
    const pilots = Array.isArray(selectedPilots) ? selectedPilots : [];
    const ids = pilots.map(item => item.id).filter(item => item !== null && item !== undefined);
    const names = pilots.map(item => this.getItemOriginalLabel(item));
    const canacs = pilots.map(item => item && item.canac ? item.canac : '');
    const emails = pilots.map(item => item && item.email ? String(item.email).toLowerCase() : '');

    return {
      id_pilot: ids.length ? ids[0] : '',
      selectedPilotIds: ids,
      pilot: this.limitFieldValue('pilot', this.joinUniqueValues(names)),
      canac: this.limitFieldValue('canac', this.joinUniqueValues(canacs)),
      pilotEmail: this.joinUniqueValues(emails),
      showCustomPilot: false
    };
  };

  applyPlaneSelectionFromText = (planes) => {
    const list = Array.isArray(planes) ? planes : [];
    const nameParts = this.getNameParts(this.state.plane);
    if (!nameParts.length || !list.length) return;

    const selected = list.filter(item => {
      const label = this.getItemLabel(item).toLowerCase();
      const original = this.getItemOriginalLabel(item).toLowerCase();
      return nameParts.some(name => {
        const normalizedName = name.toLowerCase();
        return normalizedName === label || normalizedName === original;
      });
    });

    if (selected.length > 0) {
      this.setState(this.getSelectedPlaneState(selected));
    }
  };

  applyPilotSelectionFromText = (pilots) => {
    const list = Array.isArray(pilots) ? pilots : [];
    const nameParts = this.getNameParts(this.state.pilot);
    if (!nameParts.length || !list.length) return;

    const selected = list.filter(item => {
      const label = this.getItemLabel(item).toLowerCase();
      const original = this.getItemOriginalLabel(item).toLowerCase();
      return nameParts.some(name => {
        const normalizedName = name.toLowerCase();
        return normalizedName === label || normalizedName === original;
      });
    });

    if (selected.length > 0) {
      this.setState(this.getSelectedPilotState(selected));
    }
  };

  clearSelectedPlanes = () => {
    this.setState({
      selectedPlaneIds: [],
      plane: '',
      showCustomPlane: false
    });
  };

  clearSelectedPilots = () => {
    this.setState({
      id_pilot: '',
      selectedPilotIds: [],
      pilot: '',
      canac: '',
      pilotEmail: '',
      showCustomPilot: false
    });
  };

  handleChangePlane = (e) => {
    const value = e && e.target && Array.isArray(e.target.value) ? e.target.value : [];

    if (!value.length) {
      this.clearSelectedPlanes();
      return;
    }

    const list = Array.isArray(this.state.planes) ? this.state.planes : [];
    const selectedPlanes = list.filter(item => value.some(id => Number(id) === Number(item.id)));

    if (selectedPlanes.length > 0) {
      this.setState(this.getSelectedPlaneState(selectedPlanes));
    }
  };

  handleChangePilot = (e) => {
    const value = e && e.target && Array.isArray(e.target.value) ? e.target.value : [];

    if (!value.length) {
      this.clearSelectedPilots();
      return;
    }

    const list = Array.isArray(this.state.pilots) ? this.state.pilots : [];
    const selectedPilots = list.filter(item => value.some(id => Number(id) === Number(item.id)));

    if (selectedPilots.length > 0) {
      this.setState(this.getSelectedPilotState(selectedPilots));
    }
  };

  handlePlaneInputChange = (e) => {
    const value = e && e.target ? e.target.value : '';

    this.setState({
      selectedPlaneIds: [],
      plane: this.limitFieldValue('plane', value),
      showCustomPlane: true
    });
  };

  handlePilotInputChange = (e) => {
    const value = e && e.target ? e.target.value : '';

    this.setState({
      id_pilot: '',
      selectedPilotIds: [],
      pilot: this.limitFieldValue('pilot', value),
      showCustomPilot: true
    });
  };

  readPlanes = () => {
    const apiUrl = `${Config.server}/plane`;
    const apiUrlPerm = `${Config.server}/plane/perm`;

    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    };

    Promise.all([
      fetch(apiUrl, options),
      fetch(apiUrlPerm, options)
    ])
      .then((responses) => {
        for (let i = 0; i < responses.length; i++) {
          if (responses[i].status !== 200) throw responses[i];
        }
        return Promise.all(responses.map((res) => res.json()));
      })
      .then((result) => {
        const planes = Array.isArray(result[0]) ? result[0] : [];
        const permPlanes = Array.isArray(result[1]) ? result[1] : [];

        const merged = [];
        const seen = {};

        for (let i = 0; i < planes.length; i++) {
          const planeItem = planes[i];
          if (planeItem && planeItem.id != null && !seen[planeItem.id]) {
            seen[planeItem.id] = true;
            merged.push(Object.assign({}, planeItem, {
              original_name: planeItem.name ? String(planeItem.name) : '',
              id_company: planeItem.id_company != null ? planeItem.id_company : null
            }));
          }
        }

        for (let i = 0; i < permPlanes.length; i++) {
          const plane = permPlanes[i];
          if (!plane || plane.id == null) continue;

          const planeName = plane.name ? String(plane.name) : '';
          const companyName = plane.company_name ? String(plane.company_name) : '';

          const mergedPlane = Object.assign({}, plane, {
            original_name: planeName,
            name: companyName ? planeName + ' - ' + companyName : planeName,
            id_company: plane.id_company != null ? plane.id_company : null
          });

          if (!seen[plane.id]) {
            seen[plane.id] = true;
            merged.push(mergedPlane);
          }
        }

        this.setState({ planes: merged }, () => {
          this.applyPlaneSelectionFromText(merged);
        });
      })
      .catch((error) => {
        if (error.status === 405) {
          notification.open({
            message: this.props.res.PERMISSAO,
            description: this.props.res.PERMISSAO_MSG,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
        } else if (error.status === 401 || error.status === 403) {
          this.props.link('/login');
        } else {
          notification.open({
            message: this.props.res.ERRO,
            description: this.props.res.ERRO_MSG,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
        }
      });
  };

  readPilots = () => {
    const apiUrl = `${Config.server}/pilot`;
    const apiUrlPerm = `${Config.server}/pilot/perm`;

    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    };

    Promise.all([
      fetch(apiUrl, options),
      fetch(apiUrlPerm, options)
    ])
      .then((responses) => {
        for (let i = 0; i < responses.length; i++) {
          if (responses[i].status !== 200) throw responses[i];
        }
        return Promise.all(responses.map((res) => res.json()));
      })
      .then((result) => {
        const pilots = Array.isArray(result[0]) ? result[0] : [];
        const permPilots = Array.isArray(result[1]) ? result[1] : [];

        const merged = [];
        const seen = {};

        for (let i = 0; i < pilots.length; i++) {
          const pilot = pilots[i];
          if (pilot && pilot.id != null && !seen[pilot.id]) {
            seen[pilot.id] = true;
            merged.push(Object.assign({}, pilot, {
              original_name: pilot.name ? String(pilot.name) : '',
              id_company: pilot.id_company != null ? pilot.id_company : null
            }));
          }
        }

        for (let i = 0; i < permPilots.length; i++) {
          const pilot = permPilots[i];
          if (!pilot || pilot.id == null) continue;

          const pilotName = pilot.name ? String(pilot.name) : '';
          const companyName = pilot.company_name ? String(pilot.company_name) : '';

          const mergedPilot = Object.assign({}, pilot, {
            original_name: pilotName,
            name: companyName ? pilotName + ' - ' + companyName : pilotName,
            id_company: pilot.id_company != null ? pilot.id_company : null
          });

          if (!seen[pilot.id]) {
            seen[pilot.id] = true;
            merged.push(mergedPilot);
          }
        }

        this.setState({ pilots: merged }, () => {
          this.applyPilotSelectionFromText(merged);
        });
      })
      .catch((error) => {
        if (error.status === 405) {
          notification.open({
            message: this.props.res.PERMISSAO,
            description: this.props.res.PERMISSAO_MSG,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
        } else if (error.status === 401 || error.status === 403) {
          this.props.link('/login');
        } else {
          notification.open({
            message: this.props.res.ERRO,
            description: this.props.res.ERRO_MSG,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
        }
      });
  };

  getAvailableProperties = () => {
    return (Array.isArray(this.state.list_properties) ? this.state.list_properties : []).filter((prop) => {
      const name = prop && prop.name ? String(prop.name).trim() : '';
      const normalizedName = name.toLowerCase().replace(/[ãáàâ]/g, 'a').replace(/[éê]/g, 'e').replace(/[í]/g, 'i').replace(/[óôõ]/g, 'o').replace(/[ú]/g, 'u').replace(/[ç]/g, 'c');
      return name && normalizedName !== 'outro' && normalizedName !== 'nao cadastrada' && normalizedName !== 'no register';
    });
  };

  joinUniqueValues = (values) => {
    const list = [];
    (values || []).forEach((value) => {
      const text = value === null || value === undefined ? '' : String(value).trim();
      if (text && list.indexOf(text) < 0) {
        list.push(text);
      }
    });
    return list.join(', ');
  };


  getAreaName = (area, index) => {
    if (area && area.name) return String(area.name).trim();
    if (area && area.property_name) return String(area.property_name).trim();
    if (area && area.area_name) return String(area.area_name).trim();
    return 'Área ' + (index + 1);
  };

  getFirstCoordinateFromPoints = (raw) => {
    if (!raw) return null;

    let points = raw;
    if (typeof points === 'string') {
      try {
        points = JSON.parse(points);
      } catch (e) {
        return null;
      }
    }

    if (!Array.isArray(points) || points.length === 0) return null;

    while (Array.isArray(points[0]) && Array.isArray(points[0][0])) {
      points = points[0];
    }

    const point = points[0];
    if (!Array.isArray(point) || point.length < 2) return null;

    const lat = Number(point[0]);
    const lng = Number(point[1]);

    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;

    return { lat, lng };
  };

  getCoordinateFromArea = (area) => {
    if (!area) return null;

    const lat = area.lat !== undefined && area.lat !== null ? Number(area.lat)
      : area.latitude !== undefined && area.latitude !== null ? Number(area.latitude)
        : null;
    const lng = area.lng !== undefined && area.lng !== null ? Number(area.lng)
      : area.longitude !== undefined && area.longitude !== null ? Number(area.longitude)
        : null;

    if (Number.isFinite(lat) && Number.isFinite(lng)) {
      return { lat, lng };
    }

    return this.getFirstCoordinateFromPoints(area.points_place) || this.getFirstCoordinateFromPoints(area.points);
  };

  getAreaCoordinates = (jobDetail, serviceOrderList) => {
    let areas = [];

    if (jobDetail && jobDetail.execucao && Array.isArray(jobDetail.execucao.area) && jobDetail.execucao.area.length > 0) {
      areas = jobDetail.execucao.area;
    } else if (jobDetail && jobDetail.planejamento && Array.isArray(jobDetail.planejamento.area) && jobDetail.planejamento.area.length > 0) {
      areas = jobDetail.planejamento.area;
    } else if (Array.isArray(serviceOrderList) && serviceOrderList.length > 0) {
      areas = [].concat.apply([], serviceOrderList.map((serviceOrder) => {
        return serviceOrder && Array.isArray(serviceOrder.areas) ? serviceOrder.areas : [];
      })).filter((area) => area && area.type === 'area');
    }

    const coordinates = [];
    const seen = {};

    areas.forEach((area, index) => {
      const coordinate = this.getCoordinateFromArea(area);
      if (!coordinate) return;

      const key = String(coordinate.lat) + '|' + String(coordinate.lng) + '|' + this.getAreaName(area, index);
      if (seen[key]) return;
      seen[key] = true;

      coordinates.push({
        name: this.getAreaName(area, index),
        lat: coordinate.lat,
        lng: coordinate.lng
      });
    });

    return coordinates;
  };

  formatAreaCoordinateValues = (areaCoordinates, type) => {
    const coordinates = Array.isArray(areaCoordinates) ? areaCoordinates : [];

    if (coordinates.length === 0) return '';

    if (coordinates.length === 1) {
      const coordinate = coordinates[0];
      return geo.toDMS(type === 'latitude' ? coordinate.lat : coordinate.lng, type, null, this.props.res);
    }

    return coordinates.map((coordinate, index) => {
      const value = geo.toDMS(type === 'latitude' ? coordinate.lat : coordinate.lng, type, null, this.props.res);
      return (coordinate.name || ('Área ' + (index + 1))) + ': ' + value;
    }).join('; ');
  };

  readAreaLocations = async (areaCoordinates) => {
    const coordinates = Array.isArray(areaCoordinates) ? areaCoordinates : [];
    if (!coordinates.length) {
      this.setState({ areaLocation: null });
      return null;
    }

    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    };

    const locations = [];

    for (const coordinate of coordinates) {
      try {
        const response = await fetch(`${Config.server}/reverse_geocode/${coordinate.lat}/${coordinate.lng}`, options);
        if (response.status !== 200) continue;
        const result = await response.json();
        if (result && (result.city || result.address || result.uf)) locations.push(result);
      } catch (e) {
      }
    }

    if (!locations.length) {
      this.setState({ areaLocation: null });
      return null;
    }

    const areaLocation = {
      city: this.joinUniqueValues(locations.map(item => item.city)),
      address: this.joinUniqueValues(locations.map(item => item.address)),
      uf: this.joinUniqueValues(locations.map(item => item.uf ? String(item.uf).toUpperCase() : ''))
    };

    this.setState((prevState) => ({
      areaLocation,
      city: areaLocation.city || prevState.city,
      address: areaLocation.address || prevState.address,
      uf: areaLocation.uf || prevState.uf
    }));

    return areaLocation;
  };

  getPropertyNameParts = (value) => {
    if (!value) return [];
    return String(value).split(',').map(item => item.trim()).filter(Boolean);
  };

  getSelectedPropertyState = (selectedProperties) => {
    const properties = Array.isArray(selectedProperties) ? selectedProperties : [];
    const ids = properties.map(item => item.id).filter(item => item !== null && item !== undefined);
    const names = properties.map(item => item.name);
    const cities = properties.map(item => item.localidade);
    const addresses = properties.map(item => item.address);
    const ufs = properties.map(item => item.uf ? String(item.uf).toUpperCase() : '');

    const jobProperty = Array.isArray(this.state.jobProperty) ? this.state.jobProperty.slice() : [];

    properties.forEach((item) => {
      if (item && !jobProperty.some(jp => Number(jp.property_id) === Number(item.id) || String(jp.property_name) === String(item.name))) {
        jobProperty.push({ property_id: item.id, property_name: item.name });
      }
    });

    return {
      id_property: ids.length ? ids[0] : '',
      selectedPropertyId: ids.length ? ids[0] : '',
      selectedPropertyIds: ids,
      property: this.joinUniqueValues(names),
      city: (this.state.areaLocation && this.state.areaLocation.city) || this.joinUniqueValues(cities),
      address: (this.state.areaLocation && this.state.areaLocation.address) || this.joinUniqueValues(addresses),
      uf: (this.state.areaLocation && this.state.areaLocation.uf) || this.joinUniqueValues(ufs),
      showCustomProperty: false,
      jobProperty
    };
  };

  clearSelectedProperties = () => {
    this.setState({
      id_property: '',
      selectedPropertyId: '',
      selectedPropertyIds: [],
      property: '',
      city: (this.state.areaLocation && this.state.areaLocation.city) || '',
      address: (this.state.areaLocation && this.state.areaLocation.address) || '',
      uf: (this.state.areaLocation && this.state.areaLocation.uf) || '',
      showCustomProperty: false
    });
  };

  readProperties = (idClient, opts) => {
    if (!idClient) {
      this.setState({
        list_properties: [],
        jobProperty: [],
        id_property: '',
        selectedPropertyId: '',
        selectedPropertyIds: [],
        showCustomProperty: true
      });
      return Promise.resolve();
    }

    const apiUrl = `${Config.server}/properties/${idClient}`;

    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    };

    return fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        return res.json();
      })
      .then((result) => new Promise((resolve) => {
        const list_properties = Array.isArray(result) ? result.map((p) => {
          const addressParts = [];
          if (p.logradouro) addressParts.push(p.logradouro);
          if (p.numero) addressParts.push(p.numero);
          return {
            id: p.id,
            name: p.name,
            property_name: p.name,
            localidade: p.localidade || '',
            uf: p.uf || '',
            address: addressParts.join(', '),
            obs: p.obs || ''
          };
        }).filter((p) => {
          const name = p && p.name ? String(p.name).trim() : '';
          const normalizedName = name.toLowerCase().replace(/[ãáàâ]/g, 'a').replace(/[éê]/g, 'e').replace(/[í]/g, 'i').replace(/[óôõ]/g, 'o').replace(/[ú]/g, 'u').replace(/[ç]/g, 'c');
          return name && normalizedName !== 'outro' && normalizedName !== 'nao cadastrada' && normalizedName !== 'no register';
        }) : [];

        const jobProperty = list_properties.map(p => ({
          property_id: p.id,
          property_name: p.name
        }));

        this.setState({ list_properties, jobProperty }, () => {
          const selId = opts && opts.selectId ? Number(opts.selectId) : null;
          const selName = opts && opts.selectName ? String(opts.selectName).trim() : '';
          const closeModal = opts && opts.closeModal ? true : false;
          const previousProperties = opts && Array.isArray(opts.previousProperties) ? opts.previousProperties : [];
          let selectedIds = Array.isArray(this.state.selectedPropertyIds) ? this.state.selectedPropertyIds.slice() : [];

          if (Number.isFinite(selId)) {
            selectedIds = [selId];
          }

          if (selName) {
            const nameParts = this.getPropertyNameParts(selName);
            const nameIds = list_properties
              .filter(p => nameParts.some(name => String(p.name).trim().toLowerCase() === name.toLowerCase()))
              .map(p => p.id);

            if (nameIds.length > 0) {
              selectedIds = nameIds;
            }
          }

          if (previousProperties.length > 0) {
            const previousIds = previousProperties
              .filter(item => item && item.id != null)
              .map(item => Number(item.id));

            const selected = list_properties.find(item => item && item.id != null && previousIds.indexOf(Number(item.id)) === -1) || null;
            if (selected) {
              selectedIds = selectedIds.filter(id => Number(id) !== Number(selected.id));
              selectedIds.push(selected.id);
            }
          }

          if (selectedIds.length === 0 && closeModal && list_properties.length > 0) {
            selectedIds = [list_properties[list_properties.length - 1].id];
          }

          if (selectedIds.length === 0 && list_properties.length === 1 && !selName) {
            selectedIds = [list_properties[0].id];
          }

          const selectedProperties = list_properties.filter(item => selectedIds.some(id => Number(id) === Number(item.id)));

          if (selectedProperties.length > 0) {
            this.setState({
              ...this.getSelectedPropertyState(selectedProperties),
              showPropertyForm: closeModal ? false : this.state.showPropertyForm
            }, resolve);
          } else if (selName) {
            this.setState({
              id_property: '',
              selectedPropertyId: '',
              selectedPropertyIds: [],
              property: selName,
              showCustomProperty: true,
              showPropertyForm: closeModal ? false : this.state.showPropertyForm
            }, resolve);
          } else {
            resolve();
          }
        });
      }))
      .catch((error) => {
        if (error && error.status === 405) {
          notification.open({
            message: this.props.res.PERMISSAO,
            description: this.props.res.PERMISSAO_MSG,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
        } else if (error && (error.status === 401 || error.status === 403)) {
          this.props.link('/login');
        }
      });
  };

  handleChangeProperty = (e) => {
    const value = e && e.target && Array.isArray(e.target.value) ? e.target.value : [];

    if (!value.length) {
      this.clearSelectedProperties();
      return;
    }

    const list = Array.isArray(this.state.list_properties) ? this.state.list_properties : [];
    const selectedProperties = list.filter(item => value.some(id => Number(id) === Number(item.id)));

    if (selectedProperties.length > 0) {
      this.setState(this.getSelectedPropertyState(selectedProperties));
    }
  };

  handlePropertyInputChange = (e) => {
    const value = e && e.target ? e.target.value : '';

    this.setState({
      id_property: '',
      selectedPropertyId: '',
      selectedPropertyIds: [],
      property: this.limitFieldValue('property', value),
      showCustomProperty: true
    });
  };

  openPropertyModal = (event) => {
    if (event && event.preventDefault) event.preventDefault();
    if (event && event.stopPropagation) event.stopPropagation();

    this.setState({
      showPropertyForm: true,
      id_property: '',
      selectedPropertyId: '',
      propertyModalKey: Date.now()
    });
  };

  closePropertyModal = () => {
    this.setState({
      showPropertyForm: false
    });
  };

  saveProperty = (savedProperty) => {
    const selectedClientId = this.state.id_client;
    const previousProperties = Array.isArray(this.state.list_properties) ? this.state.list_properties.slice() : [];

    if (!selectedClientId) {
      this.setState({
        showPropertyForm: false
      });
      return;
    }

    this.readProperties(selectedClientId, {
      selectId: savedProperty && savedProperty.id ? savedProperty.id : '',
      selectName: savedProperty && savedProperty.name ? savedProperty.name : '',
      closeModal: true,
      previousProperties
    });
  };

  handleDeleteReportsMapa = () => {
    const apiUrl = Config.server + `/reports_mapa/${this.state.jobReportId}`;
    const formData = new URLSearchParams();
    let descr = '';

    formData.append('id', this.state.jobReportId);
    descr = this.props.res.ITEM_EXCLUIDO;

    const options = {
      method: 'DELETE',
      body: formData,
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    };

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        return res.json();
      })
      .then(
        (result) => {
          this.setState({ jobReportId: null, editData: true }, () => {
            if (typeof this.readJob === 'function') this.readJob();
          });
        },
        (error) => {
          console.log(error);
        }
      );
  };

  openReportConfigDialog = () => {
    this.setState({
      openReportConfigDialog: true,
      ...this.getDefaultReportConfig()
    });
  };

  closeReportConfigDialog = () => {
    if (this.state.reportGenerated) return;
    this.setState({
      openReportConfigDialog: false,
      ...this.getDefaultReportConfig()
    });
  };

  handleChangeReportOption = (event) => {
    const { name, checked } = event.target;
    this.setState({ [name]: checked });
  };

  confirmDownloadRelMAPA = async () => {
    const culture = this.props.res.LINGUA;

    const apiUrlGen = Config.server + '/relmapa';
    const apiUrlSign = Config.server + '/relmapaSign';

    const invalidEmails = this.getInvalidSignatureEmails();

    if (invalidEmails.length > 0) {
      notification.open({
        message: this.props.res.ATENCAO,
        description: this.getInvalidEmailNotification(),
        icon: <MaterialIcon icon="error" className="text-danger" />
      });
      return;
    }

    const formData = new URLSearchParams();
    formData.append('data', JSON.stringify(this.state.jobReport));
    formData.append('signature', this.state.responsibleTechnicianSignature);
    formData.append('type', 'relmapa');
    formData.append('culture', culture);
    formData.append('id', this.state.id);
    formData.append('arrFuel', JSON.stringify(this.state.arrFuel));
    formData.append('percSize', this.state.percSize);
    formData.append('applicationGuide', this.state.applicationGuide);
    formData.append('logo', this.state.logo);
    formData.append('path', this.state.path);
    formData.append('map', this.state.map);
    formData.append('application', this.state.application);

    this.setState({ reportGenerated: true });

    try {
      const genRes = await fetch(apiUrlGen, {
        method: 'POST',
        body: formData,
        headers: { 'Authorization': localStorage.getItem('access-token-jwt') }
      });

      if (genRes.status !== 200) throw genRes;

      const genJson = await genRes.json();
      const pdfData = genJson && genJson.pdfData ? genJson.pdfData : null;

      const fileName = (this.state.title || 'Relatorio-MAPA').replace(/[\/\\:\.\!]/g, "-");

      let blob = new Blob([], { type: 'application/pdf' });
      if (pdfData) {
        try {
          const byteChars = atob(pdfData);
          const byteNumbers = new Array(byteChars.length);
          for (let i = 0; i < byteChars.length; i++) {
            byteNumbers[i] = byteChars.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          blob = new Blob([byteArray], { type: 'application/pdf' });
        } catch (e) {
          blob = new Blob([], { type: 'application/pdf' });
        }
      }

      if (!(blob && blob.type === 'application/pdf' && blob.size > 0)) {
        throw new Error('PDF inválido');
      }

      const blobUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = `${fileName}-Relatorio-MAPA.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(blobUrl);

      const companyId =
        (this.state.jobReport && this.state.jobReport.company_id) ||
        this.state.id_company ||
        this.state.company_id;

      const signPayload = {
        id_company: companyId,
        pdfData: pdfData,
        title: this.state.title,
        prescriptionDate: this.state.jobReport && this.state.jobReport.prescriptionDate,
        contractorEmail: this.state.jobReport && this.state.jobReport.contractorEmail,
        pilotEmail: this.state.jobReport && this.state.jobReport.pilotEmail,
        engineerEmail: this.state.jobReport && this.state.jobReport.engineerEmail,
        executorEmail: this.state.jobReport && this.state.jobReport.executorEmail,
        responsibleTechnicianEmail: this.state.jobReport && this.state.jobReport.responsibleTechnicianEmail,
        data: this.state.jobReport
      };

      const signRes = await fetch(apiUrlSign, {
        method: 'POST',
        headers: {
          'Authorization': localStorage.getItem('access-token-jwt'),
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(signPayload)
      });

      if (signRes.status !== 200) throw signRes;

      const signJson = await signRes.json();
      const guid = signJson && signJson.guid ? signJson.guid : null;

      if (!guid) {
        throw new Error('GUID não retornado');
      }

      await new Promise((resolve) => {
        this.setState({ documentGuid: guid }, resolve);
      });

      await this.createDocument();
      await this.readDocument();

      this.setState({
        reportGenerated: false,
        openReportConfigDialog: false
      });

    } catch (error) {
      notification.open({
        message: this.props.res.ERRO,
        description: this.props.res.ERRO_MSG,
        icon: <MaterialIcon icon="error" className="text-danger" />
      });

      this.setState({
        reportGenerated: false
      });
    }
  };

  openPreReportConfigDialog = () => {
    this.setState({
      openPreReportConfigDialog: true,
      map: true
    });
  };

  closePreReportConfigDialog = () => {
    if (this.state.reportGenerated) return;
    this.setState({ openPreReportConfigDialog: false });
  };

  render() {
    const { res } = this.props;

    const indexOfLastItem = this.state.currentPage * this.state.itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - this.state.itemsPerPage;
    const currentItems = this.state.filteredProducts.slice(indexOfFirstItem, indexOfLastItem);

    const directionOptions = [
      { value: 'N', label: 'Norte (N)', icon: <ArrowRightAltIcon style={{ transform: 'rotate(270deg)' }} /> },
      { value: 'NE', label: 'Nordeste (NE)', icon: <ArrowRightAltIcon style={{ transform: 'rotate(315deg)' }} /> },
      { value: 'L', label: 'Leste (L)', icon: <ArrowRightAltIcon /> },
      { value: 'SE', label: 'Sudeste (SE)', icon: <ArrowRightAltIcon style={{ transform: 'rotate(45deg)' }} /> },
      { value: 'S', label: 'Sul (S)', icon: <ArrowRightAltIcon style={{ transform: 'rotate(90deg)' }} /> },
      { value: 'SO', label: 'Sudoeste (SO)', icon: <ArrowRightAltIcon style={{ transform: 'rotate(135deg)' }} /> },
      { value: 'O', label: 'Oeste (O)', icon: <ArrowRightAltIcon style={{ transform: 'rotate(180deg)' }} /> },
      { value: 'NO', label: 'Noroeste (NO)', icon: <ArrowRightAltIcon style={{ transform: 'rotate(225deg)' }} /> },
    ];

    const appDirectionOptions = [
      { value: 'N', label: 'Norte (N)', icon: <ArrowRightAltIcon style={{ transform: 'rotate(270deg)' }} /> },
      { value: 'NNE', label: 'Nor-Nordeste (NNE)', icon: <ArrowRightAltIcon style={{ transform: 'rotate(292.5deg)' }} /> },
      { value: 'NE', label: 'Nordeste (NE)', icon: <ArrowRightAltIcon style={{ transform: 'rotate(315deg)' }} /> },
      { value: 'ENE', label: 'És-Nordeste (ENE)', icon: <ArrowRightAltIcon style={{ transform: 'rotate(337.5deg)' }} /> },
      { value: 'L', label: 'Leste (L)', icon: <ArrowRightAltIcon /> },
      { value: 'ESE', label: 'És-Sudeste (ESE)', icon: <ArrowRightAltIcon style={{ transform: 'rotate(22.5deg)' }} /> },
      { value: 'SE', label: 'Sudeste (SE)', icon: <ArrowRightAltIcon style={{ transform: 'rotate(45deg)' }} /> },
      { value: 'SSE', label: 'Su-Sudeste (SSE)', icon: <ArrowRightAltIcon style={{ transform: 'rotate(67.5deg)' }} /> },
      { value: 'S', label: 'Sul (S)', icon: <ArrowRightAltIcon style={{ transform: 'rotate(90deg)' }} /> },
      { value: 'SSO', label: 'Su-Sudoeste (SSO)', icon: <ArrowRightAltIcon style={{ transform: 'rotate(112.5deg)' }} /> },
      { value: 'SO', label: 'Sudoeste (SO)', icon: <ArrowRightAltIcon style={{ transform: 'rotate(135deg)' }} /> },
      { value: 'OSO', label: 'Oés-Sudoeste (OSO)', icon: <ArrowRightAltIcon style={{ transform: 'rotate(157.5deg)' }} /> },
      { value: 'O', label: 'Oeste (O)', icon: <ArrowRightAltIcon style={{ transform: 'rotate(180deg)' }} /> },
      { value: 'ONO', label: 'Oés-Noroeste (ONO)', icon: <ArrowRightAltIcon style={{ transform: 'rotate(202.5deg)' }} /> },
      { value: 'NO', label: 'Noroeste (NO)', icon: <ArrowRightAltIcon style={{ transform: 'rotate(225deg)' }} /> },
      { value: 'NNO', label: 'Nor-Noroeste (NNO)', icon: <ArrowRightAltIcon style={{ transform: 'rotate(247.5deg)' }} /> },
    ];

    const partes = (this.state.documentData && Array.isArray(this.state.documentData.partes)) ? this.state.documentData.partes : [];
    const allSigned = partes.length > 0 && partes.every(part => part.assinado && part.assinado.created);

    return (
      <div>
        <Dialog
          open={!!this.state.showPropertyForm}
          onClose={this.closePropertyModal}
          fullWidth
          maxWidth="md"
        >
          <EditProperty
            key={this.state.propertyModalKey}
            link={this.props.link}
            res={this.props.res}
            modal={true}
            idClient={this.state.id_client}
            idProperty={this.state.id_property}
            onSave={this.saveProperty}
            onClose={this.closePropertyModal}
          />
        </Dialog>
        <div className="containerTop">
          <div><h1>{res.RELATORIO_MAPA}</h1></div>
          <div className="centerTop"></div>
          <div>
            {(() => {
              const { editData, jobReportId, documentId, fileSigned, openResetConfirm } = this.state;
              const fileSignedNormalized = this.normalizeDocumentValue(fileSigned);
              const showReset = (!editData && jobReportId !== null) && !(documentId || fileSignedNormalized);
              return showReset ? (
                <>
                  <Button
                    variant="contained"
                    className="popUpButton"
                    onClick={() => this.setState({ openResetConfirm: true })}
                  >
                    {res.REINICIAR_RELATORIO}
                  </Button> &nbsp;

                  <Dialog
                    open={!!openResetConfirm}
                    onClose={() => this.setState({ openResetConfirm: false })}
                  >
                    <DialogTitle style={{ padding: '0' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', backgroundColor: '#2D3238', padding: '0.5rem 0' }}>
                        <div style={{ width: '16%', textAlign: 'left' }}></div>
                        <div style={{ textAlign: 'center' }}>
                          <p style={{ color: 'white', margin: '0' }}>{res.REINICIAR_RELATORIO}</p>
                        </div>
                        <div style={{ width: '16%', textAlign: 'right' }}>
                          <Button size="small" className="popUpButton" onClick={() => this.setState({ openResetConfirm: false })}>
                            <CloseIcon style={{ color: 'white' }} />
                          </Button>
                        </div>
                      </div>
                    </DialogTitle>
                    <DialogContent>
                      <DialogContentText style={{ color: 'black' }}>{res.CONFIRMAR_REINICIO}</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={() => this.setState({ openResetConfirm: false })} color="primary">
                        {res.NAO}
                      </Button>
                      <Button
                        onClick={() => {
                          this.setState({ openResetConfirm: false }, () => this.handleDeleteReportsMapa());
                        }}
                        color="primary"
                        autoFocus
                      >
                        {res.SIM}
                      </Button>
                    </DialogActions>
                  </Dialog>
                </>
              ) : null;
            })()}
            <Button variant="contained" disabled={this.state.editData && this.state.jobReportId !== null} onClick={() => this.props.link('/app/relatorio-mapa/list')} className="popUpButton">
              {res.CANCELAR}
            </Button> &nbsp;
            {(this.state.documentId && this.normalizeDocumentValue(this.state.documentGuid)) ? (
              <>
                <Button
                  variant="contained"
                  color="primary"
                  className="popUpButton"
                  onClick={this.handleOpenModalSigned}
                >
                  <DescriptionIcon className="iconMapS" />
                  {res.ACOMPANHAR_ASSINATURA}
                </Button> &nbsp;
              </>

            ) : (
              <>
                <Button
                  variant="contained"
                  disabled={!this.state.isReportReady || (this.state.editData && this.state.reportGenerated)}
                  color={this.state.reportGenerated ? "default" : "primary"}
                  className="popUpButton"
                  onClick={this.downloadRelMAPA}
                  style={{ display: this.state.validJob ? 'inline-flex' : 'none' }}
                >
                  {this.state.reportGenerated ? (
                    <CircularProgress size={24} />
                  ) : (
                    <>
                      <DescriptionIcon className="iconMapS" />
                      {res.GERAR_RELATORIO}
                    </>
                  )}
                </Button> &nbsp;

                <Dialog
                  open={this.state.openReportConfigDialog}
                  onClose={this.closeReportConfigDialog}
                  fullWidth
                  maxWidth="sm"
                >
                  <DialogTitle style={{ padding: 0 }}>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: '0.5rem 0',
                        backgroundColor: '#2D3238',
                      }}
                    >
                      <div />
                      <h3 style={{ margin: 0, color: 'white', whiteSpace: 'nowrap' }}>
                        {res.GERAR_RELATORIO}
                      </h3>
                      <CloseIcon
                        onClick={this.closeReportConfigDialog}
                        style={{ cursor: 'pointer', width: '2rem', height: '2rem', color: 'white', marginRight: '0.5rem' }}
                      />
                    </div>
                  </DialogTitle>

                  <DialogContent
                    style={{ margin: 0, padding: '1rem 1.5rem', color: 'black', backgroundColor: 'white' }}
                  >
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>

                      <FormControlLabel
                        control={
                          <Switch
                            checked={this.state.map}
                            onChange={this.handleChangeReportOption}
                            name="map"
                            color="primary"
                          />
                        }
                        label={res.MAPA_FUNDO}
                      />

                      <FormControlLabel
                        control={
                          <Switch
                            checked={this.state.application}
                            onChange={this.handleChangeReportOption}
                            name="application"
                            color="primary"
                          />
                        }
                        label={res.APLICACAO}
                      />

                      <FormControlLabel
                        control={
                          <Switch
                            checked={this.state.path}
                            onChange={this.handleChangeReportOption}
                            name="path"
                            color="primary"
                          />
                        }
                        label={res.TRAJETORIA_VOO}
                      />

                      <FormControlLabel
                        control={
                          <Switch
                            checked={this.state.logo}
                            onChange={this.handleChangeReportOption}
                            name="logo"
                            color="primary"
                          />
                        }
                        label={res.REMOVER_LOGO}
                      />

                      <FormControlLabel
                        control={
                          <Switch
                            checked={this.state.applicationGuide}
                            onChange={this.handleChangeReportOption}
                            name="applicationGuide"
                            color="primary"
                          />
                        }
                        label={res.GUIA_APLICACAO}
                      />

                    </div>
                  </DialogContent>

                  <DialogActions style={{ backgroundColor: 'white', padding: '0.75rem 1rem' }}>
                    <Button onClick={this.closeReportConfigDialog} disabled={this.state.reportGenerated}>
                      {res.CANCELAR}
                    </Button>

                    <Button
                      onClick={this.confirmDownloadRelMAPA}
                      color="primary"
                      variant="contained"
                      disabled={this.state.reportGenerated}
                    >
                      {this.state.reportGenerated ? <CircularProgress size={24} /> : (res.GERAR)}
                    </Button>
                  </DialogActions>
                </Dialog>
              </>
            )}
            <Button
              variant="contained"
              color="primary"
              className="popUpButton"
              onClick={this.downloadPreRelMAPA}
              style={{ display: this.state.preJob ? 'inline-flex' : 'none' }}
            >
              <>
                <DescriptionIcon className="iconMapS" />
                {res.RELATORIO_PRE_OPERACAO}
              </>
            </Button>
            <Dialog
              open={this.state.openPreReportConfigDialog}
              onClose={this.closePreReportConfigDialog}
              fullWidth
              maxWidth="sm"
            >
              <DialogTitle style={{ padding: 0 }}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '0.5rem 0',
                    backgroundColor: '#2D3238',
                  }}
                >
                  <div />
                  <h3 style={{ margin: 0, color: 'white', whiteSpace: 'nowrap' }}>
                    {res.RELATORIO_PRE_OPERACAO}
                  </h3>
                  <CloseIcon
                    onClick={this.closePreReportConfigDialog}
                    style={{ cursor: 'pointer', width: '2rem', height: '2rem', color: 'white', marginRight: '0.5rem' }}
                  />
                </div>
              </DialogTitle>

              <DialogContent
                style={{ margin: 0, padding: '1rem 1.5rem', color: 'black', backgroundColor: 'white' }}
              >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={this.state.map}
                        onChange={this.handleChangeReportOption}
                        name="map"
                        color="primary"
                      />
                    }
                    label={res.MAPA_FUNDO}
                  />
                </div>
              </DialogContent>

              <DialogActions style={{ backgroundColor: 'white', padding: '0.75rem 1rem' }}>
                <Button onClick={this.closePreReportConfigDialog} disabled={this.state.reportGenerated}>
                  {res.CANCELAR}
                </Button>

                <Button
                  onClick={this.confirmDownloadPreRelMAPA}
                  color="primary"
                  variant="contained"
                  disabled={this.state.reportGenerated}
                >
                  {res.GERAR}
                </Button>
              </DialogActions>
            </Dialog>
            <Modal
              open={this.state.openModal}
              onClose={this.handleCloseModal}
              aria-labelledby="simple-modal-title"
              aria-describedby="simple-modal-description"
              style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            >
              <Paper style={{ maxWidth: '80%', overflow: 'auto' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', backgroundColor: '#2D3238', padding: '0.5rem 0' }}>
                  <div style={{ width: '33%', textAlign: 'left' }}></div>
                  <div style={{ width: '33%', textAlign: 'center' }}>
                    <h2 style={{ color: 'white' }}>{res.DADOS_DOCUMENTO}</h2>
                  </div>
                  <div style={{ width: '33%', textAlign: 'right' }}>
                    <Button size="small" className="popUpButton" onClick={this.handleCloseModal}>
                      <CloseIcon style={{ color: 'white' }} />
                    </Button>
                  </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'right', padding: '1rem' }}>
                  <Button
                    variant="contained"
                    color="primary"
                    className="popUpButton"
                    onClick={this.downloadReportDocument}
                    style={{ paddingTop: '0.75rem' }}
                  >
                    <DescriptionIcon className="iconMapS" />
                    {allSigned ? (res.BAIXAR_RELATORIO_ASSINADO) : res.BAIXAR_RELATORIO}
                  </Button> &nbsp;
                  <Button
                    variant="contained"
                    color="primary"
                    className="popUpButton"
                    onClick={this.readDocument}
                    style={{ paddingTop: '0.75rem' }}
                  >
                    <RefreshIcon className="iconMapS" />
                  </Button> &nbsp;
                  <Button
                    variant="contained"
                    style={{ backgroundColor: 'red', color: 'white', paddingTop: '0.75rem' }}
                    className="popUpButton"
                    onClick={this.handleClickOpen}
                  >
                    <DeleteForeverIcon className="iconMapS" />
                  </Button>
                  <Dialog
                    open={this.state.open}
                    onClose={this.handleClose}
                  >
                    <DialogTitle style={{ padding: '0' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', backgroundColor: '#2D3238', padding: '0.5rem 0' }}>
                        <div style={{ width: '16%', textAlign: 'left' }}></div>
                        <div style={{ textAlign: 'center' }}>
                          <p style={{ color: 'white', margin: '0' }}>{res.EXCLUIR_DOCUMENTO}</p>
                        </div>
                        <div style={{ width: '16%', textAlign: 'right' }}>
                          <Button size="small" className="popUpButton" onClick={this.handleClose}>
                            <CloseIcon style={{ color: 'white' }} />
                          </Button>
                        </div>
                      </div>
                    </DialogTitle>
                    <DialogContent>
                      <DialogContentText style={{ color: 'black' }}>{res.CONFIRMAR_EXCLUSÃO}</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={this.handleClose} color="primary">
                        {res.NAO}
                      </Button>
                      <Button onClick={this.handleDeleteSignature} color="primary" autoFocus>
                        {res.SIM}
                      </Button>
                    </DialogActions>
                  </Dialog>
                </div>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>{res.NOME}</TableCell>
                      <TableCell style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>{res.E_MAIL}</TableCell>
                      <TableCell style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>{res.FUNCAO}</TableCell>
                      <TableCell style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>{res.ETAPA}</TableCell>
                      <TableCell style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>{res.STATUS_ASSINATURA}</TableCell>
                      <TableCell style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>{res.ULTIMA_ATUALIZACAO}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {partes.length > 0 ? (
                      partes.map((part) => {
                        const { icon, etapa, date } = this.getStatusDetails(part);
                        const nome = part.nome || this.getNameFromEmail(part.email) || 'Nome não disponível';
                        const funcao = this.getFunctionFromEmail(part.email);
                        return (
                          <TableRow key={part.uuid}>
                            <TableCell style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>{nome}</TableCell>
                            <TableCell style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>{part.email || 'E-mail não disponível'}</TableCell>
                            <TableCell style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>{funcao}</TableCell>
                            <TableCell style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>{etapa}</TableCell>
                            <TableCell style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>{icon}</TableCell>
                            <TableCell style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>{date ? Moment(date).format('DD/MM/YYYY HH:mm') : 'Data não disponível'}</TableCell>
                          </TableRow>
                        );
                      })
                    ) : (
                      <TableRow>
                        <TableCell colSpan={6} align="center">
                          {res.NENHUM_DADO}
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </Paper>
            </Modal>
          </div>
        </div>
        <div style={{ textAlign: 'end', marginTop: '1rem' }}>
          {this.state.editData
            ?
            <div>
              <Button
                variant="contained"
                color="primary"
                onClick={this.handleSubmit}
                className="popUpButton"
              >
                <SaveIcon className="iconMapS" />
                {res.SALVAR}
              </Button>

            </div>
            :
            (!(this.state.documentId || this.normalizeDocumentValue(this.state.fileSigned)) && (
              <Button variant="contained" color="primary" onClick={() => this.setState({ editData: true })} className="popUpButton" >
                <EditIcon className="iconMapS" />
                {res.EDITAR}
              </Button>
            ))
          }
        </div>
        <div style={{ margin: '1rem 0', position: 'relative' }}>
          {this.state.initialLoading && (
            <div style={{ position: 'absolute', inset: 0, zIndex: 10, backgroundColor: 'rgba(255,255,255,0.85)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <CircularProgress />
            </div>
          )}
          <div style={{ margin: '1rem 0' }}>
            <TextField
              id="title"
              label={res.TITULO}
              disabled={!this.state.editData}
              value={this.state.title}
            />
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <TextField
              label={res.DATA_RECEITUARIO}
              type="date"
              value={this.state.prescriptionDate}
              onChange={this.handleChange('prescriptionDate')}
              disabled={!this.state.editData}
              InputLabelProps={{
                shrink: true,
              }}
              style={{ width: '100%', marginTop: '1rem' }}
            />
            <TextField
              id="prescriptionNumber"
              label={res.NUMERO_RECEITUARIO}
              disabled={!this.state.editData}
              style={{ width: '100%', margin: '1rem' }}
              value={this.state.prescriptionNumber}
              onChange={this.handleChange('prescriptionNumber')}
            />
            <TextField
              id="registrationNumber"
              label={res.NUMERO_REGISTRO_MAPA}
              disabled={!this.state.editData}
              style={{ width: '100%', marginTop: '1rem' }}
              value={this.state.registrationNumber}
              onChange={this.handleChange('registrationNumber')}
            />
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <TextField
              id="contractorSelect"
              label={res.CONTRATANTE}
              disabled={this.state.editData === false}
              style={{ marginTop: '1rem', width: this.state.showCustomContractor ? '50%' : '100%', paddingRight: '1rem' }}
              select
              SelectProps={{ native: true }}
              InputLabelProps={{ shrink: true }}
              value={this.state.contractorSelect || ''}
              onChange={this.handleContractorSelectChange}
            >
              <option value="" disabled>{res.SELECIONE}</option>
              {Array.isArray(this.state.clients) && this.state.clients.map(function (c) {
                return <option key={c.id} value={c.name}>{c.name}</option>;
              })}
              <option value="noRegister">{res.NAO_CADASTRADA}</option>
            </TextField>

            {this.state.showCustomContractor && (
              <TextField
                id="contractor"
                label={res.CONTRATANTE}
                disabled={this.state.editData === false}
                style={{ marginTop: '1rem', width: '50%', paddingRight: '1rem' }}
                value={this.state.contractor || ''}
                onChange={this.handleContractorInputChange}
                InputLabelProps={{ shrink: true }}
                inputProps={{ maxLength: 80 }}
              />
            )}
            <TextField
              id="cnpj-cpf"
              label={res.CPFCNPJ}
              disabled={this.state.editData === false}
              style={{ marginTop: '1rem', width: '100%', paddingRight: '1rem' }}
              value={this.state.cpf_cnpj}
              onChange={this.handleChange('cpf_cnpj')}
            />
            <TextField
              id="contractorEmail"
              label={res.EMAIL}
              disabled={this.state.editData === false}
              style={{ marginTop: '1rem', width: '100%' }}
              value={this.state.contractorEmail ? this.state.contractorEmail : ''}
              error={this.isInvalidEmail(this.state.contractorEmail)}
              helperText={this.isInvalidEmail(this.state.contractorEmail) ? this.getInvalidEmailMessage() : ''}
              onChange={(e) => {
                e.target.value = e.target.value.toLowerCase();
                this.handleChange('contractorEmail')(e);
              }}
            />
          </div>
          <div>
            {this.state.showCustomContractor
              ? (
                <TextField
                  id="property"
                  label={res.PROPRIEDADE}
                  disabled={this.state.editData === false}
                  margin="normal"
                  fullWidth
                  style={{ marginTop: '1rem', width: '60%', paddingRight: '1rem' }}
                  value={this.state.property}
                  onChange={this.handlePropertyInputChange}
                  inputProps={{ maxLength: fieldLimits.property }}
                  InputLabelProps={{ shrink: true }}
                />
              )
              : (
                <div style={{ marginTop: '1rem', width: '60%', paddingRight: '1rem', display: 'inline-block', verticalAlign: 'top' }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: 24 }}>
                    <InputLabel id="property-label" style={{ position: 'relative', transform: 'none', fontSize: '0.75rem' }}>{res.PROPRIEDADE}</InputLabel>
                    {this.state.editData !== false && (
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <FormControlLabel
                          style={{ marginRight: '1rem', height: 24, marginBottom: 0 }}
                          control={
                            <Checkbox
                              color="primary"
                              checked={this.state.showCustomProperty}
                              onChange={(event) => this.setState({
                                showCustomProperty: event.target.checked,
                                property: '',
                                id_property: '',
                                selectedPropertyId: '',
                                selectedPropertyIds: [],
                                city: (this.state.areaLocation && this.state.areaLocation.city) || '',
                                address: (this.state.areaLocation && this.state.areaLocation.address) || '',
                                uf: (this.state.areaLocation && this.state.areaLocation.uf) || ''
                              })}
                              style={{ padding: 4 }}
                            />
                          }
                          label={<span style={{ fontSize: '0.75rem' }}>{res.PREENCHIMENTO_MANUAL}</span>}
                        />

                        {!this.state.showCustomProperty && (
                          <Button
                            type="button"
                            color="primary"
                            size="small"
                            onClick={this.openPropertyModal}
                            style={{ minWidth: 'unset', padding: 0, textTransform: 'none', fontSize: '0.75rem', fontWeight: 500 }}
                          >
                            <AddIcon style={{ fontSize: 16, marginRight: 4 }} />
                            {res.NOVA_PROPRIEDADE}
                          </Button>
                        )}
                      </div>
                    )}
                  </div>

                  {!this.state.showCustomProperty ? (
                    <FormControl
                      style={{ width: '100%' }}
                      disabled={this.state.editData === false}
                    >
                      <Select
                        multiple
                        labelId="property-label"
                        id="property"
                        value={this.state.selectedPropertyIds || []}
                        onChange={this.handleChangeProperty}
                        displayEmpty
                        renderValue={(selected) => {
                          const selectedNames = this.getAvailableProperties()
                            .filter((prop) => selected.some(id => Number(id) === Number(prop.id)))
                            .map((prop) => String(prop.name || '').trim());
                          return selectedNames.join(', ');
                        }}
                        endAdornment={
                          this.state.property ? (
                            <IconButton
                              size="small"
                              style={{ marginRight: 24 }}
                              onClick={(event) => {
                                event.stopPropagation();
                                this.clearSelectedProperties();
                              }}
                            >
                              <CloseIcon fontSize="small" />
                            </IconButton>
                          ) : null
                        }
                        MenuProps={{
                          anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                          transformOrigin: { vertical: 'top', horizontal: 'left' },
                          getContentAnchorEl: null,
                        }}
                      >
                        {this.getAvailableProperties().map((prop, index) => (
                          <MenuItem key={prop.id || index} value={prop.id}>
                            <Checkbox checked={(this.state.selectedPropertyIds || []).some(id => Number(id) === Number(prop.id))} />
                            <ListItemText primary={prop.name} />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  ) : (
                    <TextField
                      id="propertyManual"
                      disabled={this.state.editData === false}
                      fullWidth
                      style={{ marginTop: 0 }}
                      value={this.state.property}
                      onChange={this.handlePropertyInputChange}
                      inputProps={{ maxLength: fieldLimits.property }}
                      InputLabelProps={{ shrink: true }}
                    />
                  )}
                </div>
              )
            }
            <TextField
              id="city"
              label={res.CIDADE}
              disabled={this.state.editData === false}
              style={{ marginTop: '1rem', width: '40%' }}
              value={this.state.city ? this.state.city : ''}
              onChange={this.handleChange('city')}
              inputProps={{ maxLength: fieldLimits.city }}
            />
          </div>
          <div>
            <TextField
              id="address"
              label={res.ENDERECO}
              disabled={this.state.editData === false}
              style={{ marginTop: '1rem', width: '60%', paddingRight: '1rem' }}
              value={this.state.address ? this.state.address : ''}
              onChange={this.handleChange('address')}
              inputProps={{ maxLength: fieldLimits.address }}
            />
            <TextField
              id="uf"
              label={res.ESTADO}
              disabled={this.state.editData === false}
              style={{ marginTop: '1rem', width: '40%' }}
              value={(this.state.uf || '').toUpperCase()}
              onChange={(e) => {
                const v = (e.target.value || '').toUpperCase().replace(/[^A-Z, /-]/g, '').slice(0, fieldLimits.uf);
                this.handleChange('uf')({ target: { value: v } });
              }}
              inputProps={{ maxLength: fieldLimits.uf }}
            />
          </div>
          <div>
            <FormControl style={{ width: '100%' }} disabled={this.state.editData === false}>
              <InputLabel htmlFor="agriculturelCulture" style={{ paddingTop: '1rem' }}>{res.CULTURA}</InputLabel>
              <Select
                onChange={this.handleChange('culture')}
                value={this.state.culture}
                style={{ width: '100%', marginTop: '2rem' }}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 224,
                      width: 250,
                    },
                  },
                  anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                  },
                  transformOrigin: {
                    vertical: 'top',
                    horizontal: 'left',
                  },
                  getContentAnchorEl: null,
                }}
              >
                <MenuItem disabled value="">{res.SELECIONAR_CULTURA}</MenuItem>
                {this.state.cultureData.map((item) => (
                  <MenuItem key={item.name} value={item.name}>{item.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              id="area"
              label={res.AREA}
              disabled={this.state.editData === false}
              style={{ marginTop: '1rem', width: '33.33%', paddingRight: '1rem' }}
              value={this.state.area}
              onChange={this.handleChange('area')}
              inputProps={{ maxLength: fieldLimits.area }}
            />
            <TextField
              id="volume"
              label={res.VOLUME}
              disabled={this.state.editData === false}
              style={{ marginTop: '1rem', width: '33.33%' }}
              value={this.state.volume}
              onChange={this.handleChange('volume')}
              inputProps={{ maxLength: fieldLimits.volume }}
            />
          </div>
          <div style={{ display: 'flex', alignItems: 'baseline' }}>
            <div style={{ display: 'flex', alignItems: 'baseline', width: '40%' }}>
              <TextField
                id="startDate"
                label={res.INICIO_APLICACAO}
                type="datetime-local"
                disabled={!this.state.editData}
                style={{ marginTop: '1rem', width: '50%', paddingRight: '1rem' }}
                value={this.state.startDate}
                onChange={this.handleChange('startDate')}
                InputLabelProps={{ shrink: true }}
              />
              <TextField
                id="endDate"
                label={res.FIM_APLICACAO}
                type="datetime-local"
                disabled={!this.state.editData}
                style={{ marginTop: '1rem', width: '50%', paddingRight: '1rem' }}
                value={this.state.endDate}
                onChange={this.handleChange('endDate')}
                InputLabelProps={{ shrink: true }}
              />
            </div>
            <TextField
              id="timeVoo"
              label={res.TEMPO_OPERACAO}
              type="time"
              disabled={!this.state.editData}
              style={{ marginTop: '1rem', width: '20%', paddingRight: '1rem' }}
              value={this.state.time_voo}
              onChange={this.handleChange('time_voo')}
              InputLabelProps={{ shrink: true }}
              inputProps={{ step: 1 }}
            />
            <FormControl style={{ display: 'flex', flexDirection: 'row', marginTop: '1rem', width: '40%' }} disabled={this.state.editData === false}>
              <FormLabel style={{ display: 'flex', alignItems: 'center', marginRight: '1rem' }}>{res.PERIODO_APLICACAO}:</FormLabel>
              <RadioGroup style={{ display: 'flex', flexDirection: 'row' }} value={this.state.application_period} onChange={this.handleChange('application_period')}>
                <FormControlLabel style={{ marginRight: '2rem' }} value="preEmergente" control={<Radio color="primary" />} label="Pré-Emergente" />
                <FormControlLabel style={{ marginRight: '2rem' }} value="posEmergente" control={<Radio color="primary" />} label="Pós-Emergente" />
              </RadioGroup>
            </FormControl>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <FormControl style={{ display: 'flex', flexDirection: 'row', marginTop: '1rem', width: '100%' }} disabled={this.state.editData === false}>
              <FormLabel style={{ display: 'flex', alignItems: 'center' }}>{res.CLASSE_AGROTOXICO}:</FormLabel>
              <div style={{ display: 'flex', alignItems: 'center', margin: '0 0.5rem' }}>
                <input
                  type="checkbox"
                  style={{ width: '1.25rem', height: '1.25rem', marginRight: '0.5rem', cursor: this.state.editData ? 'pointer' : null }}
                  checked={this.state.type_service.insecticide}
                  onChange={() => this.handleTypeServiceChange('insecticide')}
                  name="insecticide"
                  disabled={this.state.editData === false}
                />
                <span style={{ color: this.state.editData ? 'black' : 'rgba(0, 0, 0, 0.38)' }}>{res.INSETICIDA}</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', margin: '0 0.5rem' }}>
                <input
                  type="checkbox"
                  style={{ width: '1.25rem', height: '1.25rem', marginRight: '0.5rem', cursor: this.state.editData ? 'pointer' : null }}
                  checked={this.state.type_service.herbicide}
                  onChange={() => this.handleTypeServiceChange('herbicide')}
                  name="herbicide"
                  disabled={this.state.editData === false}
                />
                <span style={{ color: this.state.editData ? 'black' : 'rgba(0, 0, 0, 0.38)' }}>{res.HERBICIDA}</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', margin: '0 0.5rem' }}>
                <input
                  type="checkbox"
                  style={{ width: '1.25rem', height: '1.25rem', marginRight: '0.5rem', cursor: this.state.editData ? 'pointer' : null }}
                  checked={this.state.type_service.fungicide}
                  onChange={() => this.handleTypeServiceChange('fungicide')}
                  name="fungicide"
                  disabled={this.state.editData === false}
                />
                <span style={{ color: this.state.editData ? 'black' : 'rgba(0, 0, 0, 0.38)' }}>{res.FUNGICIDA}</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', margin: '0 0.5rem' }}>
                <input
                  type="checkbox"
                  style={{ width: '1.25rem', height: '1.25rem', marginRight: '0.5rem', cursor: this.state.editData ? 'pointer' : null }}
                  checked={this.state.type_service.seeding}
                  onChange={() => this.handleTypeServiceChange('seeding')}
                  name="seeding"
                  disabled={this.state.editData === false}
                />
                <span style={{ color: this.state.editData ? 'black' : 'rgba(0, 0, 0, 0.38)' }}>{res.SEMEADURA}</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', margin: '0 0.5rem' }}>
                <input
                  type="checkbox"
                  style={{ width: '1.25rem', height: '1.25rem', marginRight: '0.5rem', cursor: this.state.editData ? 'pointer' : null }}
                  checked={this.state.type_service.fertilizing}
                  onChange={() => this.handleTypeServiceChange('fertilizing')}
                  name="fertilizing"
                  disabled={this.state.editData === false}
                />
                <span style={{ color: this.state.editData ? 'black' : 'rgba(0, 0, 0, 0.38)' }}>{res.ADUBACAO}</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', margin: '0 0.5rem' }}>
                <input
                  type="checkbox"
                  style={{ width: '1.25rem', height: '1.25rem', marginRight: '0.5rem', cursor: this.state.editData ? 'pointer' : null }}
                  checked={this.state.type_service.maturator}
                  onChange={() => this.handleTypeServiceChange('maturator')}
                  name="maturator"
                  disabled={this.state.editData === false}
                />
                <span style={{ color: this.state.editData ? 'black' : 'rgba(0, 0, 0, 0.38)' }}>{res.MATURADOR}</span>
              </div>
            </FormControl>
            <FormControl style={{ width: '100%', marginTop: '1rem' }} disabled={this.state.editData === false}>
              <InputLabel htmlFor="type-service">{res.TIPO_SERVICO}</InputLabel>
              <Select
                value={this.state.selectedService}
                onChange={this.handleChange('selectedService')}
                style={{ width: '100%' }}
                inputProps={{
                  name: 'typeService',
                  id: 'type-service',
                }}
                MenuProps={{
                  anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                  },
                  transformOrigin: {
                    vertical: 'top',
                    horizontal: 'left',
                  },
                  getContentAnchorEl: null,
                }}
              >
                <MenuItem value="">{res.SELECIONE_TIPO_SERVICO}</MenuItem>
                <MenuItem value="AplicacaoAgrotoxico">{res.APLICACAO_AGROTOXICO}</MenuItem>
                <MenuItem value="AplicacaoBioinsumo">{res.APLICACAO_BIOINSUMO}</MenuItem>
                <MenuItem value="AplicacaoFertilizante">{res.APLICACAO_FERTILIZANTE}</MenuItem>
                <MenuItem value="Semeadura">{res.SEMEADURA}</MenuItem>
                <MenuItem value="Maturador">{res.MATURADOR}</MenuItem>
                <MenuItem value="AplicacaoAdjuvante">{res.APLICACAO_ADJUVANTE}</MenuItem>
              </Select>
            </FormControl>
          </div>

          <div>
            <TextField
              id="temperature"
              label={res.TEMPERATURA_}
              disabled={this.state.editData === false}
              style={{ marginTop: '1rem', width: '33.34%', paddingRight: '1rem' }}
              value={this.state.temperature}
              onChange={this.handleChange('temperature')}
              inputProps={{ maxLength: fieldLimits.temperature }}
            />
            <TextField
              id="humidity"
              label={res.HUMIDADE_UNI}
              disabled={this.state.editData === false}
              style={{ marginTop: '1rem', width: '33.33%', paddingRight: '1rem' }}
              value={this.state.humidity}
              onChange={this.handleChange('humidity')}
              inputProps={{ maxLength: fieldLimits.humidity }}
            />
            <TextField
              id="windSpeed"
              label={tools.replaceString(res._VELOCIDADE_VENTO, Units.getSpeedUnit(res))}
              disabled={this.state.editData === false}
              style={{ marginTop: '1rem', width: '33.33%' }}
              value={Units.convertSpeed(this.state.wind_speed, 'km/h', res)}
              onChange={(event) => this.setState({ wind_speed: Units.toCanonicalSpeed(event.target.value, res) })}
              inputProps={{ maxLength: fieldLimits.wind_speed }}
            />
          </div>
          <div>
            <TextField
              id="flightHeight"
              label={res.ALTURA_VOO}
              disabled={this.state.editData === false}
              style={{ marginTop: '1rem', width: '50%', paddingRight: '1rem' }}
              value={this.state.flight_height}
              onChange={this.handleChange('flight_height')}
              inputProps={{ maxLength: fieldLimits.flight_height }}
            />
            <TextField
              id="applicationRange"
              label={res.FAIXA_UNI}
              disabled={this.state.editData === false}
              style={{ marginTop: '1rem', width: '50%' }}
              value={this.state.applicationRange}
              onChange={this.handleChange('applicationRange')}
              inputProps={{ maxLength: fieldLimits.applicationRange }}
            />
          </div>

          <div style={{ marginTop: '1rem' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: 24 }}>
              <InputLabel id="plane-label" style={{ position: 'relative', transform: 'none', fontSize: '0.75rem' }}>{res.AERONAVE}</InputLabel>
              {this.state.editData !== false && (
                <FormControlLabel
                  style={{ marginRight: 0, height: 24, marginBottom: 0 }}
                  control={
                    <Checkbox
                      color="primary"
                      checked={this.state.showCustomPlane}
                      onChange={(event) => this.setState({
                        showCustomPlane: event.target.checked,
                        selectedPlaneIds: [],
                        plane: ''
                      })}
                      style={{ padding: 4 }}
                    />
                  }
                  label={<span style={{ fontSize: '0.75rem' }}>{res.PREENCHIMENTO_MANUAL}</span>}
                />
              )}
            </div>

            {!this.state.showCustomPlane ? (
              <FormControl
                style={{ width: '100%' }}
                disabled={this.state.editData === false}
              >
                <Select
                  multiple
                  labelId="plane-label"
                  id="plane"
                  value={this.state.selectedPlaneIds || []}
                  onChange={this.handleChangePlane}
                  displayEmpty
                  renderValue={(selected) => {
                    const names = (this.state.planes || [])
                      .filter((item) => selected.some(id => Number(id) === Number(item.id)))
                      .map((item) => this.getItemOriginalLabel(item));
                    return names.join(', ');
                  }}
                  endAdornment={
                    this.state.plane ? (
                      <IconButton
                        size="small"
                        style={{ marginRight: 24 }}
                        onClick={(event) => {
                          event.stopPropagation();
                          this.clearSelectedPlanes();
                        }}
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    ) : null
                  }
                  MenuProps={{
                    anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                    transformOrigin: { vertical: 'top', horizontal: 'left' },
                    getContentAnchorEl: null,
                  }}
                >
                  {(this.state.planes || []).map((item, index) => (
                    <MenuItem key={item.id || index} value={item.id}>
                      <Checkbox checked={(this.state.selectedPlaneIds || []).some(id => Number(id) === Number(item.id))} />
                      <ListItemText primary={this.limitSelectLabel(item.name)} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            ) : (
              <TextField
                id="planeManual"
                disabled={this.state.editData === false}
                fullWidth
                style={{ marginTop: 0 }}
                value={this.state.plane}
                onChange={this.handlePlaneInputChange}
                inputProps={{ maxLength: fieldLimits.plane }}
                InputLabelProps={{ shrink: true }}
              />
            )}
          </div>

          <div style={{ marginTop: '1rem' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: 24, width: '40%', paddingRight: '1rem' }}>
              <InputLabel id="pilot-label" style={{ position: 'relative', transform: 'none', fontSize: '0.75rem' }}>{res.PILOTO}</InputLabel>
              {this.state.editData !== false && (
                <FormControlLabel
                  style={{ marginRight: 0, height: 24, marginBottom: 0 }}
                  control={
                    <Checkbox
                      color="primary"
                      checked={this.state.showCustomPilot}
                      onChange={(event) => this.setState({
                        showCustomPilot: event.target.checked,
                        id_pilot: '',
                        selectedPilotIds: [],
                        pilot: '',
                        canac: '',
                        pilotEmail: ''
                      })}
                      style={{ padding: 4 }}
                    />
                  }
                  label={<span style={{ fontSize: '0.75rem' }}>{res.PREENCHIMENTO_MANUAL}</span>}
                />
              )}
            </div>

            {!this.state.showCustomPilot ? (
              <FormControl
                style={{ width: '40%', paddingRight: '1rem', paddingTop: '1rem' }}
                disabled={this.state.editData === false}
              >
                <Select
                  multiple
                  labelId="pilot-label"
                  id="pilot"
                  value={this.state.selectedPilotIds || []}
                  onChange={this.handleChangePilot}
                  displayEmpty
                  renderValue={(selected) => {
                    const names = (this.state.pilots || [])
                      .filter((item) => selected.some(id => Number(id) === Number(item.id)))
                      .map((item) => this.getItemOriginalLabel(item));
                    return names.join(', ');
                  }}
                  endAdornment={
                    this.state.pilot ? (
                      <IconButton
                        size="small"
                        style={{ marginRight: 24 }}
                        onClick={(event) => {
                          event.stopPropagation();
                          this.clearSelectedPilots();
                        }}
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    ) : null
                  }
                  MenuProps={{
                    anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                    transformOrigin: { vertical: 'top', horizontal: 'left' },
                    getContentAnchorEl: null,
                  }}
                >
                  {(this.state.pilots || []).map((item, index) => (
                    <MenuItem key={item.id || index} value={item.id}>
                      <Checkbox checked={(this.state.selectedPilotIds || []).some(id => Number(id) === Number(item.id))} />
                      <ListItemText primary={this.limitSelectLabel(item.name)} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            ) : (
              <TextField
                id="pilotManual"
                disabled={this.state.editData === false}
                style={{ marginTop: 0, width: '40%', paddingRight: '1rem', paddingTop: '1rem' }}
                value={this.state.pilot}
                onChange={this.handlePilotInputChange}
                inputProps={{ maxLength: fieldLimits.pilot }}
                InputLabelProps={{ shrink: true }}
              />
            )}
            <TextField
              id="canac"
              label={res.CHT}
              disabled={this.state.editData === false}
              style={{ marginTop: 0, width: '30%', paddingRight: '1rem' }}
              value={this.state.canac}
              onChange={this.handleChange('canac')}
              inputProps={{ maxLength: fieldLimits.canac }}
            />
            <TextField
              id="pilotEmail"
              label={res.EMAIL}
              disabled={this.state.editData === false}
              style={{ marginTop: 0, width: '30%' }}
              value={this.state.pilotEmail ? this.state.pilotEmail : ''}
              error={this.isInvalidEmail(this.state.pilotEmail)}
              helperText={this.isInvalidEmail(this.state.pilotEmail) ? this.getInvalidEmailMessage() : ''}
              onChange={(e) => {
                e.target.value = e.target.value.toLowerCase();
                this.handleChange('pilotEmail')(e);
              }}
            />
          </div>
          <div>
            <div>
              <FormControl style={{ display: 'flex', flexDirection: 'row', marginTop: '1rem', width: '100%' }} disabled={!this.state.editData}>
                <FormLabel style={{ display: 'flex', alignItems: 'center', marginRight: '1rem' }}>{res.EQUIPAMENTO}:</FormLabel>
                <RadioGroup style={{ display: 'flex', flexDirection: 'row' }} value={this.state.equipment.type} onChange={this.handleChange('equipment')}>
                  <FormControlLabel style={{ marginRight: '2rem' }} value="bicoHidraulicoCoreDisco" control={<Radio color="primary" />} label={res.BICO_HIDRAULICO_CORE_DISCO} />
                  <FormControlLabel style={{ marginRight: '2rem' }} value="bicoHidraulicoCeramica" control={<Radio color="primary" />} label={res.BICO_HIDRAULICO_CERAMICA} />
                  <FormControlLabel style={{ marginRight: '2rem' }} value="bicoHidraulicoSolido" control={<Radio color="primary" />} label={res.BICO_HIDRAULICO_SOLIDO} />
                  <FormControlLabel style={{ marginRight: '2rem' }} value="bicoHidraulicoPlano" control={<Radio color="primary" />} label={res.BICO_HIDRAULICO_PLANO} />
                  <FormControlLabel style={{ marginRight: '2rem' }} value="cp03tt03" control={<Radio color="primary" />} label={res.CP03_TT03} />
                  <FormControlLabel style={{ marginRight: '2rem' }} value="cp09tt09" control={<Radio color="primary" />} label={res.CP09_TT09} />
                  <FormControlLabel style={{ marginRight: '2rem' }} value="cp11tt11" control={<Radio color="primary" />} label={res.CP11_TT11} />
                  <FormControlLabel style={{ marginRight: '2rem' }} value="atomizadorTela" control={<Radio color="primary" />} label={res.ATOMIZADOR_TELA} />
                  <FormControlLabel style={{ marginRight: '2rem' }} value="atomizadorDisco" control={<Radio color="primary" />} label={res.ATOMIZADOR_DISCO} />
                  <FormControlLabel style={{ marginRight: '2rem' }} value="swathmaster" control={<Radio color="primary" />} label={res.DIFUSOR_SOLIDOS} />
                  <FormControlLabel style={{ marginRight: '2rem' }} value="outro" control={<Radio color="primary" />} label={res.OUTROTXT} />
                </RadioGroup>
              </FormControl>
              {this.renderEquipmentDetailsInput()}
            </div>
            <div>
              <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '1rem 0' }}>
                  <span style={{ color: this.state.editData ? 'black' : 'rgba(0, 0, 0, 0.38)' }}>{res.LISTA_PRODUTOS}</span>
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <input
                      type="text"
                      placeholder="Filtrar produtos"
                      value={this.state.filter}
                      onChange={this.handleFilterChange}
                      style={{ border: 'none', borderBottom: this.state.editData ? '1px solid black' : '1px solid rgba(0, 0, 0, 0.38)', outline: 'none', fontSize: '0.75rem', width: '6rem' }}
                      disabled={this.state.editData === false}
                    />
                    <SearchIcon style={{ color: this.state.editData ? 'black' : 'rgba(0, 0, 0, 0.38)', borderBottom: this.state.editData ? '1px solid black' : '1px solid rgba(0, 0, 0, 0.38)', marginTop: '-3px' }} />
                    <IconButton title={res.CADASTRAR} aria-label="add" onClick={this.openNewProductModal} disabled={this.state.editData === false}>
                      <AddIcon />
                    </IconButton>
                  </div>
                </div>
                <div style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  justifyContent: 'flex-start',
                  padding: '0',
                  margin: '0 -0.5rem',
                }}>
                  {currentItems.map(product => (
                    <div key={product.id} style={{
                      padding: '0.5rem',
                      width: 'calc(33.33% - 1rem)',
                      boxSizing: 'border-box',
                    }}
                    >
                      <label
                        style={{
                          display: 'block',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          color: this.state.editData ? 'black' : 'rgba(0, 0, 0, 0.38)'
                        }}
                        disabled={!this.state.editData}
                      >
                        <input
                          type="checkbox"
                          style={{ width: '1.25rem', height: '1.25rem', marginRight: '0.5rem', cursor: this.state.editData ? 'pointer' : null }}
                          checked={this.state.product.some(p => p.id === product.id)}
                          onChange={() => this.handleProductChange(product)}
                          disabled={!this.state.editData}
                        />
                        {product.name}
                      </label>
                      {this.state.product.some(p => p.id === product.id) && (
                        <div style={{ display: 'flex', alignItems: 'flex-end', gap: '8px' }}>
                          <TextField
                            select
                            label={res.UNIDADE}
                            value={(this.state.product.find(p => p.id === product.id)?.unit || '').toLowerCase()}
                            onChange={(e) =>
                              this.handleFieldChange(product.id, 'unit', this.normalizeUnit(e.target.value))
                            }
                            SelectProps={{
                              displayEmpty: true,
                              renderValue: (val) =>
                                val === '' ? <span style={{ opacity: 0.6 }}>{res.SELECIONE}</span>
                                  : (val === 'l' ? res.LITROS : res.KG)
                            }}
                            InputLabelProps={{ shrink: true, style: { fontSize: '0.8rem' } }}
                            margin="normal"
                            disabled={!this.state.editData}
                            style={{ width: '10rem' }}
                          >
                            <MenuItem value="">{res.SELECIONE}</MenuItem>
                            <MenuItem value="l">{res.LITROS}</MenuItem>
                            <MenuItem value="kg">{res.KG}</MenuItem>
                          </TextField>

                          <TextField
                            label="Dosagem"
                            value={this.state.product.find(p => p.id === product.id)?.dosage || ''}
                            onChange={(e) => this.handleFieldChange(product.id, 'dosage', e.target.value)}
                            disabled={!this.state.editData}
                            InputLabelProps={{ style: { fontSize: '0.8rem' } }}
                            style={{ width: '6rem' }}
                            margin="normal"
                          />

                          <TextField
                            label="Classe Toxicológica"
                            value={this.state.product.find(p => p.id === product.id)?.class || this.state.product.find(p => p.id === product.id)?.toxicClass || ''}
                            onChange={(e) => this.handleFieldChange(product.id, 'toxicClass', e.target.value)}
                            disabled={!this.state.editData}
                            InputLabelProps={{ style: { fontSize: '0.8rem' } }}
                            style={{ width: '12rem' }}
                            margin="normal"
                          />

                          <TextField
                            label="Taxa de Aplicação"
                            value={this.state.product.find(p => p.id === product.id)?.applicationRate || ''}
                            onChange={(e) => this.handleFieldChange(product.id, 'applicationRate', e.target.value)}
                            disabled={!this.state.editData}
                            InputLabelProps={{ style: { fontSize: '0.8rem' } }}
                            style={{ width: '10rem' }}
                            margin="normal"
                          />
                        </div>
                      )}
                    </div>
                  ))}
                </div>
                {this.renderPaginationControls()}
              </div>
              {this.state.product.length > 0 ?
                <div style={{ marginBottom: '1rem', border: '1px solid gray', padding: '0.25rem' }}>
                  <span style={{ color: this.state.editData ? 'black' : 'rgba(0, 0, 0, 0.38)' }}>{res.PRODUTOS_SELECIONADOS}</span>
                  <div style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'flex-start',
                    padding: '0',
                    margin: '0 -0.5rem',
                  }}>
                    {this.state.product.map(product => (
                      <div key={product.id} style={{
                        padding: '0.5rem',
                        width: 'calc(33.33% - 1rem)',
                        boxSizing: 'border-box',
                      }}>
                        <label
                          style={{
                            display: 'block',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            color: this.state.editData ? 'black' : 'rgba(0, 0, 0, 0.38)'
                          }}
                          disabled={!this.state.editData}
                        >
                          <input
                            type="checkbox"
                            style={{ width: '1.25rem', height: '1.25rem', marginRight: '0.5rem', cursor: this.state.editData ? 'pointer' : null }}
                            checked={this.state.product.some(p => p.id === product.id)}
                            onChange={() => this.handleProductChange(product)}
                            disabled={!this.state.editData}
                          />
                          {product.name}
                        </label>
                        <div style={{ display: 'flex', alignItems: 'flex-end', gap: '8px' }}>
                          <TextField
                            select
                            label={res.UNIDADE}
                            value={(this.state.product.find(p => p.id === product.id)?.unit || '').toLowerCase()}
                            onChange={(e) =>
                              this.handleFieldChange(product.id, 'unit', this.normalizeUnit(e.target.value))
                            }
                            SelectProps={{
                              displayEmpty: true,
                              renderValue: (val) =>
                                val === '' ? <span style={{ opacity: 0.6 }}>{res.SELECIONE}</span>
                                  : (val === 'l' ? res.LITROS : res.KG)
                            }}
                            InputLabelProps={{ shrink: true, style: { fontSize: '0.8rem' } }}
                            margin="normal"
                            disabled={!this.state.editData}
                            style={{ width: '10rem' }}
                          >
                            <MenuItem value="">{res.SELECIONE}</MenuItem>
                            <MenuItem value="l">{res.LITROS}</MenuItem>
                            <MenuItem value="kg">{res.KG}</MenuItem>
                          </TextField>

                          <TextField
                            label="Dosagem"
                            value={product.dosage || ''}
                            onChange={(e) => this.handleFieldChange(product.id, 'dosage', e.target.value)}
                            disabled={!this.state.editData}
                            InputLabelProps={{ shrink: true, style: { fontSize: '0.8rem' } }}
                            style={{ width: '6rem' }}
                            margin="normal"
                          />

                          <TextField
                            label="Classe Toxicológica"
                            value={product.class || product.toxicClass || ''}
                            onChange={(e) => this.handleFieldChange(product.id, 'toxicClass', e.target.value)}
                            disabled={!this.state.editData}
                            InputLabelProps={{ shrink: true, style: { fontSize: '0.8rem' } }}
                            style={{ width: '12rem' }}
                            margin="normal"
                          />

                          <TextField
                            label="Taxa de Aplicação"
                            value={product.applicationRate || ''}
                            onChange={(e) => this.handleFieldChange(product.id, 'applicationRate', e.target.value)}
                            disabled={!this.state.editData}
                            InputLabelProps={{ shrink: true, style: { fontSize: '0.8rem' } }}
                            style={{ width: '10rem' }}
                            margin="normal"
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                : null}
            </div>
          </div>
          <div>
            <FormLabel style={{ display: 'flex', alignItems: 'center', marginRight: '1rem', color: this.state.editData ? 'black' : 'rgba(0, 0, 0, 0.38)' }}>{res.CONDICOES_APLICACAO}</FormLabel>
            <TextField
              label={res.DATA_INICIO}
              type="date"
              value={this.state.applicationConditions.data}
              onChange={(e) => this.handleDateChange(e.target.value, 'data')}
              disabled={!this.state.editData}
              InputLabelProps={{
                shrink: true,
              }}
              style={{ marginTop: '1rem' }}
            />

            <TextField
              label={res.DATA_FIM}
              type="date"
              value={this.state.applicationConditions.dataFim}
              onChange={(e) => this.handleDateChange(e.target.value, 'dataFim')}
              disabled={!this.state.editData}
              InputLabelProps={{
                shrink: true,
              }}
              style={{ marginTop: '1rem', marginLeft: '1rem' }}
            />
            <div style={{ display: 'flex' }}>
              <div style={{ width: '25%' }}>
                <FormLabel style={{ display: 'flex', alignItems: 'center', marginTop: '1rem', marginRight: '1rem', color: this.state.editData ? 'black' : 'rgba(0, 0, 0, 0.38)' }}>{res.TEMPERATURA_}</FormLabel>
                <div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <input
                      type="checkbox"
                      style={{ width: '1.25rem', height: '1.25rem', marginRight: '0.5rem', cursor: this.state.editData ? 'pointer' : null }}
                      checked={this.state.applicationConditions.temperaturaMatutino}
                      onChange={() => this.handleCheckboxChange('temperaturaMatutino')}
                      disabled={this.state.editData === false}
                    />
                    <span style={{ color: this.state.editData ? 'black' : 'rgba(0, 0, 0, 0.38)' }}>{res.MATUTINO}</span>
                  </div>
                  {this.state.applicationConditions.temperaturaMatutino && (
                    <div>
                      <TextField
                        label={res.TEMPERATURA_INI_MATUTINO}
                        value={this.state.applicationConditions.temperaturaInicialMatutino}
                        onChange={(e) => this.handleInputChange('temperaturaInicialMatutino', e.target.value)}
                        disabled={!this.state.editData}
                        InputLabelProps={{
                          style: { fontSize: '0.8rem' }
                        }}
                        style={{ padding: '0 1rem 0 0', margin: '0.5rem 0', width: '100%' }}
                      />
                      <TextField
                        label={res.TEMPERATURA_FIN_MATUTINO}
                        value={this.state.applicationConditions.temperaturaFinalMatutino}
                        onChange={(e) => this.handleInputChange('temperaturaFinalMatutino', e.target.value)}
                        disabled={!this.state.editData}
                        InputLabelProps={{
                          style: { fontSize: '0.8rem' }
                        }}
                        style={{ padding: '0 1rem 0 0', margin: '0.5rem 0', width: '100%' }}
                      />
                    </div>
                  )}
                </div>
                <div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <input
                      type="checkbox"
                      style={{ width: '1.25rem', height: '1.25rem', marginRight: '0.5rem', cursor: this.state.editData ? 'pointer' : null }}
                      checked={this.state.applicationConditions.temperaturaVespertino}
                      onChange={() => this.handleCheckboxChange('temperaturaVespertino')}
                      disabled={!this.state.editData}
                    />
                    <span style={{ color: this.state.editData ? 'black' : 'rgba(0, 0, 0, 0.38)' }}>{res.VESPERTINO}</span>
                  </div>
                  {this.state.applicationConditions.temperaturaVespertino && (
                    <div>
                      <TextField
                        label={res.TEMPERATURA_INI_VESPERTINO}
                        value={this.state.applicationConditions.temperaturaInicialVespertino}
                        onChange={(e) => this.handleInputChange('temperaturaInicialVespertino', e.target.value)}
                        disabled={!this.state.editData}
                        InputLabelProps={{
                          style: { fontSize: '0.8rem' }
                        }}
                        style={{ padding: '0 1rem 0 0', margin: '0.5rem 0', width: '100%' }}
                      />
                      <TextField
                        label={res.TEMPERATURA_FIN_VESPERTINO}
                        value={this.state.applicationConditions.temperaturaFinalVespertino}
                        onChange={(e) => this.handleInputChange('temperaturaFinalVespertino', e.target.value)}
                        disabled={!this.state.editData}
                        InputLabelProps={{
                          style: { fontSize: '0.8rem' }
                        }}
                        style={{ padding: '0 1rem 0 0', margin: '0.5rem 0', width: '100%' }}
                      />
                    </div>
                  )}
                </div>
              </div>

              <div style={{ width: '25%' }}>
                <FormLabel style={{ display: 'flex', alignItems: 'center', marginTop: '1rem', marginRight: '1rem', color: this.state.editData ? 'black' : 'rgba(0, 0, 0, 0.38)' }}>{res.UMIDADE_}</FormLabel>
                <div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <input
                      type="checkbox"
                      style={{ width: '1.25rem', height: '1.25rem', marginRight: '0.5rem', cursor: this.state.editData ? 'pointer' : null }}
                      checked={this.state.applicationConditions.umidadeMatutino}
                      onChange={() => this.handleCheckboxChange('umidadeMatutino')}
                      disabled={!this.state.editData}
                    />
                    <span style={{ color: this.state.editData ? 'black' : 'rgba(0, 0, 0, 0.38)' }}>{res.MATUTINO}</span>
                  </div>
                  {this.state.applicationConditions.umidadeMatutino && (
                    <div>
                      <TextField
                        label={res.UMIDADE_INI_MATUTINO}
                        value={this.state.applicationConditions.umidadeInicialMatutino}
                        onChange={(e) => this.handleInputChange('umidadeInicialMatutino', e.target.value)}
                        disabled={!this.state.editData}
                        InputLabelProps={{
                          style: { fontSize: '0.8rem' }
                        }}
                        style={{ padding: '0 1rem 0 0', margin: '0.5rem 0', width: '100%' }}
                      />
                      <TextField
                        label={res.UMIDADE_FIN_MATUTINO}
                        value={this.state.applicationConditions.umidadeFinalMatutino}
                        onChange={(e) => this.handleInputChange('umidadeFinalMatutino', e.target.value)}
                        disabled={!this.state.editData}
                        InputLabelProps={{
                          style: { fontSize: '0.8rem' }
                        }}
                        style={{ padding: '0 1rem 0 0', margin: '0.5rem 0', width: '100%' }}
                      />
                    </div>
                  )}
                </div>
                <div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <input
                      type="checkbox"
                      style={{ width: '1.25rem', height: '1.25rem', marginRight: '0.5rem', cursor: this.state.editData ? 'pointer' : null }}
                      checked={this.state.applicationConditions.umidadeVespertino}
                      onChange={() => this.handleCheckboxChange('umidadeVespertino')}
                      disabled={!this.state.editData}
                    />
                    <span style={{ color: this.state.editData ? 'black' : 'rgba(0, 0, 0, 0.38)' }}>{res.VESPERTINO}</span>
                  </div>
                  {this.state.applicationConditions.umidadeVespertino && (
                    <div>
                      <TextField
                        label={res.UMIDADE_INI_VESPERTINO}
                        value={this.state.applicationConditions.umidadeInicialVespertino}
                        onChange={(e) => this.handleInputChange('umidadeInicialVespertino', e.target.value)}
                        disabled={!this.state.editData}
                        InputLabelProps={{
                          style: { fontSize: '0.8rem' }
                        }}
                        style={{ padding: '0 1rem 0 0', margin: '0.5rem 0', width: '100%' }}
                      />
                      <TextField
                        label={res.UMIDADE_FIN_VESPERTINO}
                        value={this.state.applicationConditions.umidadeFinalVespertino}
                        onChange={(e) => this.handleInputChange('umidadeFinalVespertino', e.target.value)}
                        disabled={!this.state.editData}
                        InputLabelProps={{
                          style: { fontSize: '0.8rem' }
                        }}
                        style={{ padding: '0 1rem 0 0', margin: '0.5rem 0', width: '100%' }}
                      />
                    </div>
                  )}
                </div>
              </div>

              <div style={{ width: '25%' }}>
                <FormLabel style={{ display: 'flex', alignItems: 'center', marginTop: '1rem', marginRight: '1rem', color: this.state.editData ? 'black' : 'rgba(0, 0, 0, 0.38)' }}>{res.VENTO_VELOCIDADE}</FormLabel>
                <div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <input
                      type="checkbox"
                      style={{ width: '1.25rem', height: '1.25rem', marginRight: '0.5rem', cursor: this.state.editData ? 'pointer' : null }}
                      checked={this.state.applicationConditions.velocidadeMatutino}
                      onChange={() => this.handleCheckboxChange('velocidadeMatutino')}
                      disabled={!this.state.editData}
                    />
                    <span style={{ color: this.state.editData ? 'black' : 'rgba(0, 0, 0, 0.38)' }}>{res.MATUTINO}</span>
                  </div>
                  {this.state.applicationConditions.velocidadeMatutino && (
                    <div>
                      <TextField
                        label={res.VEL_VENTO_INI_MATUTINO}
                        value={this.state.applicationConditions.velocidadeInicialMatutino}
                        onChange={(e) => this.handleInputChange('velocidadeInicialMatutino', e.target.value)}
                        disabled={!this.state.editData}
                        InputLabelProps={{
                          style: { fontSize: '0.8rem' }
                        }}
                        style={{ padding: '0 1rem 0 0', margin: '0.5rem 0', width: '100%' }}
                      />
                      <TextField
                        label={res.VEL_VENTO_FIN_MATUTINO}
                        value={this.state.applicationConditions.velocidadeFinalMatutino}
                        onChange={(e) => this.handleInputChange('velocidadeFinalMatutino', e.target.value)}
                        disabled={!this.state.editData}
                        InputLabelProps={{
                          style: { fontSize: '0.8rem' }
                        }}
                        style={{ padding: '0 1rem 0 0', margin: '0.5rem 0', width: '100%' }}
                      />
                    </div>
                  )}
                </div>
                <div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <input
                      type="checkbox"
                      style={{ width: '1.25rem', height: '1.25rem', marginRight: '0.5rem', cursor: this.state.editData ? 'pointer' : null }}
                      checked={this.state.applicationConditions.velocidadeVespertino}
                      onChange={() => this.handleCheckboxChange('velocidadeVespertino')}
                      disabled={!this.state.editData}
                    />
                    <span style={{ color: this.state.editData ? 'black' : 'rgba(0, 0, 0, 0.38)' }}>{res.VESPERTINO}</span>
                  </div>
                  {this.state.applicationConditions.velocidadeVespertino && (
                    <div>
                      <TextField
                        label={res.VEL_VENTO_INI_VESPERTINO}
                        value={this.state.applicationConditions.velocidadeInicialVespertino}
                        onChange={(e) => this.handleInputChange('velocidadeInicialVespertino', e.target.value)}
                        disabled={!this.state.editData}
                        InputLabelProps={{
                          style: { fontSize: '0.8rem' }
                        }}
                        style={{ padding: '0 1rem 0 0', margin: '0.5rem 0', width: '100%' }}
                      />
                      <TextField
                        label={res.VEL_VENTO_FIN_VESPERTINO}
                        value={this.state.applicationConditions.velocidadeFinalVespertino}
                        onChange={(e) => this.handleInputChange('velocidadeFinalVespertino', e.target.value)}
                        disabled={!this.state.editData}
                        InputLabelProps={{
                          style: { fontSize: '0.8rem' }
                        }}
                        style={{ padding: '0 1rem 0 0', margin: '0.5rem 0', width: '100%' }}
                      />
                    </div>
                  )}
                </div>
              </div>

              <div style={{ width: '25%' }}>
                <FormLabel style={{ display: 'flex', alignItems: 'center', marginTop: '1rem', marginRight: '1rem', color: this.state.editData ? 'black' : 'rgba(0, 0, 0, 0.38)' }}>{res.HORARIO_APLICACAO}</FormLabel>
                <div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <input
                      type="checkbox"
                      style={{ width: '1.25rem', height: '1.25rem', marginRight: '0.5rem', cursor: this.state.editData ? 'pointer' : null }}
                      checked={this.state.applicationConditions.horarioMatutino}
                      onChange={() => this.handleCheckboxChange('horarioMatutino')}
                      disabled={!this.state.editData}
                    />
                    <span style={{ color: this.state.editData ? 'black' : 'rgba(0, 0, 0, 0.38)' }}>{res.MATUTINO}</span>
                  </div>
                  {this.state.applicationConditions.horarioMatutino && (
                    <div>
                      <TextField
                        type="time"
                        label={res.HORARIO_APLICACAO_INI_MATUTINO}
                        value={this.state.applicationConditions.horarioInicialMatutino}
                        onChange={(e) => this.handleInputChange('horarioInicialMatutino', e.target.value)}
                        disabled={!this.state.editData}
                        InputLabelProps={{
                          shrink: true,
                          style: { fontSize: '0.8rem' }
                        }}
                        inputProps={{
                          step: 300,
                        }}
                        style={{ padding: '0 1rem 0 0', margin: '0.5rem 0', width: '100%' }}
                      />
                      <TextField
                        type="time"
                        label={res.HORARIO_APLICACAO_FIN_MATUTINO}
                        value={this.state.applicationConditions.horarioFinalMatutino}
                        onChange={(e) => this.handleInputChange('horarioFinalMatutino', e.target.value)}
                        disabled={!this.state.editData}
                        InputLabelProps={{
                          shrink: true,
                          style: { fontSize: '0.8rem' }
                        }}
                        inputProps={{
                          step: 300,
                        }}
                        style={{ padding: '0 1rem 0 0', margin: '0.5rem 0', width: '100%' }}
                      />
                    </div>
                  )}
                </div>
                <div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <input
                      type="checkbox"
                      style={{ width: '1.25rem', height: '1.25rem', marginRight: '0.5rem', cursor: this.state.editData ? 'pointer' : null }}
                      checked={this.state.applicationConditions.horarioVespertino}
                      onChange={() => this.handleCheckboxChange('horarioVespertino')}
                      disabled={!this.state.editData}
                    />
                    <span style={{ color: this.state.editData ? 'black' : 'rgba(0, 0, 0, 0.38)' }}>{res.VESPERTINO}</span>
                  </div>
                  {this.state.applicationConditions.horarioVespertino && (
                    <div>
                      <TextField
                        type="time"
                        label={res.HORARIO_APLICACAO_INI_VESPERTINO}
                        value={this.state.applicationConditions.horarioInicialVespertino}
                        onChange={(e) => this.handleInputChange('horarioInicialVespertino', e.target.value)}
                        disabled={!this.state.editData}
                        InputLabelProps={{
                          shrink: true,
                          style: { fontSize: '0.8rem' }
                        }}
                        inputProps={{
                          step: 300,
                        }}
                        style={{ padding: '0 1rem 0 0', margin: '0.5rem 0', width: '100%' }}
                      />
                      <TextField
                        type="time"
                        label={res.HORARIO_APLICACAO_FIN_VESPERTINO}
                        value={this.state.applicationConditions.horarioFinalVespertino}
                        onChange={(e) => this.handleInputChange('horarioFinalVespertino', e.target.value)}
                        disabled={!this.state.editData}
                        InputLabelProps={{
                          shrink: true,
                          style: { fontSize: '0.8rem' }
                        }}
                        inputProps={{
                          step: 300,
                        }}
                        style={{ padding: '0 1rem 0 0', margin: '0.5rem 0', width: '100%' }}
                      />
                    </div>
                  )}
                </div>
              </div>

            </div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <FormControl style={{ marginTop: '1rem', width: '50%', paddingRight: '1rem' }} disabled={!this.state.editData}>
              <InputLabel>{res.EXECUTOR}</InputLabel>
              <Select
                id="executor"
                value={this.state.executor}
                onChange={this.handleTechnicianChange}
                MenuProps={{
                  anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                  },
                  transformOrigin: {
                    vertical: 'top',
                    horizontal: 'left',
                  },
                  getContentAnchorEl: null,
                }}
              >
                {this.state.technicians.map((technician) => (
                  <MenuItem key={technician.id} value={technician.name}>
                    {technician.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              id="creaExecutor"
              label={res.CFTA}
              disabled={!this.state.editData}
              style={{ marginTop: '1rem', width: '50%', paddingRight: '1rem' }}
              value={this.state.executor_crea_cpf}
              onChange={this.handleChange('executor_crea_cpf')}
            />
            <TextField
              id="executorEmail"
              label={res.EMAIL}
              disabled={this.state.editData === false}
              style={{ marginTop: '1rem', width: '50%' }}
              value={this.state.executorEmail ? this.state.executorEmail : ''}
              error={this.isInvalidEmail(this.state.executorEmail)}
              helperText={this.isInvalidEmail(this.state.executorEmail) ? this.getInvalidEmailMessage() : ''}
              onChange={(e) => {
                e.target.value = e.target.value.toLowerCase();
                this.handleChange('executorEmail')(e);
              }}
            />
          </div>
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <FormControl style={{ marginTop: '1rem', width: '50%', paddingRight: '1rem' }} disabled={!this.state.editData}>
              <InputLabel>{res.ENG_AGRONOMO}</InputLabel>
              <Select
                id="agriculturalEngineer"
                value={this.state.agricultural_engineer}
                onChange={this.handleAgronomistChange}
                MenuProps={{
                  anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                  },
                  transformOrigin: {
                    vertical: 'top',
                    horizontal: 'left',
                  },
                  getContentAnchorEl: null,
                }}
              >
                {this.state.agronomists.map((agronomist) => (
                  <MenuItem key={agronomist.id} value={agronomist.name}>
                    {agronomist.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              id="engineerCrea"
              label={res.CREA}
              disabled={!this.state.editData}
              style={{ marginTop: '1rem', width: '50%', paddingRight: '1rem' }}
              value={this.state.engineer_crea_cpf}
              onChange={this.handleChange('engineer_crea_cpf')}
            />
            <TextField
              id="engineerEmail"
              label={res.EMAIL}
              disabled={this.state.editData === false}
              style={{ marginTop: '1rem', width: '50%' }}
              value={this.state.engineerEmail ? this.state.engineerEmail : ''}
              error={this.isInvalidEmail(this.state.engineerEmail)}
              helperText={this.isInvalidEmail(this.state.engineerEmail) ? this.getInvalidEmailMessage() : ''}
              onChange={(e) => {
                e.target.value = e.target.value.toLowerCase();
                this.handleChange('engineerEmail')(e);
              }}
            />
          </div>

          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <FormControl style={{ marginTop: '1rem', width: '50%', paddingRight: '1rem' }} disabled={!this.state.editData}>
              <InputLabel>{res.RESPONSAVEL_TECNICO}</InputLabel>
              <Select
                id="responsibleTechnician"
                value={this.state.responsibleTechnician}
                onChange={this.handleResponsibleTechnicianChange}
                MenuProps={{
                  anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                  },
                  transformOrigin: {
                    vertical: 'top',
                    horizontal: 'left',
                  },
                  getContentAnchorEl: null,
                }}
              >
                {this.state.technicians.map((agronomist) => (
                  <MenuItem key={agronomist.id} value={agronomist.name}>
                    {agronomist.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              id="responsibleTechnician_crea_cfta"
              label={res.CREA}
              disabled={!this.state.editData}
              style={{ marginTop: '1rem', width: '50%', paddingRight: '1rem' }}
              value={this.state.responsibleTechnician_crea_cfta}
              onChange={this.handleChange('responsibleTechnician_crea_cfta')}
            />
            <TextField
              id="responsibleTechnicianEmail"
              label={res.EMAIL}
              disabled={this.state.editData === false}
              style={{ marginTop: '1rem', width: '50%' }}
              value={this.state.responsibleTechnicianEmail ? this.state.responsibleTechnicianEmail : ''}
              error={this.isInvalidEmail(this.state.responsibleTechnicianEmail)}
              helperText={this.isInvalidEmail(this.state.responsibleTechnicianEmail) ? this.getInvalidEmailMessage() : ''}
              onChange={(e) => {
                e.target.value = e.target.value.toLowerCase();
                this.handleChange('responsibleTechnicianEmail')(e);
              }}
            />
          </div>
          <div>
            <TextField
              id="latitude"
              label={res.LATITUDE}
              disabled={!this.state.editData}
              style={{ marginTop: '1rem', width: '50%', paddingRight: '1rem' }}
              value={this.state.latitude}
              onChange={this.handleChangeCoordinates('latitude')}
            />
            <TextField
              id="longitude"
              label={res.LONGITUDE}
              disabled={!this.state.editData}
              style={{ marginTop: '1rem', width: '50%' }}
              value={this.state.longitude}
              onChange={this.handleChangeCoordinates('longitude')}
            />
          </div>
          <div>
            <TextField
              id="runwayLatitude"
              label={res.LATITUDE_PISTA}
              disabled={!this.state.editData}
              style={{ marginTop: '1rem', width: '50%', paddingRight: '1rem' }}
              value={this.state.runway_latitude}
              onChange={this.handleChangeCoordinates('runway_latitude')}
            />
            <TextField
              id="runwayLongitude"
              label={res.LONGITUDE_PISTA}
              disabled={!this.state.editData}
              style={{ marginTop: '1rem', width: '50%' }}
              value={this.state.runway_longitude}
              onChange={this.handleChangeCoordinates('runway_longitude')}
            />
          </div>
          <div>
            <TextField
              id="runwayDistance"
              label={res.DISTANCIA_PISTA}
              disabled={!this.state.editData}
              style={{ marginTop: '1rem', width: '50%', paddingRight: '1rem' }}
              value={this.state.runwayDistance}
              onChange={this.handleChange('runwayDistance')}
            />
            <TextField
              id="polygonName"
              label={res.NOME_TALHAO}
              disabled={!this.state.editData}
              style={{ marginTop: '1rem', width: '50%' }}
              value={this.state.polygonName || ''}
              onChange={(e) => {
                const v = (e && e.target && e.target.value ? e.target.value : '').slice(0, maxCaracteres);
                this.setState({ polygonName: v });
              }}
              inputProps={{ maxLength: maxCaracteres }}
            />
          </div>
          <div>
            <div>
              <FormControl style={{ marginTop: '1rem', width: '50%', paddingRight: '1rem' }} disabled={!this.state.editData}>
                <InputLabel id="windDirection-label">{res.DIRECAO_VENTO}</InputLabel>
                <Select
                  labelId="windDirection-label"
                  id="windDirection"
                  value={this.state.wind_direction}
                  onChange={this.handleChange('wind_direction')}
                  style={{ marginTop: this.state.wind_direction ? '0.5rem' : null }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 224,
                        width: 250,
                      },
                    },
                    anchorOrigin: {
                      vertical: 'bottom',
                      horizontal: 'left',
                    },
                    transformOrigin: {
                      vertical: 'top',
                      horizontal: 'left',
                    },
                    getContentAnchorEl: null,
                  }}
                >
                  {directionOptions.map(option => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label} {option.icon}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl style={{ marginTop: '1rem', width: '50%', paddingRight: '1rem' }} disabled={!this.state.editData}>
                <InputLabel id="flightDirection-label">{res.DIRECAO_TIRO}</InputLabel>
                <Select
                  labelId="flightDirection-label"
                  id="flightDirection"
                  multiple
                  value={Array.isArray(this.state.flight_direction) ? this.state.flight_direction.filter(value => value !== undefined) : []}
                  onChange={this.handleDirectionChange}
                  renderValue={(selected) => {
                    const selectedArray = Array.isArray(selected) ? selected : [];
                    return (
                      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                        {selectedArray.map((value, index) => {
                          const option = appDirectionOptions.find(opt => opt.value === value);
                          if (!option) {
                            return null;
                          }
                          return (
                            <div key={value} style={{ display: 'flex', alignItems: 'center', marginRight: '8px' }}>
                              <span>{option.label}</span>
                              {option.icon}
                              {index < selectedArray.length - 1 ? ', ' : ''}
                            </div>
                          );
                        })}
                      </div>
                    );
                  }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 224,
                        width: 250,
                      },
                    },
                    anchorOrigin: {
                      vertical: 'bottom',
                      horizontal: 'left',
                    },
                    transformOrigin: {
                      vertical: 'top',
                      horizontal: 'left',
                    },
                    getContentAnchorEl: null,
                  }}
                >
                  {appDirectionOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      <Checkbox checked={this.state.flight_direction.indexOf(option.value) > -1} />
                      <ListItemText primary={option.label} />
                      {option.icon}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>

            <div
              id="mapid"
              style={{
                width: '100%',
                height: '500px',
                margin: '1rem 0',
                pointerEvents: !this.state.editData ? 'none' : 'auto',
                opacity: !this.state.editData ? 0.8 : 1,
                filter: !this.state.editData ? 'grayscale(10%)' : 'none',
              }}
            ></div>
            <TextField
              id="observations"
              label={res.OBSERVACOES}
              disabled={!this.state.editData}
              style={{ width: '100%', marginTop: '1rem' }}
              value={this.state.observations}
              onChange={this.handleChange('observations')}
            />
            {this.state.isOnlyServiceOrder && (
              <div style={{ marginTop: '1rem' }}>
                {!this.state.isSigning && (
                  <Button onClick={this.startSigning} disabled={!this.state.editData} variant="contained" color="primary">
                    {res.ASSINAR_TECNICO}
                  </Button>
                )}

                <Dialog
                  open={this.state.isSigning}
                  onClose={this.handleCloseDialog}
                  aria-labelledby="signature-dialog"
                  maxWidth="sm"
                  fullWidth
                >
                  <DialogTitle id="signature-dialog" style={{ padding: 0 }}>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: '0.5rem 0',
                        backgroundColor: '#2D3238',
                      }}
                    >
                      <div />
                      <h3 style={{ margin: 0, color: 'white', whiteSpace: 'nowrap' }}>
                        {res.ASSINAR_TECNICO}
                      </h3>
                      <CloseIcon
                        onClick={this.handleCloseDialog}
                        style={{ cursor: 'pointer', width: '2rem', height: '2rem', color: 'white', marginRight: '0.5rem' }}
                      />
                    </div>
                  </DialogTitle>

                  <DialogContent
                    style={{ margin: 0, padding: '1rem', color: 'black', textAlign: 'center', backgroundColor: 'white' }}
                  >
                    <h3 style={{ margin: 0, whiteSpace: 'nowrap' }}>
                      {res.DESENHAR_ASSINATURA_TECNICO}
                    </h3>
                    <div style={{ border: '1px solid black', maxWidth: '18.75rem', margin: '0 auto' }}>
                      <SignaturePad
                        ref={this.signaturePadRef}
                        onEnd={this.handleSignatureEnd}
                        options={{ minWidth: 4, penColor: 'black' }}
                      />
                    </div>
                  </DialogContent>

                  <DialogActions style={{ backgroundColor: 'white' }}>
                    <Button onClick={this.clearSignature} color="secondary">
                      {res.CLEAR}
                    </Button>
                    <Button
                      onClick={this.saveSignature}
                      color="primary"
                      disabled={!this.state.hasSignature}
                    >
                      {res.SALVAR_ASSINATURA}
                    </Button>
                  </DialogActions>
                </Dialog>

                {this.state.responsibleTechnicianSignature && (
                  <div style={{ marginTop: '1rem' }}>
                    <img
                      src={this.state.responsibleTechnicianSignature}
                      alt={res.ASSINATURA}
                      style={{ border: '1px solid black' }}
                    />
                  </div>
                )}
              </div>
            )}

            <Dialog open={!!this.state.newProductModalOpen} onClose={this.closeNewProductModal} aria-labelledby="dlg-new-prod" fullWidth maxWidth="sm">
              <div style={{ background: '#fff', borderRadius: 8, overflow: 'hidden' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0.75rem 1rem', backgroundColor: '#2D3238' }}>
                  <div></div>
                  <h3 style={{ margin: 0, color: 'white', whiteSpace: 'nowrap' }}>{res.NOVO_PRODUTO}</h3>
                  <CloseIcon onClick={this.closeNewProductModal} style={{ cursor: 'pointer', width: '2rem', height: '2rem', color: 'white' }} />
                </div>
                <div style={{ padding: '1rem 2rem' }}>
                  <TextField autoFocus margin="dense" label={res.NOME} fullWidth value={this.state.newProductName || ''} onChange={this.onNewProductNameChange} />
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem', padding: '0 2rem 1rem' }}>
                  <Button onClick={this.closeNewProductModal} disabled={!!this.state.newProductSaving}>{res.CANCELAR}</Button>
                  <Button
                    onClick={this.saveNewProductCustom}
                    color="primary"
                    variant="contained"
                    disabled={!String(this.state.newProductName || '').trim() || !!this.state.newProductSaving}
                    startIcon={this.state.newProductSaving ? <CircularProgress size={16} /> : null}
                  >
                    {res.SALVAR}
                  </Button>
                </div>
              </div>
            </Dialog>
          </div>
        </div>
      </div >
    );
  }
}

Edit.propTypes = {
  classes: PropTypes.object.isRequired,
};

const TextFields1 = withStyles(styles)(Edit);

const Box = (props) => {
  const { link, res } = props;
  let { id } = useParams();
  return (
    <div className="rowForm">
      <div className="divContent">
        <TextFields1 link={link} id={id} res={res} />
      </div>
    </div>)
}

export default Box;
